//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class WorkerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkers(): Observable<GetWorkersResponse> {
        let url_ = this.baseUrl + "/api/v1/worker";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWorkersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWorkersResponse>;
        }));
    }

    protected processGetWorkers(response: HttpResponseBase): Observable<GetWorkersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWorkersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWorkersResponse>(null as any);
    }
}

@Injectable()
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getUserList(request: GetUserListRequest): Observable<GetUserListResponse> {
        let url_ = this.baseUrl + "/api/v1/user/GetUserList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserListResponse>;
        }));
    }

    protected processGetUserList(response: HttpResponseBase): Observable<GetUserListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserListResponse>(null as any);
    }

    upsertUser(request: UpsertUserRequest): Observable<UpsertUserResponse> {
        let url_ = this.baseUrl + "/api/v1/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertUserResponse>;
        }));
    }

    protected processUpsertUser(response: HttpResponseBase): Observable<UpsertUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertUserResponse>(null as any);
    }

    deleteUser(request: DeleteUserRequest): Observable<DeleteUserResponse> {
        let url_ = this.baseUrl + "/api/v1/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteUserResponse>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<DeleteUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteUserResponse>(null as any);
    }

    restoreUser(request: RestoreUserRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/user/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestoreUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    ping(payload?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/user/Ping?";
        if (payload === null)
            throw new Error("The parameter 'payload' cannot be null.");
        else if (payload !== undefined)
            url_ += "payload=" + encodeURIComponent("" + payload) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    savePassword(request: SavePasswordRequest): Observable<SavePasswordResponse> {
        let url_ = this.baseUrl + "/api/v1/user/SavePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavePasswordResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavePasswordResponse>;
        }));
    }

    protected processSavePassword(response: HttpResponseBase): Observable<SavePasswordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavePasswordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SavePasswordResponse>(null as any);
    }

    setUserDepartments(userId: string, departmentIds: string[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/user/user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(departmentIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserDepartments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserDepartments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSetUserDepartments(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable()
export class TaskClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createTask(request: CreateTaskRequest): Observable<CreateTaskResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTaskResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTaskResponse>;
        }));
    }

    protected processCreateTask(response: HttpResponseBase): Observable<CreateTaskResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTaskResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateTaskResponse>(null as any);
    }

    /**
     * @param jobNumber (optional) If set, response will only contain tasks with this jobnumber (jobnumbers are from Navision)
     * @param jobId (optional) If set, response will only contain tasks with this job ID (Job IDs are from Jutlighthouse DB)
     * @param taskNumber (optional) If set, response will only contain tasks with that begin with this string
     * @param customerName (optional) If set, response will ony contain tasks where the customer name contains this string
     * @param startDateFrom (optional) If set, response will ony contain tasks where start date is on or after this date. If null, filter is not used.
     * @param startDateTo (optional) If set, response will ony contain tasks where start date is on or before this date. If null, filter is not used.
     * @param taskStatuses (optional) If set, response will ony contain tasks with one of the listed statuses
     * @param responsibleWorkers (optional) If set, response will ony contain tasks where ResponsiblePerson is one of these workers. Must be a worker ID WorkerController
     * @param page (optional) 
     */
    getTaskList(jobNumber?: number | null | undefined, jobId?: string | null | undefined, taskNumber?: string | null | undefined, customerName?: string | null | undefined, startDateFrom?: Date | null | undefined, startDateTo?: Date | null | undefined, taskStatuses?: Status[] | null | undefined, responsibleWorkers?: string[] | null | undefined, page?: number | undefined): Observable<GetTaskListResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/task?";
        if (jobNumber !== undefined && jobNumber !== null)
            url_ += "JobNumber=" + encodeURIComponent("" + jobNumber) + "&";
        if (jobId !== undefined && jobId !== null)
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (taskNumber !== undefined && taskNumber !== null)
            url_ += "TaskNumber=" + encodeURIComponent("" + taskNumber) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (startDateFrom !== undefined && startDateFrom !== null)
            url_ += "StartDateFrom=" + encodeURIComponent(startDateFrom ? "" + startDateFrom.toISOString() : "") + "&";
        if (startDateTo !== undefined && startDateTo !== null)
            url_ += "StartDateTo=" + encodeURIComponent(startDateTo ? "" + startDateTo.toISOString() : "") + "&";
        if (taskStatuses !== undefined && taskStatuses !== null)
            taskStatuses && taskStatuses.forEach(item => { url_ += "TaskStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (responsibleWorkers !== undefined && responsibleWorkers !== null)
            responsibleWorkers && responsibleWorkers.forEach(item => { url_ += "ResponsibleWorkers=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskListResponse>;
        }));
    }

    protected processGetTaskList(response: HttpResponseBase): Observable<GetTaskListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTaskListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskListResponse>(null as any);
    }
}

@Injectable()
export class OperationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createOperation(request: CreateOperationRequest): Observable<CreateOperationResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOperationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOperationResponse>;
        }));
    }

    protected processCreateOperation(response: HttpResponseBase): Observable<CreateOperationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOperationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOperationResponse>(null as any);
    }

    /**
     * @param startDateFrom (optional) If set, response will ony contain operations where start date is on or after this date. If null, filter is not used.
     * @param startDateTo (optional) If set, response will ony contain operations where start date is on or before this date. If null, filter is not used.
     * @param statuses (optional) If set, response will ony contain operations with one of the listed statuses
     * @param page (optional) 
     */
    getOperationList(startDateFrom?: Date | null | undefined, startDateTo?: Date | null | undefined, statuses?: Status[] | null | undefined, page?: number | undefined): Observable<GetOperationListResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation?";
        if (startDateFrom !== undefined && startDateFrom !== null)
            url_ += "StartDateFrom=" + encodeURIComponent(startDateFrom ? "" + startDateFrom.toISOString() : "") + "&";
        if (startDateTo !== undefined && startDateTo !== null)
            url_ += "StartDateTo=" + encodeURIComponent(startDateTo ? "" + startDateTo.toISOString() : "") + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOperationListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOperationListResponse>;
        }));
    }

    protected processGetOperationList(response: HttpResponseBase): Observable<GetOperationListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOperationListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOperationListResponse>(null as any);
    }

    getOperation(id: string): Observable<TerminalOperation> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalOperation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalOperation>;
        }));
    }

    protected processGetOperation(response: HttpResponseBase): Observable<TerminalOperation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminalOperation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TerminalOperation>(null as any);
    }

    updateOperation(id: string, operation: TerminalOperation): Observable<TerminalOperation> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalOperation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalOperation>;
        }));
    }

    protected processUpdateOperation(response: HttpResponseBase): Observable<TerminalOperation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminalOperation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TerminalOperation>(null as any);
    }

    deleteOperation(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteOperation(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    rejectOperation(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectOperation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectOperation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRejectOperation(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    setOperationStatusTo(id: string, request: SetOperationStatusRequest): Observable<TerminalOperation> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{id}/status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOperationStatusTo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOperationStatusTo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalOperation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalOperation>;
        }));
    }

    protected processSetOperationStatusTo(response: HttpResponseBase): Observable<TerminalOperation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminalOperation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TerminalOperation>(null as any);
    }

    updateOperationsVehiclesList(id: string, involvedVehicles: string[]): Observable<TerminalOperation> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{id}/vehicles";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(involvedVehicles);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOperationsVehiclesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOperationsVehiclesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalOperation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalOperation>;
        }));
    }

    protected processUpdateOperationsVehiclesList(response: HttpResponseBase): Observable<TerminalOperation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminalOperation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TerminalOperation>(null as any);
    }
}

@Injectable()
export class OperationFileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Uploads a file and attaches it to a specific Terminal Operation.
    Use GetOperationFiles to see the list of files attached to an operation.
    Use FileController.GetAttachment(fileId) to get the actual contents of a file
     * @param originalFilename (optional) 
     * @param file (optional) 
     */
    uploadFile(operationId: string, originalFilename?: string | undefined, file?: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{operationId}/attachments";
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "X-original-file-name": originalFilename !== undefined && originalFilename !== null ? "" + originalFilename : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getOperationFiles(operationId: string): Observable<GetOperationFilesResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{operationId}/attachments";
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperationFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperationFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOperationFilesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOperationFilesResponse>;
        }));
    }

    protected processGetOperationFiles(response: HttpResponseBase): Observable<GetOperationFilesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOperationFilesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOperationFilesResponse>(null as any);
    }

    deleteOperationFile(operationId: string, fileId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{operationId}/attachments/{fileId}";
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOperationFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOperationFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOperationFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    downloadOperationFile(operationId: string, fileId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{operationId}/attachments/{fileId}";
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOperationFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOperationFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOperationFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable()
export class OperationCommentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getComments(operationId: string): Observable<OperationComment[]> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{operationId}/comment";
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationComment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationComment[]>;
        }));
    }

    protected processGetComments(response: HttpResponseBase): Observable<OperationComment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OperationComment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperationComment[]>(null as any);
    }

    createComment(operationId: string, request: CreateOperationCommentRequest): Observable<OperationComment> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{operationId}/comment";
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationComment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationComment>;
        }));
    }

    protected processCreateComment(response: HttpResponseBase): Observable<OperationComment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationComment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperationComment>(null as any);
    }

    updateComment(operationId: string, commentId: string, request: UpdateOperationCommentRequest): Observable<OperationComment> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{operationId}/comment/{commentId}";
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperationComment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperationComment>;
        }));
    }

    protected processUpdateComment(response: HttpResponseBase): Observable<OperationComment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperationComment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperationComment>(null as any);
    }

    markCommentsAsRead(operationId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{operationId}/comment/mark-read";
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkCommentsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkCommentsAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMarkCommentsAsRead(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    hasUnreadComments(operationId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/terminal/task/operation/{operationId}/comment/has-unread";
        if (operationId === undefined || operationId === null)
            throw new Error("The parameter 'operationId' must be defined.");
        url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasUnreadComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasUnreadComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasUnreadComments(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class LocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getLocation(): Observable<GetLocationListResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/location";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationListResponse>;
        }));
    }

    protected processGetLocation(response: HttpResponseBase): Observable<GetLocationListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationListResponse>(null as any);
    }
}

@Injectable()
export class JobClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createJob(request: CreateJobRequest): Observable<CreateJobResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/job";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateJobResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateJobResponse>;
        }));
    }

    protected processCreateJob(response: HttpResponseBase): Observable<CreateJobResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateJobResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateJobResponse>(null as any);
    }

    /**
     * @param search (optional) If set, only jobs containing the search string in their names are returned.
     * @param customerId (optional) If set, only jobs for this customer are displayed. Must be a CustomerId, see CustomerController
     * @param responsibleDepartment (optional) 
     * @param status (optional) 
     */
    getJobList(search?: string | null | undefined, customerId?: string | null | undefined, responsibleDepartment?: string | null | undefined, status?: JobStatus[] | null | undefined): Observable<GetJobListResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/job?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (responsibleDepartment !== undefined && responsibleDepartment !== null)
            url_ += "ResponsibleDepartment=" + encodeURIComponent("" + responsibleDepartment) + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetJobListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetJobListResponse>;
        }));
    }

    protected processGetJobList(response: HttpResponseBase): Observable<GetJobListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJobListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetJobListResponse>(null as any);
    }

    updateJob(id: string, req: UpdateJobRequest): Observable<UpdateJobResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/job/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateJobResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateJobResponse>;
        }));
    }

    protected processUpdateJob(response: HttpResponseBase): Observable<UpdateJobResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateJobResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateJobResponse>(null as any);
    }
}

@Injectable()
export class InfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createInfo(request: CreateInfoRequest): Observable<CreateInfoResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateInfoResponse>;
        }));
    }

    protected processCreateInfo(response: HttpResponseBase): Observable<CreateInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateInfoResponse>(null as any);
    }

    getAllInfo(dateUtc?: string | undefined, page?: number | undefined): Observable<GetInfoListResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/info?";
        if (dateUtc === null)
            throw new Error("The parameter 'dateUtc' cannot be null.");
        else if (dateUtc !== undefined)
            url_ += "DateUtc=" + encodeURIComponent("" + dateUtc) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInfoListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInfoListResponse>;
        }));
    }

    protected processGetAllInfo(response: HttpResponseBase): Observable<GetInfoListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInfoListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetInfoListResponse>(null as any);
    }

    updateInfo(id: string, request: UpdateInfoRequest): Observable<TerminalInfo> {
        let url_ = this.baseUrl + "/api/v1/terminal/info/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalInfo>;
        }));
    }

    protected processUpdateInfo(response: HttpResponseBase): Observable<TerminalInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminalInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TerminalInfo>(null as any);
    }

    deleteInfo(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/terminal/info/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeleteInfo(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable()
export class TerminalStatementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getTerminalStatements(): Observable<GetTerminalStatementsResponse> {
        let url_ = this.baseUrl + "/api/v1/terminalstatement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTerminalStatements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTerminalStatements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTerminalStatementsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTerminalStatementsResponse>;
        }));
    }

    protected processGetTerminalStatements(response: HttpResponseBase): Observable<GetTerminalStatementsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTerminalStatementsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTerminalStatementsResponse>(null as any);
    }
}

@Injectable()
export class TabletAppSettingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getTabletAppSettings(): Observable<TabletAppSettingResponse> {
        let url_ = this.baseUrl + "/api/v1/tablet-app-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTabletAppSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTabletAppSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TabletAppSettingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TabletAppSettingResponse>;
        }));
    }

    protected processGetTabletAppSettings(response: HttpResponseBase): Observable<TabletAppSettingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TabletAppSettingResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TabletAppSettingResponse>(null as any);
    }

    setTabletAppSetting(request: SetTabletAppSettingRequest): Observable<TabletAppSettingResponse> {
        let url_ = this.baseUrl + "/api/v1/tablet-app-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTabletAppSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTabletAppSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TabletAppSettingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TabletAppSettingResponse>;
        }));
    }

    protected processSetTabletAppSetting(response: HttpResponseBase): Observable<TabletAppSettingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TabletAppSettingResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TabletAppSettingResponse>(null as any);
    }

    hashPassword(password?: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/tablet-app-settings/pw?";
        if (password === null)
            throw new Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHashPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHashPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processHashPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class StorageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getStorageItemList(request: GetStorageItemListRequest): Observable<GetStorageItemListResponse> {
        let url_ = this.baseUrl + "/api/v1/storage/getstorageitemlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageItemList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageItemList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStorageItemListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStorageItemListResponse>;
        }));
    }

    protected processGetStorageItemList(response: HttpResponseBase): Observable<GetStorageItemListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStorageItemListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStorageItemListResponse>(null as any);
    }

    getStorageItem(id: string): Observable<GetStorageItemResponse> {
        let url_ = this.baseUrl + "/api/v1/storage/getstorageitem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStorageItemResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStorageItemResponse>;
        }));
    }

    protected processGetStorageItem(response: HttpResponseBase): Observable<GetStorageItemResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStorageItemResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStorageItemResponse>(null as any);
    }

    getStorageItemMovementList(request: GetStorageItemMovementListRequest, id: string): Observable<GetStorageItemMovementListResponse> {
        let url_ = this.baseUrl + "/api/v1/storage/getstorageitem/{id}/movements";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageItemMovementList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageItemMovementList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStorageItemMovementListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStorageItemMovementListResponse>;
        }));
    }

    protected processGetStorageItemMovementList(response: HttpResponseBase): Observable<GetStorageItemMovementListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStorageItemMovementListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStorageItemMovementListResponse>(null as any);
    }

    getStorageItemMovementQuantityList(id: string, year: number): Observable<GetStorageItemMovementQuantityListResponse> {
        let url_ = this.baseUrl + "/api/v1/storage/getstorageitem/{id}/movements/quantity/{year}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageItemMovementQuantityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageItemMovementQuantityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStorageItemMovementQuantityListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStorageItemMovementQuantityListResponse>;
        }));
    }

    protected processGetStorageItemMovementQuantityList(response: HttpResponseBase): Observable<GetStorageItemMovementQuantityListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStorageItemMovementQuantityListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStorageItemMovementQuantityListResponse>(null as any);
    }

    getStorageItemBinList(request: GetStorageItemBinListRequest, id: string): Observable<GetStorageItemBinListResponse> {
        let url_ = this.baseUrl + "/api/v1/storage/getstorageitem/{id}/bins";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageItemBinList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageItemBinList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStorageItemBinListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStorageItemBinListResponse>;
        }));
    }

    protected processGetStorageItemBinList(response: HttpResponseBase): Observable<GetStorageItemBinListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStorageItemBinListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStorageItemBinListResponse>(null as any);
    }

    getStorageTankList(request: GetStorageTankListRequest, id: string): Observable<GetStorageTankListResponse> {
        let url_ = this.baseUrl + "/api/v1/storage/getstorageitem/{id}/tanks";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageTankList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageTankList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStorageTankListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStorageTankListResponse>;
        }));
    }

    protected processGetStorageTankList(response: HttpResponseBase): Observable<GetStorageTankListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStorageTankListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStorageTankListResponse>(null as any);
    }

    getStorageTankFiles(id: string, tankid: string): Observable<GetStorageTankFilesResponse> {
        let url_ = this.baseUrl + "/api/v1/storage/getstorageitem/{id}/tanks/{tankid}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tankid === undefined || tankid === null)
            throw new Error("The parameter 'tankid' must be defined.");
        url_ = url_.replace("{tankid}", encodeURIComponent("" + tankid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageTankFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageTankFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStorageTankFilesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStorageTankFilesResponse>;
        }));
    }

    protected processGetStorageTankFiles(response: HttpResponseBase): Observable<GetStorageTankFilesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStorageTankFilesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStorageTankFilesResponse>(null as any);
    }

    getStorageTankFile(id: string, tankid: string, filename: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/storage/getstorageitem/{id}/tanks/{tankid}/download/{filename}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tankid === undefined || tankid === null)
            throw new Error("The parameter 'tankid' must be defined.");
        url_ = url_.replace("{tankid}", encodeURIComponent("" + tankid));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageTankFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageTankFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetStorageTankFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStorageItemAccumulatedQuantityList(id: string, year: number): Observable<GetStorageItemMovementAccumulatedQuantityListResponse> {
        let url_ = this.baseUrl + "/api/v1/storage/getstorageitem/{id}/movements/accumulatedquantity/{year}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageItemAccumulatedQuantityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageItemAccumulatedQuantityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStorageItemMovementAccumulatedQuantityListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStorageItemMovementAccumulatedQuantityListResponse>;
        }));
    }

    protected processGetStorageItemAccumulatedQuantityList(response: HttpResponseBase): Observable<GetStorageItemMovementAccumulatedQuantityListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStorageItemMovementAccumulatedQuantityListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStorageItemMovementAccumulatedQuantityListResponse>(null as any);
    }

    exportStorageItems(keyword?: string | null | undefined, withMovements?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/storage/exportstorageitems?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (withMovements === null)
            throw new Error("The parameter 'withMovements' cannot be null.");
        else if (withMovements !== undefined)
            url_ += "withMovements=" + encodeURIComponent("" + withMovements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportStorageItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportStorageItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportStorageItems(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable()
export class StevedoreForemanClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getStevedoreForemanList(searchString?: string | null | undefined, maxResults?: number | null | undefined): Observable<StevedoreForemanListResponse> {
        let url_ = this.baseUrl + "/api/v1/stevedoreForeman?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (maxResults !== undefined && maxResults !== null)
            url_ += "MaxResults=" + encodeURIComponent("" + maxResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStevedoreForemanList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStevedoreForemanList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StevedoreForemanListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StevedoreForemanListResponse>;
        }));
    }

    protected processGetStevedoreForemanList(response: HttpResponseBase): Observable<StevedoreForemanListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StevedoreForemanListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StevedoreForemanListResponse>(null as any);
    }

    upsertStevedoreForeman(foreman: StevedoreForeman): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/stevedoreForeman";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(foreman);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertStevedoreForeman(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertStevedoreForeman(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertStevedoreForeman(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteStevedoreForeman(request: DeleteStevedoreForemanRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/stevedoreForeman";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStevedoreForeman(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStevedoreForeman(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteStevedoreForeman(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ResourceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get list of all Resource Group Numbers
     */
    getReourceGroups(): Observable<GetResourceGroupResponse> {
        let url_ = this.baseUrl + "/api/v1/resource/getreourcegroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReourceGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReourceGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetResourceGroupResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetResourceGroupResponse>;
        }));
    }

    protected processGetReourceGroups(response: HttpResponseBase): Observable<GetResourceGroupResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetResourceGroupResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetResourceGroupResponse>(null as any);
    }

    /**
     * Get list of Resources by filtering
     */
    getResourceList(request: GetResourceRequest): Observable<GetResourceListResponse> {
        let url_ = this.baseUrl + "/api/v1/resource/getresources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResourceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResourceList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetResourceListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetResourceListResponse>;
        }));
    }

    protected processGetResourceList(response: HttpResponseBase): Observable<GetResourceListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetResourceListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetResourceListResponse>(null as any);
    }
}

@Injectable()
export class ProjectQuestionnaireClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    upsertProjectQuestionnaire(request: UpsertProjectQuestionnaireRequest): Observable<UpsertProjectQuestionnaireResponse> {
        let url_ = this.baseUrl + "/api/v1/questionnaire/Questionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertProjectQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertProjectQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertProjectQuestionnaireResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertProjectQuestionnaireResponse>;
        }));
    }

    protected processUpsertProjectQuestionnaire(response: HttpResponseBase): Observable<UpsertProjectQuestionnaireResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertProjectQuestionnaireResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertProjectQuestionnaireResponse>(null as any);
    }

    upsertQnaSet(request: UpsertQuestionAnswerSetRequest): Observable<UpsertQuestionAnswerSetResponse> {
        let url_ = this.baseUrl + "/api/v1/questionnaire/QnaSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertQnaSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertQnaSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertQuestionAnswerSetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertQuestionAnswerSetResponse>;
        }));
    }

    protected processUpsertQnaSet(response: HttpResponseBase): Observable<UpsertQuestionAnswerSetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertQuestionAnswerSetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertQuestionAnswerSetResponse>(null as any);
    }

    getQuestionnaire(qid?: string | undefined): Observable<UpsertProjectQuestionnaireRequest> {
        let url_ = this.baseUrl + "/api/v1/questionnaire/getquestionnaire?";
        if (qid === null)
            throw new Error("The parameter 'qid' cannot be null.");
        else if (qid !== undefined)
            url_ += "qid=" + encodeURIComponent("" + qid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertProjectQuestionnaireRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertProjectQuestionnaireRequest>;
        }));
    }

    protected processGetQuestionnaire(response: HttpResponseBase): Observable<UpsertProjectQuestionnaireRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertProjectQuestionnaireRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertProjectQuestionnaireRequest>(null as any);
    }
}

@Injectable()
export class ProjectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets a list of projects. If user is of type Customer, only projects for the user's customer is returned
     * @param before (optional) If set, gets only projects with ExpectedDeparture before this date
     * @param after (optional) If set, gets only projects with ExpectedDeparture after this date
     * @param customerId (optional) If set, gets only projects with for this customer
     * @param searchTerm (optional) If set, gets only projects containing this string in its name
     * @param offset (optional) If set, skips the first N projects
     * @param maxResults (optional) 
     * @param ordering (optional) 
     * @param descending (optional) 
     * @param statuses (optional) 
     * @param isProjectTemplate (optional) 
     */
    getProjects(before?: Date | null | undefined, after?: Date | null | undefined, customerId?: string | null | undefined, searchTerm?: string | null | undefined, offset?: number | undefined, maxResults?: number | undefined, ordering?: ProjectOrdering | undefined, descending?: boolean | undefined, statuses?: ProjectStatus[] | null | undefined, isProjectTemplate?: boolean | null | undefined): Observable<GetProjectListResponse> {
        let url_ = this.baseUrl + "/api/v1/project?";
        if (before !== undefined && before !== null)
            url_ += "Before=" + encodeURIComponent(before ? "" + before.toISOString() : "") + "&";
        if (after !== undefined && after !== null)
            url_ += "After=" + encodeURIComponent(after ? "" + after.toISOString() : "") + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (maxResults === null)
            throw new Error("The parameter 'maxResults' cannot be null.");
        else if (maxResults !== undefined)
            url_ += "MaxResults=" + encodeURIComponent("" + maxResults) + "&";
        if (ordering === null)
            throw new Error("The parameter 'ordering' cannot be null.");
        else if (ordering !== undefined)
            url_ += "Ordering=" + encodeURIComponent("" + ordering) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (isProjectTemplate !== undefined && isProjectTemplate !== null)
            url_ += "IsProjectTemplate=" + encodeURIComponent("" + isProjectTemplate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectListResponse>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<GetProjectListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectListResponse>(null as any);
    }

    upsertProject(request: UpsertProjectRequest): Observable<UpsertProjectResponse> {
        let url_ = this.baseUrl + "/api/v1/project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertProjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertProjectResponse>;
        }));
    }

    protected processUpsertProject(response: HttpResponseBase): Observable<UpsertProjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertProjectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertProjectResponse>(null as any);
    }

    editInternalNote(request: EditInternalNoteRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/project/InternalNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditInternalNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditInternalNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditInternalNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getProjectDetails(projectId: string): Observable<GetProjectDetailsResponse> {
        let url_ = this.baseUrl + "/api/v1/project/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectDetailsResponse>;
        }));
    }

    protected processGetProjectDetails(response: HttpResponseBase): Observable<GetProjectDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectDetailsResponse>(null as any);
    }

    deleteProject(projectId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/project/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteProject(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getTemplateProjects(): Observable<GetProjectListResponse> {
        let url_ = this.baseUrl + "/api/v1/project/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectListResponse>;
        }));
    }

    protected processGetTemplateProjects(response: HttpResponseBase): Observable<GetProjectListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectListResponse>(null as any);
    }

    upsertTemplate(request: UpsertProjectRequest): Observable<UpsertProjectResponse> {
        let url_ = this.baseUrl + "/api/v1/project/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertProjectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertProjectResponse>;
        }));
    }

    protected processUpsertTemplate(response: HttpResponseBase): Observable<UpsertProjectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertProjectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertProjectResponse>(null as any);
    }

    getProjectTemplateDetails(projectId: string): Observable<GetProjectDetailsResponse> {
        let url_ = this.baseUrl + "/api/v1/project/templates/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTemplateDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTemplateDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectDetailsResponse>;
        }));
    }

    protected processGetProjectTemplateDetails(response: HttpResponseBase): Observable<GetProjectDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectDetailsResponse>(null as any);
    }
}

@Injectable()
export class ProjectReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getTemplates(): Observable<GetProjectTemplatesResponse> {
        let url_ = this.baseUrl + "/api/v1/projectTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectTemplatesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectTemplatesResponse>;
        }));
    }

    protected processGetTemplates(response: HttpResponseBase): Observable<GetProjectTemplatesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectTemplatesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectTemplatesResponse>(null as any);
    }

    getReport(projectId: string, templateId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/projectTemplate/{projectId}/{templateId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable()
export class ShipReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getShipReportPdfAnon(projectId: string, questionaireId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/shipReport/{projectId}/{questionaireId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (questionaireId === undefined || questionaireId === null)
            throw new Error("The parameter 'questionaireId' must be defined.");
        url_ = url_.replace("{questionaireId}", encodeURIComponent("" + questionaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipReportPdfAnon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipReportPdfAnon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetShipReportPdfAnon(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getShipReportPdf(projectId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/shipReport/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipReportPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipReportPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetShipReportPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable()
export class ProjectOccurenceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    upsertProjectOccurence(request: UpsertProjectOccurenceRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/projectOccurence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertProjectOccurence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertProjectOccurence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertProjectOccurence(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProjectMemberClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getProjectMemberList(searchString?: string | null | undefined, maxResults?: number | null | undefined): Observable<ProjectMemberListResponse> {
        let url_ = this.baseUrl + "/api/v1/projectMember?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (maxResults !== undefined && maxResults !== null)
            url_ += "MaxResults=" + encodeURIComponent("" + maxResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectMemberList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectMemberList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectMemberListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectMemberListResponse>;
        }));
    }

    protected processGetProjectMemberList(response: HttpResponseBase): Observable<ProjectMemberListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectMemberListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectMemberListResponse>(null as any);
    }

    upsertProjectmember(member: ProjectMember): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/projectMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(member);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertProjectmember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertProjectmember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertProjectmember(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteProjectMember(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/projectMember/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProjectMember(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProjectFileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    uploadFile(projectId: string, originalFilename?: string | undefined, file?: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/project/{projectId}/attachments";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "X-original-file-name": originalFilename !== undefined && originalFilename !== null ? "" + originalFilename : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getProjectFiles(projectId: string): Observable<GetProjectFilesResponse> {
        let url_ = this.baseUrl + "/api/v1/project/{projectId}/attachments";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectFilesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectFilesResponse>;
        }));
    }

    protected processGetProjectFiles(response: HttpResponseBase): Observable<GetProjectFilesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectFilesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectFilesResponse>(null as any);
    }

    uploadDocument(projectId: string, orginalDocumentName?: string | undefined, file?: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/project/{projectId}/attachments1";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "X-original-document-name": orginalDocumentName !== undefined && orginalDocumentName !== null ? "" + orginalDocumentName : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getProjectDocuments(projectId: string): Observable<GetProjectDocumentsResponse> {
        let url_ = this.baseUrl + "/api/v1/project/{projectId}/attachments1";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectDocumentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectDocumentsResponse>;
        }));
    }

    protected processGetProjectDocuments(response: HttpResponseBase): Observable<GetProjectDocumentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectDocumentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectDocumentsResponse>(null as any);
    }

    updateDocumentShared(projectId: string, fileId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/project/{projectId}/attatchments1/{fileId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentShared(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentShared(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDocumentShared(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    downloadProjectDocument(projectId: string, fileId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/project/{projectId}/attatchments1/{fileId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProjectDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProjectDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadProjectDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadProjectFile(projectId: string, fileId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/project/{projectId}/attachments/{fileId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProjectFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProjectFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadProjectFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    deleteProjectFile(projectId: string, fileId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/project/{projectId}/{fileId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProjectFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProjectFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    sendmail(projectId?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/project/SendDocuments?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProjectEventTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getProjectEventTypes(projectId?: string | undefined): Observable<GetProjectEventTypesResponse> {
        let url_ = this.baseUrl + "/api/v1/projectEventType?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectEventTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectEventTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectEventTypesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectEventTypesResponse>;
        }));
    }

    protected processGetProjectEventTypes(response: HttpResponseBase): Observable<GetProjectEventTypesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectEventTypesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectEventTypesResponse>(null as any);
    }

    /**
     * Sets the available event types on a project. Removes all other event types.
     */
    setProjectEventTypes(request: SetProjectEventTypesRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/projectEventType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProjectEventTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProjectEventTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetProjectEventTypes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProjectCommentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    upsertComment(request: UpsertProjectCommentRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/comment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    uploadFile(commentId: string, originalFilename?: string | undefined, mimeType?: string | undefined, file?: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/comment/{commentId}/attachments";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "X-original-file-name": originalFilename !== undefined && originalFilename !== null ? "" + originalFilename : "",
                "X-mime-type": mimeType !== undefined && mimeType !== null ? "" + mimeType : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getCommentFiles(commentId?: string | undefined): Observable<ProjectCommentFileDto[]> {
        let url_ = this.baseUrl + "/api/v1/comment/commentFile?";
        if (commentId === null)
            throw new Error("The parameter 'commentId' cannot be null.");
        else if (commentId !== undefined)
            url_ += "commentId=" + encodeURIComponent("" + commentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectCommentFileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectCommentFileDto[]>;
        }));
    }

    protected processGetCommentFiles(response: HttpResponseBase): Observable<ProjectCommentFileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectCommentFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectCommentFileDto[]>(null as any);
    }

    downloadCommentFile(fileId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/comment/commentFile/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCommentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCommentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadCommentFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getProjectComments(projectId: string): Observable<GetProjectCommentsResponse> {
        let url_ = this.baseUrl + "/api/v1/comment/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectCommentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectCommentsResponse>;
        }));
    }

    protected processGetProjectComments(response: HttpResponseBase): Observable<GetProjectCommentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectCommentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectCommentsResponse>(null as any);
    }
}

@Injectable()
export class ProjectCo2Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    upsertProjectCo2(request: UpsertProjectCo2Request): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/projectco2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertProjectCo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertProjectCo2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertProjectCo2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    get(): Observable<ProjectCo2Response> {
        let url_ = this.baseUrl + "/api/v1/projectco2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectCo2Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectCo2Response>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProjectCo2Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectCo2Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectCo2Response>(null as any);
    }
}

@Injectable()
export class OccurenceTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    upsertOccurenceType(request: UpsertOccurenceTypeRequest): Observable<UpsertOccurenceTypeResponse> {
        let url_ = this.baseUrl + "/api/v1/occurenceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertOccurenceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertOccurenceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertOccurenceTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertOccurenceTypeResponse>;
        }));
    }

    protected processUpsertOccurenceType(response: HttpResponseBase): Observable<UpsertOccurenceTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertOccurenceTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertOccurenceTypeResponse>(null as any);
    }

    getOccurenceTypes(): Observable<GetOccurenceTypeResponse> {
        let url_ = this.baseUrl + "/api/v1/occurenceType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOccurenceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOccurenceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOccurenceTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOccurenceTypeResponse>;
        }));
    }

    protected processGetOccurenceTypes(response: HttpResponseBase): Observable<GetOccurenceTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOccurenceTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOccurenceTypeResponse>(null as any);
    }

    deleteOccurenceType(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/occurenceType/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOccurenceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOccurenceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOccurenceType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class MailLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMailLog(projectId?: string | undefined): Observable<GetMailLogResponse> {
        let url_ = this.baseUrl + "/api/v1/mailLog/GetMailLog?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMailLogResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMailLogResponse>;
        }));
    }

    protected processGetMailLog(response: HttpResponseBase): Observable<GetMailLogResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMailLogResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMailLogResponse>(null as any);
    }
}

@Injectable()
export class MailingListClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    upsertMailingList(request: UpsertMailingListRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/mailingList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertMailingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertMailingList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertMailingList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getMailReceiver(receiverId?: string | undefined): Observable<MailReceiverResponse> {
        let url_ = this.baseUrl + "/api/v1/mailingList/MailReceiverById?";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "ReceiverId=" + encodeURIComponent("" + receiverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailReceiver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailReceiver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailReceiverResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailReceiverResponse>;
        }));
    }

    protected processGetMailReceiver(response: HttpResponseBase): Observable<MailReceiverResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailReceiverResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MailReceiverResponse>(null as any);
    }

    getMailingList(id: string): Observable<GetMailingListResponse> {
        let url_ = this.baseUrl + "/api/v1/mailingList/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailingList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMailingListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMailingListResponse>;
        }));
    }

    protected processGetMailingList(response: HttpResponseBase): Observable<GetMailingListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMailingListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMailingListResponse>(null as any);
    }

    unsubscribe(mailReceiverId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/mailingList/unsubscribe/{mailReceiverId}";
        if (mailReceiverId === undefined || mailReceiverId === null)
            throw new Error("The parameter 'mailReceiverId' must be defined.");
        url_ = url_.replace("{mailReceiverId}", encodeURIComponent("" + mailReceiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnsubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnsubscribe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    unsubscribeDailyStatus(mailReceiverId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/mailingList/unsub/daily/{mailReceiverId}";
        if (mailReceiverId === undefined || mailReceiverId === null)
            throw new Error("The parameter 'mailReceiverId' must be defined.");
        url_ = url_.replace("{mailReceiverId}", encodeURIComponent("" + mailReceiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnsubscribeDailyStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsubscribeDailyStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnsubscribeDailyStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class LoginClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gives you a loginToken, allowing you to use protected endpoints
     */
    login(request: LoginRequest): Observable<LoginResponse> {
        let url_ = this.baseUrl + "/api/v1/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResponse>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponse>(null as any);
    }

    /**
     * Returns your UserId
     */
    whoami(): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/login/whoami";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWhoami(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWhoami(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processWhoami(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * Renews the current login token. You must have an existing, valid token.
     */
    renew(): Observable<LoginResponse> {
        let url_ = this.baseUrl + "/api/v1/login/renew";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResponse>;
        }));
    }

    protected processRenew(response: HttpResponseBase): Observable<LoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginResponse>(null as any);
    }

    loginWithLink(linkId: string): Observable<LinkLoginResponse> {
        let url_ = this.baseUrl + "/api/v1/login/link/{linkId}";
        if (linkId === undefined || linkId === null)
            throw new Error("The parameter 'linkId' must be defined.");
        url_ = url_.replace("{linkId}", encodeURIComponent("" + linkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginWithLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginWithLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkLoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkLoginResponse>;
        }));
    }

    protected processLoginWithLink(response: HttpResponseBase): Observable<LinkLoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LinkLoginResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LinkLoginResponse>(null as any);
    }

    createProjectLink(projectId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/login/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateProjectLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    passwordReset(request: PasswordResetRequest): Observable<PasswordResetResponse> {
        let url_ = this.baseUrl + "/api/v1/login/passwordreset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPasswordReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PasswordResetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PasswordResetResponse>;
        }));
    }

    protected processPasswordReset(response: HttpResponseBase): Observable<PasswordResetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PasswordResetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PasswordResetResponse>(null as any);
    }
}

@Injectable()
export class GangClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    upsertGang(request: UpsertGangRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/gang";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertGang(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertGang(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertGang(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class FileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAttachment(fileId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/file/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable()
export class EventClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    upsertEvent(request: UpsertEventRequest): Observable<UpsertEventResponse> {
        let url_ = this.baseUrl + "/api/v1/event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertEventResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertEventResponse>;
        }));
    }

    protected processUpsertEvent(response: HttpResponseBase): Observable<UpsertEventResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertEventResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertEventResponse>(null as any);
    }

    deleteEvent(eventId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/event/{eventId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class EventTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    upsertEventType(request: UpsertEventTypeRequest): Observable<UpsertEventTypeResponse> {
        let url_ = this.baseUrl + "/api/v1/eventType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertEventType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertEventType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertEventTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertEventTypeResponse>;
        }));
    }

    protected processUpsertEventType(response: HttpResponseBase): Observable<UpsertEventTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertEventTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertEventTypeResponse>(null as any);
    }

    getEventTypes(): Observable<GetEventTypesResponse> {
        let url_ = this.baseUrl + "/api/v1/eventType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEventTypesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEventTypesResponse>;
        }));
    }

    protected processGetEventTypes(response: HttpResponseBase): Observable<GetEventTypesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEventTypesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventTypesResponse>(null as any);
    }

    deleteEventType(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/eventType/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEventType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEventType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEventType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ESGClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    upsertESG(request: UpsertESGRequest): Observable<UpsertESGResponse> {
        let url_ = this.baseUrl + "/api/v1/esg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertESG(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertESG(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertESGResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertESGResponse>;
        }));
    }

    protected processUpsertESG(response: HttpResponseBase): Observable<UpsertESGResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertESGResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertESGResponse>(null as any);
    }

    getESGList(request: GetESGListRequest): Observable<GetESGListResponse> {
        let url_ = this.baseUrl + "/api/v1/esg/getesglist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetESGList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetESGList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetESGListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetESGListResponse>;
        }));
    }

    protected processGetESGList(response: HttpResponseBase): Observable<GetESGListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetESGListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetESGListResponse>(null as any);
    }

    getESG(id: string): Observable<GetESGResponse> {
        let url_ = this.baseUrl + "/api/v1/esg/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetESG(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetESG(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetESGResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetESGResponse>;
        }));
    }

    protected processGetESG(response: HttpResponseBase): Observable<GetESGResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetESGResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetESGResponse>(null as any);
    }

    delete(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/esg/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getESGMatrix(): Observable<GetESGMatrixResponse> {
        let url_ = this.baseUrl + "/api/v1/esg/matrix";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetESGMatrix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetESGMatrix(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetESGMatrixResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetESGMatrixResponse>;
        }));
    }

    protected processGetESGMatrix(response: HttpResponseBase): Observable<GetESGMatrixResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetESGMatrixResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetESGMatrixResponse>(null as any);
    }

    getESGChart(): Observable<GetESGChartResponse> {
        let url_ = this.baseUrl + "/api/v1/esg/chart";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetESGChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetESGChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetESGChartResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetESGChartResponse>;
        }));
    }

    protected processGetESGChart(response: HttpResponseBase): Observable<GetESGChartResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetESGChartResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetESGChartResponse>(null as any);
    }
}

@Injectable()
export class DepartmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDepartmentList(id?: string | null | undefined): Observable<GetDepartmentListResponse> {
        let url_ = this.baseUrl + "/api/v1/department?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDepartmentListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDepartmentListResponse>;
        }));
    }

    protected processGetDepartmentList(response: HttpResponseBase): Observable<GetDepartmentListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDepartmentListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDepartmentListResponse>(null as any);
    }

    createDepartment(request: CreateDepartmentRequest): Observable<CreateDepartmentResponse> {
        let url_ = this.baseUrl + "/api/v1/department";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateDepartmentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateDepartmentResponse>;
        }));
    }

    protected processCreateDepartment(response: HttpResponseBase): Observable<CreateDepartmentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateDepartmentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateDepartmentResponse>(null as any);
    }

    getAllDepartments(): Observable<GetDepartmentListResponse> {
        let url_ = this.baseUrl + "/api/v1/department/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDepartments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDepartments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDepartmentListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDepartmentListResponse>;
        }));
    }

    protected processGetAllDepartments(response: HttpResponseBase): Observable<GetDepartmentListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDepartmentListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDepartmentListResponse>(null as any);
    }

    getDepartmentsForUser(userId: string): Observable<GetDepartmentListResponse> {
        let url_ = this.baseUrl + "/api/v1/department/user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDepartmentListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDepartmentListResponse>;
        }));
    }

    protected processGetDepartmentsForUser(response: HttpResponseBase): Observable<GetDepartmentListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDepartmentListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDepartmentListResponse>(null as any);
    }
}

@Injectable()
export class CustomerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param search (optional) If set, only customers wuth the search string in their name are returned.
     */
    getCustomerList(search?: string | null | undefined): Observable<GetCustomerListResponse> {
        let url_ = this.baseUrl + "/api/v1/customer?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerListResponse>;
        }));
    }

    protected processGetCustomerList(response: HttpResponseBase): Observable<GetCustomerListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomerListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerListResponse>(null as any);
    }

    /**
     * @deprecated
     */
    upsertCustomer(request: UpsertCustomerRequest): Observable<UpsertCustomerResponse> {
        let url_ = this.baseUrl + "/api/v1/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertCustomerResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertCustomerResponse>;
        }));
    }

    protected processUpsertCustomer(response: HttpResponseBase): Observable<UpsertCustomerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertCustomerResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertCustomerResponse>(null as any);
    }

    /**
     * @deprecated
     */
    deleteCustomer(request: DeleteCustomerRequest): Observable<DeleteCustomerResponse> {
        let url_ = this.baseUrl + "/api/v1/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteCustomerResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteCustomerResponse>;
        }));
    }

    protected processDeleteCustomer(response: HttpResponseBase): Observable<DeleteCustomerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteCustomerResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteCustomerResponse>(null as any);
    }

    getCustomerListByListofIds(customerIds: string[]): Observable<GetCustomerListResponse> {
        let url_ = this.baseUrl + "/api/v1/customer/getcustomerlistbyids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerListByListofIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerListByListofIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerListResponse>;
        }));
    }

    protected processGetCustomerListByListofIds(response: HttpResponseBase): Observable<GetCustomerListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomerListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerListResponse>(null as any);
    }

    getCurrentCustomer(): Observable<GetCustomerResponse> {
        let url_ = this.baseUrl + "/api/v1/customer/current-customer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerResponse>;
        }));
    }

    protected processGetCurrentCustomer(response: HttpResponseBase): Observable<GetCustomerResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomerResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerResponse>(null as any);
    }
}

@Injectable()
export class ComponentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    upsertComponent(request: UpsertComponentRequest): Observable<UpsertComponentResponse> {
        let url_ = this.baseUrl + "/api/v1/component";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertComponentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertComponentResponse>;
        }));
    }

    protected processUpsertComponent(response: HttpResponseBase): Observable<UpsertComponentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertComponentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertComponentResponse>(null as any);
    }

    deleteComponentName(name: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/component/name/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteComponentName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComponentName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteComponentName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteComponent(componentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/component/{componentId}";
        if (componentId === undefined || componentId === null)
            throw new Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteComponent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @deprecated
     */
    upsertComponentLoad(request: UpsertComponentLoadRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/component/BatchLoad";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertComponentLoad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertComponentLoad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertComponentLoad(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getDefaultNameSuggestions(): Observable<NameSuggestionResponse> {
        let url_ = this.baseUrl + "/api/v1/component/defaultNameSuggestions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultNameSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultNameSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameSuggestionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameSuggestionResponse>;
        }));
    }

    protected processGetDefaultNameSuggestions(response: HttpResponseBase): Observable<NameSuggestionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NameSuggestionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameSuggestionResponse>(null as any);
    }

    getNameSuggestions(prefix?: string | undefined): Observable<NameSuggestionResponse> {
        let url_ = this.baseUrl + "/api/v1/component/nameSuggestions?";
        if (prefix === null)
            throw new Error("The parameter 'prefix' cannot be null.");
        else if (prefix !== undefined)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNameSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNameSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameSuggestionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameSuggestionResponse>;
        }));
    }

    protected processGetNameSuggestions(response: HttpResponseBase): Observable<NameSuggestionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NameSuggestionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("User is not logged in, or wrong username/password", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Operation is not allowed for the current user", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameSuggestionResponse>(null as any);
    }
}

export class GetWorkersResponse implements IGetWorkersResponse {
    workers!: Worker[];

    constructor(data?: IGetWorkersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.workers) {
                this.workers = [];
                for (let i = 0; i < data.workers.length; i++) {
                    let item = data.workers[i];
                    this.workers[i] = item && !(<any>item).toJSON ? new Worker(item) : <Worker>item;
                }
            }
        }
        if (!data) {
            this.workers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workers"])) {
                this.workers = [] as any;
                for (let item of _data["workers"])
                    this.workers!.push(Worker.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWorkersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workers)) {
            data["workers"] = [];
            for (let item of this.workers)
                data["workers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWorkersResponse {
    workers: IWorker[];
}

export class Worker implements IWorker {
    id!: string;
    name!: string;
    externalId!: string;
    resourceGroupNo?: string;

    constructor(data?: IWorker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.resourceGroupNo = _data["resourceGroupNo"];
        }
    }

    static fromJS(data: any): Worker {
        data = typeof data === 'object' ? data : {};
        let result = new Worker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["resourceGroupNo"] = this.resourceGroupNo;
        return data;
    }
}

export interface IWorker {
    id: string;
    name: string;
    externalId: string;
    resourceGroupNo?: string;
}

export class GetUserListResponse implements IGetUserListResponse {
    page?: number;
    users?: User[];
    isFullPage?: boolean;

    constructor(data?: IGetUserListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.users) {
                this.users = [];
                for (let i = 0; i < data.users.length; i++) {
                    let item = data.users[i];
                    this.users[i] = item && !(<any>item).toJSON ? new User(item) : <User>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
            this.isFullPage = _data["isFullPage"];
        }
    }

    static fromJS(data: any): GetUserListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["isFullPage"] = this.isFullPage;
        return data;
    }
}

export interface IGetUserListResponse {
    page?: number;
    users?: IUser[];
    isFullPage?: boolean;
}

export class User implements IUser {
    id?: string;
    name!: string;
    username!: string;
    email!: string;
    userRole?: UserRole;
    userRoleAdmin?: UserRoleAdmin;
    userRoleStorage?: UserRoleStorage;
    userRoleSustainability?: UserRoleSustainability;
    userRoleTerminal?: UserRoleTerminal;
    customerId?: string | undefined;
    customerName?: string | undefined;
    departments?: Department[];
    created?: Date | undefined;
    lastLogin?: Date | undefined;
    isDeleted?: boolean;
    passwordReset?: boolean;
    resourceId?: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.departments) {
                this.departments = [];
                for (let i = 0; i < data.departments.length; i++) {
                    let item = data.departments[i];
                    this.departments[i] = item && !(<any>item).toJSON ? new Department(item) : <Department>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.userRole = _data["userRole"];
            this.userRoleAdmin = _data["userRoleAdmin"];
            this.userRoleStorage = _data["userRoleStorage"];
            this.userRoleSustainability = _data["userRoleSustainability"];
            this.userRoleTerminal = _data["userRoleTerminal"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.passwordReset = _data["passwordReset"];
            this.resourceId = _data["resourceId"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["username"] = this.username;
        data["email"] = this.email;
        data["userRole"] = this.userRole;
        data["userRoleAdmin"] = this.userRoleAdmin;
        data["userRoleStorage"] = this.userRoleStorage;
        data["userRoleSustainability"] = this.userRoleSustainability;
        data["userRoleTerminal"] = this.userRoleTerminal;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item.toJSON());
        }
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["passwordReset"] = this.passwordReset;
        data["resourceId"] = this.resourceId;
        return data;
    }
}

export interface IUser {
    id?: string;
    name: string;
    username: string;
    email: string;
    userRole?: UserRole;
    userRoleAdmin?: UserRoleAdmin;
    userRoleStorage?: UserRoleStorage;
    userRoleSustainability?: UserRoleSustainability;
    userRoleTerminal?: UserRoleTerminal;
    customerId?: string | undefined;
    customerName?: string | undefined;
    departments?: IDepartment[];
    created?: Date | undefined;
    lastLogin?: Date | undefined;
    isDeleted?: boolean;
    passwordReset?: boolean;
    resourceId?: string | undefined;
}

export enum UserRole {
    None = "None",
    ProjectManager = "ProjectManager",
    GroupManager = "GroupManager",
    Customer = "Customer",
    Link = "Link",
}

export enum UserRoleAdmin {
    None = "None",
    EditGlobal = "EditGlobal",
}

export enum UserRoleStorage {
    None = "None",
    ReadCustomer = "ReadCustomer",
    EditCustomer = "EditCustomer",
    EditGlobal = "EditGlobal",
}

export enum UserRoleSustainability {
    None = "None",
    ReadCustomer = "ReadCustomer",
    ReadGlobal = "ReadGlobal",
    EditGlobal = "EditGlobal",
}

export enum UserRoleTerminal {
    None = "None",
    Supervisor = "Supervisor",
    Manager = "Manager",
    InformPanel = "InformPanel",
    Operator = "Operator",
    Docker = "Docker",
    TerminalCreateOperation = "TerminalCreateOperation",
    TerminalAcceptOperation = "TerminalAcceptOperation",
}

export class Department implements IDepartment {
    id?: string;
    name?: string;

    constructor(data?: IDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IDepartment {
    id?: string;
    name?: string;
}

export class GetUserListRequest implements IGetUserListRequest {
    page?: number;
    showActive?: boolean;
    showInactive?: boolean;
    keyword?: string | undefined;
    userRole?: string | undefined;
    customer?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;

    constructor(data?: IGetUserListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.showActive = _data["showActive"];
            this.showInactive = _data["showInactive"];
            this.keyword = _data["keyword"];
            this.userRole = _data["userRole"];
            this.customer = _data["customer"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): GetUserListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["showActive"] = this.showActive;
        data["showInactive"] = this.showInactive;
        data["keyword"] = this.keyword;
        data["userRole"] = this.userRole;
        data["customer"] = this.customer;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface IGetUserListRequest {
    page?: number;
    showActive?: boolean;
    showInactive?: boolean;
    keyword?: string | undefined;
    userRole?: string | undefined;
    customer?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
}

export class UpsertUserResponse implements IUpsertUserResponse {
    alreadyExisting?: boolean;

    constructor(data?: IUpsertUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alreadyExisting = _data["alreadyExisting"];
        }
    }

    static fromJS(data: any): UpsertUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alreadyExisting"] = this.alreadyExisting;
        return data;
    }
}

export interface IUpsertUserResponse {
    alreadyExisting?: boolean;
}

export class UpsertUserRequest implements IUpsertUserRequest {
    id?: string;
    name!: string;
    username!: string;
    email!: string;
    userRole!: UserRole;
    userRoleAdmin!: UserRoleAdmin;
    userRoleStorage!: UserRoleStorage;
    userRoleSustainability!: UserRoleSustainability;
    userRoleTerminal!: UserRoleTerminal;
    customerId?: string | undefined;
    password?: string | undefined;
    departmentIds?: string[];
    resourceId?: string | undefined;

    constructor(data?: IUpsertUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.username = _data["username"];
            this.email = _data["email"];
            this.userRole = _data["userRole"];
            this.userRoleAdmin = _data["userRoleAdmin"];
            this.userRoleStorage = _data["userRoleStorage"];
            this.userRoleSustainability = _data["userRoleSustainability"];
            this.userRoleTerminal = _data["userRoleTerminal"];
            this.customerId = _data["customerId"];
            this.password = _data["password"];
            if (Array.isArray(_data["departmentIds"])) {
                this.departmentIds = [] as any;
                for (let item of _data["departmentIds"])
                    this.departmentIds!.push(item);
            }
            this.resourceId = _data["resourceId"];
        }
    }

    static fromJS(data: any): UpsertUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["username"] = this.username;
        data["email"] = this.email;
        data["userRole"] = this.userRole;
        data["userRoleAdmin"] = this.userRoleAdmin;
        data["userRoleStorage"] = this.userRoleStorage;
        data["userRoleSustainability"] = this.userRoleSustainability;
        data["userRoleTerminal"] = this.userRoleTerminal;
        data["customerId"] = this.customerId;
        data["password"] = this.password;
        if (Array.isArray(this.departmentIds)) {
            data["departmentIds"] = [];
            for (let item of this.departmentIds)
                data["departmentIds"].push(item);
        }
        data["resourceId"] = this.resourceId;
        return data;
    }
}

export interface IUpsertUserRequest {
    id?: string;
    name: string;
    username: string;
    email: string;
    userRole: UserRole;
    userRoleAdmin: UserRoleAdmin;
    userRoleStorage: UserRoleStorage;
    userRoleSustainability: UserRoleSustainability;
    userRoleTerminal: UserRoleTerminal;
    customerId?: string | undefined;
    password?: string | undefined;
    departmentIds?: string[];
    resourceId?: string | undefined;
}

export class DeleteUserResponse implements IDeleteUserResponse {
    existed?: boolean;

    constructor(data?: IDeleteUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.existed = _data["existed"];
        }
    }

    static fromJS(data: any): DeleteUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["existed"] = this.existed;
        return data;
    }
}

export interface IDeleteUserResponse {
    existed?: boolean;
}

export class DeleteUserRequest implements IDeleteUserRequest {
    id?: string;

    constructor(data?: IDeleteUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteUserRequest {
    id?: string;
}

export class RestoreUserRequest implements IRestoreUserRequest {
    id?: string;

    constructor(data?: IRestoreUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RestoreUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRestoreUserRequest {
    id?: string;
}

export class SavePasswordResponse implements ISavePasswordResponse {
    success?: boolean;

    constructor(data?: ISavePasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SavePasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SavePasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ISavePasswordResponse {
    success?: boolean;
}

export class SavePasswordRequest implements ISavePasswordRequest {
    passwordTemporary?: string;
    passwordNew?: string;

    constructor(data?: ISavePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passwordTemporary = _data["passwordTemporary"];
            this.passwordNew = _data["passwordNew"];
        }
    }

    static fromJS(data: any): SavePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SavePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordTemporary"] = this.passwordTemporary;
        data["passwordNew"] = this.passwordNew;
        return data;
    }
}

export interface ISavePasswordRequest {
    passwordTemporary?: string;
    passwordNew?: string;
}

export class CreateTaskResponse implements ICreateTaskResponse {
    task?: TerminalTask;

    constructor(data?: ICreateTaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.task = data.task && !(<any>data.task).toJSON ? new TerminalTask(data.task) : <TerminalTask>this.task;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.task = _data["task"] ? TerminalTask.fromJS(_data["task"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateTaskResponse {
    task?: ITerminalTask;
}

export class TerminalTask implements ITerminalTask {
    id!: string;
    externalId?: string | undefined;
    rowVersion!: string;
    jobId!: string;
    taskStatus!: Status;
    shortDescription!: string;
    description!: string;
    /** Must be a Resource ID ResourceController */
    responsibleWorker!: string;
    startDate!: Date;
    endDate?: Date | undefined;
    estimatedTime?: string | undefined;
    taskType!: Type;
    location?: Location | undefined;
    locationId?: string;
    numberSeries?: number;
    departmentCode?: string;
    assignmentDate?: Date;
    taskReference?: string | undefined;

    constructor(data?: ITerminalTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.rowVersion = _data["rowVersion"];
            this.jobId = _data["jobId"];
            this.taskStatus = _data["taskStatus"];
            this.shortDescription = _data["shortDescription"];
            this.description = _data["description"];
            this.responsibleWorker = _data["responsibleWorker"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.estimatedTime = _data["estimatedTime"];
            this.taskType = _data["taskType"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.numberSeries = _data["numberSeries"];
            this.departmentCode = _data["departmentCode"];
            this.assignmentDate = _data["assignmentDate"] ? new Date(_data["assignmentDate"].toString()) : <any>undefined;
            this.taskReference = _data["taskReference"];
        }
    }

    static fromJS(data: any): TerminalTask {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["rowVersion"] = this.rowVersion;
        data["jobId"] = this.jobId;
        data["taskStatus"] = this.taskStatus;
        data["shortDescription"] = this.shortDescription;
        data["description"] = this.description;
        data["responsibleWorker"] = this.responsibleWorker;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["estimatedTime"] = this.estimatedTime;
        data["taskType"] = this.taskType;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["numberSeries"] = this.numberSeries;
        data["departmentCode"] = this.departmentCode;
        data["assignmentDate"] = this.assignmentDate ? this.assignmentDate.toISOString() : <any>undefined;
        data["taskReference"] = this.taskReference;
        return data;
    }
}

export interface ITerminalTask {
    id: string;
    externalId?: string | undefined;
    rowVersion: string;
    jobId: string;
    taskStatus: Status;
    shortDescription: string;
    description: string;
    /** Must be a Resource ID ResourceController */
    responsibleWorker: string;
    startDate: Date;
    endDate?: Date | undefined;
    estimatedTime?: string | undefined;
    taskType: Type;
    location?: ILocation | undefined;
    locationId?: string;
    numberSeries?: number;
    departmentCode?: string;
    assignmentDate?: Date;
    taskReference?: string | undefined;
}

export enum Status {
    Pending = "Pending",
    Active = "Active",
    Completed = "Completed",
    Declined = "Declined",
    Deleted = "Deleted",
}

export enum Type {
    Unknown = "Unknown",
    Terminal = "Terminal",
    Agency = "Agency",
    Chemical = "Chemical",
    Stevedoring = "Stevedoring",
    WarehouseRent = "WarehouseRent",
    Transport = "Transport",
    StockedGoods = "StockedGoods",
}

export class Location implements ILocation {
    id?: string;
    name?: string;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocation {
    id?: string;
    name?: string;
}

export class CreateTaskRequest implements ICreateTaskRequest {
    id!: string;
    jobId!: string;
    taskStatus!: Status;
    shortDescription!: string;
    description?: string;
    /** Must be a Resource ID. See ResourceController */
    responsibleWorker!: string;
    startDate!: Date;
    endDate?: Date | undefined;
    estimatedTime?: string | undefined;
    taskType!: Type;
    locationId?: string | undefined;
    numberSeries?: number;
    departmentCode?: string;
    assignmentDate?: Date;
    taskReference?: string | undefined;

    constructor(data?: ICreateTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobId = _data["jobId"];
            this.taskStatus = _data["taskStatus"];
            this.shortDescription = _data["shortDescription"];
            this.description = _data["description"];
            this.responsibleWorker = _data["responsibleWorker"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.estimatedTime = _data["estimatedTime"];
            this.taskType = _data["taskType"];
            this.locationId = _data["locationId"];
            this.numberSeries = _data["numberSeries"];
            this.departmentCode = _data["departmentCode"];
            this.assignmentDate = _data["assignmentDate"] ? new Date(_data["assignmentDate"].toString()) : <any>undefined;
            this.taskReference = _data["taskReference"];
        }
    }

    static fromJS(data: any): CreateTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobId"] = this.jobId;
        data["taskStatus"] = this.taskStatus;
        data["shortDescription"] = this.shortDescription;
        data["description"] = this.description;
        data["responsibleWorker"] = this.responsibleWorker;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["estimatedTime"] = this.estimatedTime;
        data["taskType"] = this.taskType;
        data["locationId"] = this.locationId;
        data["numberSeries"] = this.numberSeries;
        data["departmentCode"] = this.departmentCode;
        data["assignmentDate"] = this.assignmentDate ? this.assignmentDate.toISOString() : <any>undefined;
        data["taskReference"] = this.taskReference;
        return data;
    }
}

export interface ICreateTaskRequest {
    id: string;
    jobId: string;
    taskStatus: Status;
    shortDescription: string;
    description?: string;
    /** Must be a Resource ID. See ResourceController */
    responsibleWorker: string;
    startDate: Date;
    endDate?: Date | undefined;
    estimatedTime?: string | undefined;
    taskType: Type;
    locationId?: string | undefined;
    numberSeries?: number;
    departmentCode?: string;
    assignmentDate?: Date;
    taskReference?: string | undefined;
}

export class GetTaskListResponse implements IGetTaskListResponse {
    tasks!: TaskListTask[];
    /** true if there are more tasks on page n+1 */
    isFullPage?: boolean;

    constructor(data?: IGetTaskListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.tasks) {
                this.tasks = [];
                for (let i = 0; i < data.tasks.length; i++) {
                    let item = data.tasks[i];
                    this.tasks[i] = item && !(<any>item).toJSON ? new TaskListTask(item) : <TaskListTask>item;
                }
            }
        }
        if (!data) {
            this.tasks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskListTask.fromJS(item));
            }
            this.isFullPage = _data["isFullPage"];
        }
    }

    static fromJS(data: any): GetTaskListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        data["isFullPage"] = this.isFullPage;
        return data;
    }
}

export interface IGetTaskListResponse {
    tasks: ITaskListTask[];
    /** true if there are more tasks on page n+1 */
    isFullPage?: boolean;
}

export class TaskListTask implements ITaskListTask {
    id!: string;
    externalId?: string | undefined;
    job!: TaskListJob;
    description!: string;

    constructor(data?: ITaskListTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.job = data.job && !(<any>data.job).toJSON ? new TaskListJob(data.job) : <TaskListJob>this.job;
        }
        if (!data) {
            this.job = new TaskListJob();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.job = _data["job"] ? TaskListJob.fromJS(_data["job"]) : new TaskListJob();
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TaskListTask {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        data["description"] = this.description;
        return data;
    }
}

export interface ITaskListTask {
    id: string;
    externalId?: string | undefined;
    job: ITaskListJob;
    description: string;
}

export class TaskListJob implements ITaskListJob {
    id!: string;
    externalId?: string | undefined;
    description!: string;
    customer!: TaskListCustomer;

    constructor(data?: ITaskListJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.customer = data.customer && !(<any>data.customer).toJSON ? new TaskListCustomer(data.customer) : <TaskListCustomer>this.customer;
        }
        if (!data) {
            this.customer = new TaskListCustomer();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.description = _data["description"];
            this.customer = _data["customer"] ? TaskListCustomer.fromJS(_data["customer"]) : new TaskListCustomer();
        }
    }

    static fromJS(data: any): TaskListJob {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["description"] = this.description;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskListJob {
    id: string;
    externalId?: string | undefined;
    description: string;
    customer: ITaskListCustomer;
}

export class TaskListCustomer implements ITaskListCustomer {
    id!: string;
    name!: string;

    constructor(data?: ITaskListCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TaskListCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITaskListCustomer {
    id: string;
    name: string;
}

export class CreateOperationResponse implements ICreateOperationResponse {
    operation?: TerminalOperation;

    constructor(data?: ICreateOperationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.operation = data.operation && !(<any>data.operation).toJSON ? new TerminalOperation(data.operation) : <TerminalOperation>this.operation;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operation = _data["operation"] ? TerminalOperation.fromJS(_data["operation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOperationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOperationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operation"] = this.operation ? this.operation.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOperationResponse {
    operation?: ITerminalOperation;
}

export class TerminalOperation implements ITerminalOperation {
    id!: string;
    taskId!: string;
    status!: Status;
    description!: string;
    /** Must be a Resource ID ResourceController */
    responsiblePerson!: string;
    /** Must be a Resource ID ResourceController */
    involvedWorkers?: string[];
    involvedMachines?: string[];
    operationFiles?: string[];
    startDateTime!: DateTimeTba;
    endDateTime?: DateTimeTba | undefined;
    type!: Type;
    location?: Location | undefined;
    locationId?: string;
    notes?: string;
    important?: string;
    hasUnreadComments?: boolean;
    hasComments?: boolean;

    constructor(data?: ITerminalOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.startDateTime = data.startDateTime && !(<any>data.startDateTime).toJSON ? new DateTimeTba(data.startDateTime) : <DateTimeTba>this.startDateTime;
            this.endDateTime = data.endDateTime && !(<any>data.endDateTime).toJSON ? new DateTimeTba(data.endDateTime) : <DateTimeTba>this.endDateTime;
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
        }
        if (!data) {
            this.startDateTime = new DateTimeTba();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.responsiblePerson = _data["responsiblePerson"];
            if (Array.isArray(_data["involvedWorkers"])) {
                this.involvedWorkers = [] as any;
                for (let item of _data["involvedWorkers"])
                    this.involvedWorkers!.push(item);
            }
            if (Array.isArray(_data["involvedMachines"])) {
                this.involvedMachines = [] as any;
                for (let item of _data["involvedMachines"])
                    this.involvedMachines!.push(item);
            }
            if (Array.isArray(_data["operationFiles"])) {
                this.operationFiles = [] as any;
                for (let item of _data["operationFiles"])
                    this.operationFiles!.push(item);
            }
            this.startDateTime = _data["startDateTime"] ? DateTimeTba.fromJS(_data["startDateTime"]) : new DateTimeTba();
            this.endDateTime = _data["endDateTime"] ? DateTimeTba.fromJS(_data["endDateTime"]) : <any>undefined;
            this.type = _data["type"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.notes = _data["notes"];
            this.important = _data["important"];
            this.hasUnreadComments = _data["hasUnreadComments"];
            this.hasComments = _data["hasComments"];
        }
    }

    static fromJS(data: any): TerminalOperation {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalOperation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["status"] = this.status;
        data["description"] = this.description;
        data["responsiblePerson"] = this.responsiblePerson;
        if (Array.isArray(this.involvedWorkers)) {
            data["involvedWorkers"] = [];
            for (let item of this.involvedWorkers)
                data["involvedWorkers"].push(item);
        }
        if (Array.isArray(this.involvedMachines)) {
            data["involvedMachines"] = [];
            for (let item of this.involvedMachines)
                data["involvedMachines"].push(item);
        }
        if (Array.isArray(this.operationFiles)) {
            data["operationFiles"] = [];
            for (let item of this.operationFiles)
                data["operationFiles"].push(item);
        }
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toJSON() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["notes"] = this.notes;
        data["important"] = this.important;
        data["hasUnreadComments"] = this.hasUnreadComments;
        data["hasComments"] = this.hasComments;
        return data;
    }
}

export interface ITerminalOperation {
    id: string;
    taskId: string;
    status: Status;
    description: string;
    /** Must be a Resource ID ResourceController */
    responsiblePerson: string;
    /** Must be a Resource ID ResourceController */
    involvedWorkers?: string[];
    involvedMachines?: string[];
    operationFiles?: string[];
    startDateTime: IDateTimeTba;
    endDateTime?: IDateTimeTba | undefined;
    type: Type;
    location?: ILocation | undefined;
    locationId?: string;
    notes?: string;
    important?: string;
    hasUnreadComments?: boolean;
    hasComments?: boolean;
}

export class DateTimeTba implements IDateTimeTba {
    dateTime!: Date;
    timeIsTba!: boolean;

    constructor(data?: IDateTimeTba) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.timeIsTba = _data["timeIsTba"];
        }
    }

    static fromJS(data: any): DateTimeTba {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeTba();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["timeIsTba"] = this.timeIsTba;
        return data;
    }
}

export interface IDateTimeTba {
    dateTime: Date;
    timeIsTba: boolean;
}

export class CreateOperationRequest implements ICreateOperationRequest {
    id?: string;
    taskId!: string;
    status!: Status;
    description!: string;
    /** Must be a Resource ID. See ResourceController */
    responsiblePerson!: string;
    /** Must be a Resource ID. See ResourceController */
    involvedWorkers!: string[];
    /** Must be a Resource ID. See ResourceController */
    involvedMachines!: string[];
    startDateTime!: DateTimeTba;
    endDateTime?: DateTimeTba | undefined;
    type!: Type;
    locationId?: string | undefined;
    notes?: string | undefined;
    important?: string | undefined;

    constructor(data?: ICreateOperationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.startDateTime = data.startDateTime && !(<any>data.startDateTime).toJSON ? new DateTimeTba(data.startDateTime) : <DateTimeTba>this.startDateTime;
            this.endDateTime = data.endDateTime && !(<any>data.endDateTime).toJSON ? new DateTimeTba(data.endDateTime) : <DateTimeTba>this.endDateTime;
        }
        if (!data) {
            this.involvedWorkers = [];
            this.involvedMachines = [];
            this.startDateTime = new DateTimeTba();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.responsiblePerson = _data["responsiblePerson"];
            if (Array.isArray(_data["involvedWorkers"])) {
                this.involvedWorkers = [] as any;
                for (let item of _data["involvedWorkers"])
                    this.involvedWorkers!.push(item);
            }
            if (Array.isArray(_data["involvedMachines"])) {
                this.involvedMachines = [] as any;
                for (let item of _data["involvedMachines"])
                    this.involvedMachines!.push(item);
            }
            this.startDateTime = _data["startDateTime"] ? DateTimeTba.fromJS(_data["startDateTime"]) : new DateTimeTba();
            this.endDateTime = _data["endDateTime"] ? DateTimeTba.fromJS(_data["endDateTime"]) : <any>undefined;
            this.type = _data["type"];
            this.locationId = _data["locationId"];
            this.notes = _data["notes"];
            this.important = _data["important"];
        }
    }

    static fromJS(data: any): CreateOperationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOperationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["status"] = this.status;
        data["description"] = this.description;
        data["responsiblePerson"] = this.responsiblePerson;
        if (Array.isArray(this.involvedWorkers)) {
            data["involvedWorkers"] = [];
            for (let item of this.involvedWorkers)
                data["involvedWorkers"].push(item);
        }
        if (Array.isArray(this.involvedMachines)) {
            data["involvedMachines"] = [];
            for (let item of this.involvedMachines)
                data["involvedMachines"].push(item);
        }
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toJSON() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["locationId"] = this.locationId;
        data["notes"] = this.notes;
        data["important"] = this.important;
        return data;
    }
}

export interface ICreateOperationRequest {
    id?: string;
    taskId: string;
    status: Status;
    description: string;
    /** Must be a Resource ID. See ResourceController */
    responsiblePerson: string;
    /** Must be a Resource ID. See ResourceController */
    involvedWorkers: string[];
    /** Must be a Resource ID. See ResourceController */
    involvedMachines: string[];
    startDateTime: IDateTimeTba;
    endDateTime?: IDateTimeTba | undefined;
    type: Type;
    locationId?: string | undefined;
    notes?: string | undefined;
    important?: string | undefined;
}

export class GetOperationListResponse implements IGetOperationListResponse {
    operations!: OperationListOperation[];
    /** true if there are more operations on page n+1 */
    isFullPage?: boolean;

    constructor(data?: IGetOperationListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.operations) {
                this.operations = [];
                for (let i = 0; i < data.operations.length; i++) {
                    let item = data.operations[i];
                    this.operations[i] = item && !(<any>item).toJSON ? new OperationListOperation(item) : <OperationListOperation>item;
                }
            }
        }
        if (!data) {
            this.operations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(OperationListOperation.fromJS(item));
            }
            this.isFullPage = _data["isFullPage"];
        }
    }

    static fromJS(data: any): GetOperationListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperationListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item.toJSON());
        }
        data["isFullPage"] = this.isFullPage;
        return data;
    }
}

export interface IGetOperationListResponse {
    operations: IOperationListOperation[];
    /** true if there are more operations on page n+1 */
    isFullPage?: boolean;
}

export class OperationListOperation implements IOperationListOperation {
    id!: string;
    task!: OperationListTask;
    status!: Status;
    description!: string;
    responsiblePerson!: OperationListResource;
    involvedWorkers?: OperationListResource[];
    involvedMachines?: OperationListResource[];
    attachedFiles?: OperationListFile[];
    startDateTime!: DateTimeTba;
    endDateTime?: DateTimeTba | undefined;
    type!: Type;
    location?: Location | undefined;
    locationId?: string;
    notes?: string | undefined;
    important?: string | undefined;
    estimatedTime?: string | undefined;
    hasUnreadComments?: boolean;
    hasComments?: boolean;

    constructor(data?: IOperationListOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.task = data.task && !(<any>data.task).toJSON ? new OperationListTask(data.task) : <OperationListTask>this.task;
            this.responsiblePerson = data.responsiblePerson && !(<any>data.responsiblePerson).toJSON ? new OperationListResource(data.responsiblePerson) : <OperationListResource>this.responsiblePerson;
            if (data.involvedWorkers) {
                this.involvedWorkers = [];
                for (let i = 0; i < data.involvedWorkers.length; i++) {
                    let item = data.involvedWorkers[i];
                    this.involvedWorkers[i] = item && !(<any>item).toJSON ? new OperationListResource(item) : <OperationListResource>item;
                }
            }
            if (data.involvedMachines) {
                this.involvedMachines = [];
                for (let i = 0; i < data.involvedMachines.length; i++) {
                    let item = data.involvedMachines[i];
                    this.involvedMachines[i] = item && !(<any>item).toJSON ? new OperationListResource(item) : <OperationListResource>item;
                }
            }
            if (data.attachedFiles) {
                this.attachedFiles = [];
                for (let i = 0; i < data.attachedFiles.length; i++) {
                    let item = data.attachedFiles[i];
                    this.attachedFiles[i] = item && !(<any>item).toJSON ? new OperationListFile(item) : <OperationListFile>item;
                }
            }
            this.startDateTime = data.startDateTime && !(<any>data.startDateTime).toJSON ? new DateTimeTba(data.startDateTime) : <DateTimeTba>this.startDateTime;
            this.endDateTime = data.endDateTime && !(<any>data.endDateTime).toJSON ? new DateTimeTba(data.endDateTime) : <DateTimeTba>this.endDateTime;
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
        }
        if (!data) {
            this.task = new OperationListTask();
            this.responsiblePerson = new OperationListResource();
            this.startDateTime = new DateTimeTba();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.task = _data["task"] ? OperationListTask.fromJS(_data["task"]) : new OperationListTask();
            this.status = _data["status"];
            this.description = _data["description"];
            this.responsiblePerson = _data["responsiblePerson"] ? OperationListResource.fromJS(_data["responsiblePerson"]) : new OperationListResource();
            if (Array.isArray(_data["involvedWorkers"])) {
                this.involvedWorkers = [] as any;
                for (let item of _data["involvedWorkers"])
                    this.involvedWorkers!.push(OperationListResource.fromJS(item));
            }
            if (Array.isArray(_data["involvedMachines"])) {
                this.involvedMachines = [] as any;
                for (let item of _data["involvedMachines"])
                    this.involvedMachines!.push(OperationListResource.fromJS(item));
            }
            if (Array.isArray(_data["attachedFiles"])) {
                this.attachedFiles = [] as any;
                for (let item of _data["attachedFiles"])
                    this.attachedFiles!.push(OperationListFile.fromJS(item));
            }
            this.startDateTime = _data["startDateTime"] ? DateTimeTba.fromJS(_data["startDateTime"]) : new DateTimeTba();
            this.endDateTime = _data["endDateTime"] ? DateTimeTba.fromJS(_data["endDateTime"]) : <any>undefined;
            this.type = _data["type"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.notes = _data["notes"];
            this.important = _data["important"];
            this.estimatedTime = _data["estimatedTime"];
            this.hasUnreadComments = _data["hasUnreadComments"];
            this.hasComments = _data["hasComments"];
        }
    }

    static fromJS(data: any): OperationListOperation {
        data = typeof data === 'object' ? data : {};
        let result = new OperationListOperation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["description"] = this.description;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : <any>undefined;
        if (Array.isArray(this.involvedWorkers)) {
            data["involvedWorkers"] = [];
            for (let item of this.involvedWorkers)
                data["involvedWorkers"].push(item.toJSON());
        }
        if (Array.isArray(this.involvedMachines)) {
            data["involvedMachines"] = [];
            for (let item of this.involvedMachines)
                data["involvedMachines"].push(item.toJSON());
        }
        if (Array.isArray(this.attachedFiles)) {
            data["attachedFiles"] = [];
            for (let item of this.attachedFiles)
                data["attachedFiles"].push(item.toJSON());
        }
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toJSON() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["notes"] = this.notes;
        data["important"] = this.important;
        data["estimatedTime"] = this.estimatedTime;
        data["hasUnreadComments"] = this.hasUnreadComments;
        data["hasComments"] = this.hasComments;
        return data;
    }
}

export interface IOperationListOperation {
    id: string;
    task: IOperationListTask;
    status: Status;
    description: string;
    responsiblePerson: IOperationListResource;
    involvedWorkers?: IOperationListResource[];
    involvedMachines?: IOperationListResource[];
    attachedFiles?: IOperationListFile[];
    startDateTime: IDateTimeTba;
    endDateTime?: IDateTimeTba | undefined;
    type: Type;
    location?: ILocation | undefined;
    locationId?: string;
    notes?: string | undefined;
    important?: string | undefined;
    estimatedTime?: string | undefined;
    hasUnreadComments?: boolean;
    hasComments?: boolean;
}

export class OperationListTask implements IOperationListTask {
    id!: string;
    externalId?: string | undefined;
    description!: string;
    job!: OperationListJob;

    constructor(data?: IOperationListTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.job = data.job && !(<any>data.job).toJSON ? new OperationListJob(data.job) : <OperationListJob>this.job;
        }
        if (!data) {
            this.job = new OperationListJob();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.description = _data["description"];
            this.job = _data["job"] ? OperationListJob.fromJS(_data["job"]) : new OperationListJob();
        }
    }

    static fromJS(data: any): OperationListTask {
        data = typeof data === 'object' ? data : {};
        let result = new OperationListTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["description"] = this.description;
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOperationListTask {
    id: string;
    externalId?: string | undefined;
    description: string;
    job: IOperationListJob;
}

export class OperationListJob implements IOperationListJob {
    id!: string;
    externalId?: string | undefined;
    description!: string;
    responsibleDepartment?: string | undefined;
    customer!: OperationListCustomer;

    constructor(data?: IOperationListJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.customer = data.customer && !(<any>data.customer).toJSON ? new OperationListCustomer(data.customer) : <OperationListCustomer>this.customer;
        }
        if (!data) {
            this.customer = new OperationListCustomer();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.description = _data["description"];
            this.responsibleDepartment = _data["responsibleDepartment"];
            this.customer = _data["customer"] ? OperationListCustomer.fromJS(_data["customer"]) : new OperationListCustomer();
        }
    }

    static fromJS(data: any): OperationListJob {
        data = typeof data === 'object' ? data : {};
        let result = new OperationListJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["description"] = this.description;
        data["responsibleDepartment"] = this.responsibleDepartment;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOperationListJob {
    id: string;
    externalId?: string | undefined;
    description: string;
    responsibleDepartment?: string | undefined;
    customer: IOperationListCustomer;
}

export class OperationListCustomer implements IOperationListCustomer {
    id!: string;
    name!: string;

    constructor(data?: IOperationListCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OperationListCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new OperationListCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IOperationListCustomer {
    id: string;
    name: string;
}

export class OperationListResource implements IOperationListResource {
    id!: string;
    name!: string;
    subType?: string | undefined;
    capacityText?: string | undefined;
    externalId?: string | undefined;

    constructor(data?: IOperationListResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.subType = _data["subType"];
            this.capacityText = _data["capacityText"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): OperationListResource {
        data = typeof data === 'object' ? data : {};
        let result = new OperationListResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["subType"] = this.subType;
        data["capacityText"] = this.capacityText;
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IOperationListResource {
    id: string;
    name: string;
    subType?: string | undefined;
    capacityText?: string | undefined;
    externalId?: string | undefined;
}

export class OperationListFile implements IOperationListFile {
    id!: string;

    constructor(data?: IOperationListFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OperationListFile {
        data = typeof data === 'object' ? data : {};
        let result = new OperationListFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IOperationListFile {
    id: string;
}

export class SetOperationStatusRequest implements ISetOperationStatusRequest {
    status?: Status;

    constructor(data?: ISetOperationStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SetOperationStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetOperationStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface ISetOperationStatusRequest {
    status?: Status;
}

export class GetOperationFilesResponse implements IGetOperationFilesResponse {
    operationFiles?: OperationFile[];

    constructor(data?: IGetOperationFilesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.operationFiles) {
                this.operationFiles = [];
                for (let i = 0; i < data.operationFiles.length; i++) {
                    let item = data.operationFiles[i];
                    this.operationFiles[i] = item && !(<any>item).toJSON ? new OperationFile(item) : <OperationFile>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["operationFiles"])) {
                this.operationFiles = [] as any;
                for (let item of _data["operationFiles"])
                    this.operationFiles!.push(OperationFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOperationFilesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperationFilesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operationFiles)) {
            data["operationFiles"] = [];
            for (let item of this.operationFiles)
                data["operationFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOperationFilesResponse {
    operationFiles?: IOperationFile[];
}

export class OperationFile implements IOperationFile {
    fileId!: string;
    originalFilename!: string;
    mimeType!: string;
    created!: Date;
    name!: string;
    url!: string;

    constructor(data?: IOperationFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.originalFilename = _data["originalFilename"];
            this.mimeType = _data["mimeType"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): OperationFile {
        data = typeof data === 'object' ? data : {};
        let result = new OperationFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["originalFilename"] = this.originalFilename;
        data["mimeType"] = this.mimeType;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface IOperationFile {
    fileId: string;
    originalFilename: string;
    mimeType: string;
    created: Date;
    name: string;
    url: string;
}

export class OperationComment implements IOperationComment {
    id?: string;
    operationId?: string;
    comment?: string;
    authorId?: string;
    authorName?: string;
    createdAt?: Date;
    lastChangedAt?: Date;
    canEdit?: boolean;

    constructor(data?: IOperationComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operationId = _data["operationId"];
            this.comment = _data["comment"];
            this.authorId = _data["authorId"];
            this.authorName = _data["authorName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.lastChangedAt = _data["lastChangedAt"] ? new Date(_data["lastChangedAt"].toString()) : <any>undefined;
            this.canEdit = _data["canEdit"];
        }
    }

    static fromJS(data: any): OperationComment {
        data = typeof data === 'object' ? data : {};
        let result = new OperationComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operationId"] = this.operationId;
        data["comment"] = this.comment;
        data["authorId"] = this.authorId;
        data["authorName"] = this.authorName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["lastChangedAt"] = this.lastChangedAt ? this.lastChangedAt.toISOString() : <any>undefined;
        data["canEdit"] = this.canEdit;
        return data;
    }
}

export interface IOperationComment {
    id?: string;
    operationId?: string;
    comment?: string;
    authorId?: string;
    authorName?: string;
    createdAt?: Date;
    lastChangedAt?: Date;
    canEdit?: boolean;
}

export class CreateOperationCommentRequest implements ICreateOperationCommentRequest {
    comment?: string;

    constructor(data?: ICreateOperationCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreateOperationCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOperationCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICreateOperationCommentRequest {
    comment?: string;
}

export class UpdateOperationCommentRequest implements IUpdateOperationCommentRequest {
    comment?: string;

    constructor(data?: IUpdateOperationCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateOperationCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOperationCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateOperationCommentRequest {
    comment?: string;
}

export class GetLocationListResponse implements IGetLocationListResponse {
    locations!: TerminalLocation[];

    constructor(data?: IGetLocationListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.locations) {
                this.locations = [];
                for (let i = 0; i < data.locations.length; i++) {
                    let item = data.locations[i];
                    this.locations[i] = item && !(<any>item).toJSON ? new TerminalLocation(item) : <TerminalLocation>item;
                }
            }
        }
        if (!data) {
            this.locations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(TerminalLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLocationListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLocationListResponse {
    locations: ITerminalLocation[];
}

export class TerminalLocation implements ITerminalLocation {
    id?: string;
    name?: string;

    constructor(data?: ITerminalLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TerminalLocation {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITerminalLocation {
    id?: string;
    name?: string;
}

export class CreateJobResponse implements ICreateJobResponse {
    job!: TerminalJob;

    constructor(data?: ICreateJobResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.job = data.job && !(<any>data.job).toJSON ? new TerminalJob(data.job) : <TerminalJob>this.job;
        }
        if (!data) {
            this.job = new TerminalJob();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.job = _data["job"] ? TerminalJob.fromJS(_data["job"]) : new TerminalJob();
        }
    }

    static fromJS(data: any): CreateJobResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateJobResponse {
    job: ITerminalJob;
}

export class TerminalJob implements ITerminalJob {
    id!: string;
    externalId?: string | undefined;
    name!: string;
    rowVersion!: string;
    customerId!: string;
    responsibleDepartment!: string;
    status?: JobStatus;

    constructor(data?: ITerminalJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
            this.rowVersion = _data["rowVersion"];
            this.customerId = _data["customerId"];
            this.responsibleDepartment = _data["responsibleDepartment"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TerminalJob {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        data["rowVersion"] = this.rowVersion;
        data["customerId"] = this.customerId;
        data["responsibleDepartment"] = this.responsibleDepartment;
        data["status"] = this.status;
        return data;
    }
}

export interface ITerminalJob {
    id: string;
    externalId?: string | undefined;
    name: string;
    rowVersion: string;
    customerId: string;
    responsibleDepartment: string;
    status?: JobStatus;
}

export enum JobStatus {
    Planning = "Planning",
    Quote = "Quote",
    Open = "Open",
    Completed = "Completed",
}

export class CreateJobRequest implements ICreateJobRequest {
    /** Customer Id. CustomerController */
    customerId!: string;
    responsibleDepartment!: string;
    name!: string;
    status?: JobStatus;

    constructor(data?: ICreateJobRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.responsibleDepartment = _data["responsibleDepartment"];
            this.name = _data["name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateJobRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["responsibleDepartment"] = this.responsibleDepartment;
        data["name"] = this.name;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateJobRequest {
    /** Customer Id. CustomerController */
    customerId: string;
    responsibleDepartment: string;
    name: string;
    status?: JobStatus;
}

export class GetJobListResponse implements IGetJobListResponse {
    jobs!: TerminalJob[];

    constructor(data?: IGetJobListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.jobs) {
                this.jobs = [];
                for (let i = 0; i < data.jobs.length; i++) {
                    let item = data.jobs[i];
                    this.jobs[i] = item && !(<any>item).toJSON ? new TerminalJob(item) : <TerminalJob>item;
                }
            }
        }
        if (!data) {
            this.jobs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [] as any;
                for (let item of _data["jobs"])
                    this.jobs!.push(TerminalJob.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJobListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJobListResponse {
    jobs: ITerminalJob[];
}

export class UpdateJobResponse implements IUpdateJobResponse {
    job!: TerminalJob;

    constructor(data?: IUpdateJobResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.job = data.job && !(<any>data.job).toJSON ? new TerminalJob(data.job) : <TerminalJob>this.job;
        }
        if (!data) {
            this.job = new TerminalJob();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.job = _data["job"] ? TerminalJob.fromJS(_data["job"]) : new TerminalJob();
        }
    }

    static fromJS(data: any): UpdateJobResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateJobResponse {
    job: ITerminalJob;
}

export class UpdateJobRequest implements IUpdateJobRequest {
    name!: string;
    rowVersion!: string;

    constructor(data?: IUpdateJobRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): UpdateJobRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IUpdateJobRequest {
    name: string;
    rowVersion: string;
}

export class CreateInfoResponse implements ICreateInfoResponse {
    info?: TerminalInfo;

    constructor(data?: ICreateInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.info = data.info && !(<any>data.info).toJSON ? new TerminalInfo(data.info) : <TerminalInfo>this.info;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.info = _data["info"] ? TerminalInfo.fromJS(_data["info"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["info"] = this.info ? this.info.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateInfoResponse {
    info?: ITerminalInfo;
}

export class TerminalInfo implements ITerminalInfo {
    id?: string;
    description?: string | undefined;
    dateUtc?: Date;
    createdByName?: string;
    createdAtUtc?: Date;
    changedByName?: string | undefined;
    changedAtUtc?: Date | undefined;

    constructor(data?: ITerminalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.dateUtc = _data["dateUtc"] ? new Date(_data["dateUtc"].toString()) : <any>undefined;
            this.createdByName = _data["createdByName"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>undefined;
            this.changedByName = _data["changedByName"];
            this.changedAtUtc = _data["changedAtUtc"] ? new Date(_data["changedAtUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TerminalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["dateUtc"] = this.dateUtc ? this.dateUtc.toISOString() : <any>undefined;
        data["createdByName"] = this.createdByName;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : <any>undefined;
        data["changedByName"] = this.changedByName;
        data["changedAtUtc"] = this.changedAtUtc ? this.changedAtUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITerminalInfo {
    id?: string;
    description?: string | undefined;
    dateUtc?: Date;
    createdByName?: string;
    createdAtUtc?: Date;
    changedByName?: string | undefined;
    changedAtUtc?: Date | undefined;
}

export class CreateInfoRequest implements ICreateInfoRequest {
    id?: string;
    description?: string | undefined;
    dateUtc?: string;

    constructor(data?: ICreateInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.dateUtc = _data["dateUtc"];
        }
    }

    static fromJS(data: any): CreateInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["dateUtc"] = this.dateUtc;
        return data;
    }
}

export interface ICreateInfoRequest {
    id?: string;
    description?: string | undefined;
    dateUtc?: string;
}

export class UpdateInfoRequest implements IUpdateInfoRequest {
    description?: string;

    constructor(data?: IUpdateInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateInfoRequest {
    description?: string;
}

export class GetInfoListResponse implements IGetInfoListResponse {
    infoList!: TerminalInfo[];
    /** true if there are more infos on page n+1 */
    isFullPage?: boolean;

    constructor(data?: IGetInfoListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.infoList) {
                this.infoList = [];
                for (let i = 0; i < data.infoList.length; i++) {
                    let item = data.infoList[i];
                    this.infoList[i] = item && !(<any>item).toJSON ? new TerminalInfo(item) : <TerminalInfo>item;
                }
            }
        }
        if (!data) {
            this.infoList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["infoList"])) {
                this.infoList = [] as any;
                for (let item of _data["infoList"])
                    this.infoList!.push(TerminalInfo.fromJS(item));
            }
            this.isFullPage = _data["isFullPage"];
        }
    }

    static fromJS(data: any): GetInfoListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInfoListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.infoList)) {
            data["infoList"] = [];
            for (let item of this.infoList)
                data["infoList"].push(item.toJSON());
        }
        data["isFullPage"] = this.isFullPage;
        return data;
    }
}

export interface IGetInfoListResponse {
    infoList: ITerminalInfo[];
    /** true if there are more infos on page n+1 */
    isFullPage?: boolean;
}

export class GetTerminalStatementsResponse implements IGetTerminalStatementsResponse {
    terminalStatements?: TerminalStatement[];

    constructor(data?: IGetTerminalStatementsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.terminalStatements) {
                this.terminalStatements = [];
                for (let i = 0; i < data.terminalStatements.length; i++) {
                    let item = data.terminalStatements[i];
                    this.terminalStatements[i] = item && !(<any>item).toJSON ? new TerminalStatement(item) : <TerminalStatement>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["terminalStatements"])) {
                this.terminalStatements = [] as any;
                for (let item of _data["terminalStatements"])
                    this.terminalStatements!.push(TerminalStatement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTerminalStatementsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTerminalStatementsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.terminalStatements)) {
            data["terminalStatements"] = [];
            for (let item of this.terminalStatements)
                data["terminalStatements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTerminalStatementsResponse {
    terminalStatements?: ITerminalStatement[];
}

export class TerminalStatement implements ITerminalStatement {
    id!: string;
    name!: string;

    constructor(data?: ITerminalStatement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TerminalStatement {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalStatement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITerminalStatement {
    id: string;
    name: string;
}

export class TabletAppSettingResponse implements ITabletAppSettingResponse {
    /** Version control is handled by Intune. See WI 222 */
    minAppVersion?: number;
    /** Version control is handled by Intune. See WI 222 */
    appUpgradeUrl?: string;

    constructor(data?: ITabletAppSettingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minAppVersion = _data["minAppVersion"];
            this.appUpgradeUrl = _data["appUpgradeUrl"];
        }
    }

    static fromJS(data: any): TabletAppSettingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TabletAppSettingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minAppVersion"] = this.minAppVersion;
        data["appUpgradeUrl"] = this.appUpgradeUrl;
        return data;
    }
}

export interface ITabletAppSettingResponse {
    /** Version control is handled by Intune. See WI 222 */
    minAppVersion?: number;
    /** Version control is handled by Intune. See WI 222 */
    appUpgradeUrl?: string;
}

export class SetTabletAppSettingRequest implements ISetTabletAppSettingRequest {
    password?: string;
    validFron?: Date | undefined;
    minAppVersion?: number | undefined;
    appUpgradeUrl?: string;

    constructor(data?: ISetTabletAppSettingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.validFron = _data["validFron"] ? new Date(_data["validFron"].toString()) : <any>undefined;
            this.minAppVersion = _data["minAppVersion"];
            this.appUpgradeUrl = _data["appUpgradeUrl"];
        }
    }

    static fromJS(data: any): SetTabletAppSettingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetTabletAppSettingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["validFron"] = this.validFron ? this.validFron.toISOString() : <any>undefined;
        data["minAppVersion"] = this.minAppVersion;
        data["appUpgradeUrl"] = this.appUpgradeUrl;
        return data;
    }
}

export interface ISetTabletAppSettingRequest {
    password?: string;
    validFron?: Date | undefined;
    minAppVersion?: number | undefined;
    appUpgradeUrl?: string;
}

export class GetStorageItemListResponse implements IGetStorageItemListResponse {
    page?: number;
    storageItems?: StorageItemOverview[];
    pageTotal?: number;

    constructor(data?: IGetStorageItemListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.storageItems) {
                this.storageItems = [];
                for (let i = 0; i < data.storageItems.length; i++) {
                    let item = data.storageItems[i];
                    this.storageItems[i] = item && !(<any>item).toJSON ? new StorageItemOverview(item) : <StorageItemOverview>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            if (Array.isArray(_data["storageItems"])) {
                this.storageItems = [] as any;
                for (let item of _data["storageItems"])
                    this.storageItems!.push(StorageItemOverview.fromJS(item));
            }
            this.pageTotal = _data["pageTotal"];
        }
    }

    static fromJS(data: any): GetStorageItemListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStorageItemListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        if (Array.isArray(this.storageItems)) {
            data["storageItems"] = [];
            for (let item of this.storageItems)
                data["storageItems"].push(item.toJSON());
        }
        data["pageTotal"] = this.pageTotal;
        return data;
    }
}

export interface IGetStorageItemListResponse {
    page?: number;
    storageItems?: IStorageItemOverview[];
    pageTotal?: number;
}

export class StorageItemOverview implements IStorageItemOverview {
    id?: string;
    isDeleted?: boolean;
    externalId?: string;
    customerId?: string;
    description?: string;
    categoryCode?: string;
    fireClass?: string;
    isGoods?: boolean | undefined;
    isInventory?: boolean | undefined;
    baseUnitOfMeasure?: string;
    netInvoicedQuantity?: number | undefined;
    cO2PerUnit?: number | undefined;
    customerName?: string | undefined;
    quantity?: number | undefined;

    constructor(data?: IStorageItemOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.externalId = _data["externalId"];
            this.customerId = _data["customerId"];
            this.description = _data["description"];
            this.categoryCode = _data["categoryCode"];
            this.fireClass = _data["fireClass"];
            this.isGoods = _data["isGoods"];
            this.isInventory = _data["isInventory"];
            this.baseUnitOfMeasure = _data["baseUnitOfMeasure"];
            this.netInvoicedQuantity = _data["netInvoicedQuantity"];
            this.cO2PerUnit = _data["cO2PerUnit"];
            this.customerName = _data["customerName"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): StorageItemOverview {
        data = typeof data === 'object' ? data : {};
        let result = new StorageItemOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["externalId"] = this.externalId;
        data["customerId"] = this.customerId;
        data["description"] = this.description;
        data["categoryCode"] = this.categoryCode;
        data["fireClass"] = this.fireClass;
        data["isGoods"] = this.isGoods;
        data["isInventory"] = this.isInventory;
        data["baseUnitOfMeasure"] = this.baseUnitOfMeasure;
        data["netInvoicedQuantity"] = this.netInvoicedQuantity;
        data["cO2PerUnit"] = this.cO2PerUnit;
        data["customerName"] = this.customerName;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IStorageItemOverview {
    id?: string;
    isDeleted?: boolean;
    externalId?: string;
    customerId?: string;
    description?: string;
    categoryCode?: string;
    fireClass?: string;
    isGoods?: boolean | undefined;
    isInventory?: boolean | undefined;
    baseUnitOfMeasure?: string;
    netInvoicedQuantity?: number | undefined;
    cO2PerUnit?: number | undefined;
    customerName?: string | undefined;
    quantity?: number | undefined;
}

export class GetStorageItemListRequest implements IGetStorageItemListRequest {
    page?: number;
    keyword?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    hideZeroQuantity?: number | undefined;

    constructor(data?: IGetStorageItemListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.keyword = _data["keyword"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.hideZeroQuantity = _data["hideZeroQuantity"];
        }
    }

    static fromJS(data: any): GetStorageItemListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStorageItemListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["keyword"] = this.keyword;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["hideZeroQuantity"] = this.hideZeroQuantity;
        return data;
    }
}

export interface IGetStorageItemListRequest {
    page?: number;
    keyword?: string | undefined;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    hideZeroQuantity?: number | undefined;
}

export class GetStorageItemResponse implements IGetStorageItemResponse {
    customerName?: string;
    id?: string;
    isDeleted?: boolean;
    externalId?: string;
    customerId?: string;
    description?: string;
    categoryCode?: string;
    fireClass?: string;
    isGoods?: boolean | undefined;
    isInventory?: boolean | undefined;
    baseUnitOfMeasure?: string;
    netInvoicedQuantity?: number | undefined;
    cO2PerUnit?: number | undefined;
    quantity?: number | undefined;
    movementYears?: number[] | undefined;
    cO2Consumption?: number | undefined;

    constructor(data?: IGetStorageItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.externalId = _data["externalId"];
            this.customerId = _data["customerId"];
            this.description = _data["description"];
            this.categoryCode = _data["categoryCode"];
            this.fireClass = _data["fireClass"];
            this.isGoods = _data["isGoods"];
            this.isInventory = _data["isInventory"];
            this.baseUnitOfMeasure = _data["baseUnitOfMeasure"];
            this.netInvoicedQuantity = _data["netInvoicedQuantity"];
            this.cO2PerUnit = _data["cO2PerUnit"];
            this.quantity = _data["quantity"];
            if (Array.isArray(_data["movementYears"])) {
                this.movementYears = [] as any;
                for (let item of _data["movementYears"])
                    this.movementYears!.push(item);
            }
            this.cO2Consumption = _data["cO2Consumption"];
        }
    }

    static fromJS(data: any): GetStorageItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStorageItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["externalId"] = this.externalId;
        data["customerId"] = this.customerId;
        data["description"] = this.description;
        data["categoryCode"] = this.categoryCode;
        data["fireClass"] = this.fireClass;
        data["isGoods"] = this.isGoods;
        data["isInventory"] = this.isInventory;
        data["baseUnitOfMeasure"] = this.baseUnitOfMeasure;
        data["netInvoicedQuantity"] = this.netInvoicedQuantity;
        data["cO2PerUnit"] = this.cO2PerUnit;
        data["quantity"] = this.quantity;
        if (Array.isArray(this.movementYears)) {
            data["movementYears"] = [];
            for (let item of this.movementYears)
                data["movementYears"].push(item);
        }
        data["cO2Consumption"] = this.cO2Consumption;
        return data;
    }
}

export interface IGetStorageItemResponse {
    customerName?: string;
    id?: string;
    isDeleted?: boolean;
    externalId?: string;
    customerId?: string;
    description?: string;
    categoryCode?: string;
    fireClass?: string;
    isGoods?: boolean | undefined;
    isInventory?: boolean | undefined;
    baseUnitOfMeasure?: string;
    netInvoicedQuantity?: number | undefined;
    cO2PerUnit?: number | undefined;
    quantity?: number | undefined;
    movementYears?: number[] | undefined;
    cO2Consumption?: number | undefined;
}

export class GetStorageItemMovementListResponse implements IGetStorageItemMovementListResponse {
    page?: number;
    pageTotal?: number;
    storageItemMovements?: StorageItemMovement[];

    constructor(data?: IGetStorageItemMovementListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.storageItemMovements) {
                this.storageItemMovements = [];
                for (let i = 0; i < data.storageItemMovements.length; i++) {
                    let item = data.storageItemMovements[i];
                    this.storageItemMovements[i] = item && !(<any>item).toJSON ? new StorageItemMovement(item) : <StorageItemMovement>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageTotal = _data["pageTotal"];
            if (Array.isArray(_data["storageItemMovements"])) {
                this.storageItemMovements = [] as any;
                for (let item of _data["storageItemMovements"])
                    this.storageItemMovements!.push(StorageItemMovement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStorageItemMovementListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStorageItemMovementListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageTotal"] = this.pageTotal;
        if (Array.isArray(this.storageItemMovements)) {
            data["storageItemMovements"] = [];
            for (let item of this.storageItemMovements)
                data["storageItemMovements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStorageItemMovementListResponse {
    page?: number;
    pageTotal?: number;
    storageItemMovements?: IStorageItemMovement[];
}

export class StorageItemMovement implements IStorageItemMovement {
    externalId?: number;
    postingDate?: Date | undefined;
    lotNo?: string;
    description?: string;
    customerBatchNo?: string;
    quantity?: number | undefined;
    postingDateOnly?: Date | undefined;

    constructor(data?: IStorageItemMovement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.postingDate = _data["postingDate"] ? new Date(_data["postingDate"].toString()) : <any>undefined;
            this.lotNo = _data["lotNo"];
            this.description = _data["description"];
            this.customerBatchNo = _data["customerBatchNo"];
            this.quantity = _data["quantity"];
            this.postingDateOnly = _data["postingDateOnly"] ? new Date(_data["postingDateOnly"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StorageItemMovement {
        data = typeof data === 'object' ? data : {};
        let result = new StorageItemMovement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["lotNo"] = this.lotNo;
        data["description"] = this.description;
        data["customerBatchNo"] = this.customerBatchNo;
        data["quantity"] = this.quantity;
        data["postingDateOnly"] = this.postingDateOnly ? this.postingDateOnly.toISOString() : <any>undefined;
        return data;
    }
}

export interface IStorageItemMovement {
    externalId?: number;
    postingDate?: Date | undefined;
    lotNo?: string;
    description?: string;
    customerBatchNo?: string;
    quantity?: number | undefined;
    postingDateOnly?: Date | undefined;
}

export class GetStorageItemMovementListRequest implements IGetStorageItemMovementListRequest {
    page?: number;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    secondarySortColumn?: string | undefined;
    secondarySortDirection?: string | undefined;

    constructor(data?: IGetStorageItemMovementListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.secondarySortColumn = _data["secondarySortColumn"];
            this.secondarySortDirection = _data["secondarySortDirection"];
        }
    }

    static fromJS(data: any): GetStorageItemMovementListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStorageItemMovementListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["secondarySortColumn"] = this.secondarySortColumn;
        data["secondarySortDirection"] = this.secondarySortDirection;
        return data;
    }
}

export interface IGetStorageItemMovementListRequest {
    page?: number;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    secondarySortColumn?: string | undefined;
    secondarySortDirection?: string | undefined;
}

export class GetStorageItemMovementQuantityListResponse implements IGetStorageItemMovementQuantityListResponse {
    quantityList?: Quantity[];

    constructor(data?: IGetStorageItemMovementQuantityListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.quantityList) {
                this.quantityList = [];
                for (let i = 0; i < data.quantityList.length; i++) {
                    let item = data.quantityList[i];
                    this.quantityList[i] = item && !(<any>item).toJSON ? new Quantity(item) : <Quantity>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["quantityList"])) {
                this.quantityList = [] as any;
                for (let item of _data["quantityList"])
                    this.quantityList!.push(Quantity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStorageItemMovementQuantityListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStorageItemMovementQuantityListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.quantityList)) {
            data["quantityList"] = [];
            for (let item of this.quantityList)
                data["quantityList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStorageItemMovementQuantityListResponse {
    quantityList?: IQuantity[];
}

export class Quantity implements IQuantity {
    added?: number;
    removed?: number;
    month?: number;
    monthName?: string;

    constructor(data?: IQuantity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.added = _data["added"];
            this.removed = _data["removed"];
            this.month = _data["month"];
            this.monthName = _data["monthName"];
        }
    }

    static fromJS(data: any): Quantity {
        data = typeof data === 'object' ? data : {};
        let result = new Quantity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["added"] = this.added;
        data["removed"] = this.removed;
        data["month"] = this.month;
        data["monthName"] = this.monthName;
        return data;
    }
}

export interface IQuantity {
    added?: number;
    removed?: number;
    month?: number;
    monthName?: string;
}

export class GetStorageItemBinListResponse implements IGetStorageItemBinListResponse {
    page?: number;
    pageTotal?: number;
    storageItemBins?: StorageItemBin[];

    constructor(data?: IGetStorageItemBinListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.storageItemBins) {
                this.storageItemBins = [];
                for (let i = 0; i < data.storageItemBins.length; i++) {
                    let item = data.storageItemBins[i];
                    this.storageItemBins[i] = item && !(<any>item).toJSON ? new StorageItemBin(item) : <StorageItemBin>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageTotal = _data["pageTotal"];
            if (Array.isArray(_data["storageItemBins"])) {
                this.storageItemBins = [] as any;
                for (let item of _data["storageItemBins"])
                    this.storageItemBins!.push(StorageItemBin.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStorageItemBinListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStorageItemBinListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageTotal"] = this.pageTotal;
        if (Array.isArray(this.storageItemBins)) {
            data["storageItemBins"] = [];
            for (let item of this.storageItemBins)
                data["storageItemBins"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStorageItemBinListResponse {
    page?: number;
    pageTotal?: number;
    storageItemBins?: IStorageItemBin[];
}

export class StorageItemBin implements IStorageItemBin {
    binCode?: string;
    locationCode?: string;
    unitOfMeasure?: string;
    quantity?: number | undefined;

    constructor(data?: IStorageItemBin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.binCode = _data["binCode"];
            this.locationCode = _data["locationCode"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): StorageItemBin {
        data = typeof data === 'object' ? data : {};
        let result = new StorageItemBin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["binCode"] = this.binCode;
        data["locationCode"] = this.locationCode;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IStorageItemBin {
    binCode?: string;
    locationCode?: string;
    unitOfMeasure?: string;
    quantity?: number | undefined;
}

export class GetStorageItemBinListRequest implements IGetStorageItemBinListRequest {
    page?: number;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;

    constructor(data?: IGetStorageItemBinListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): GetStorageItemBinListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStorageItemBinListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface IGetStorageItemBinListRequest {
    page?: number;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
}

export class GetStorageTankListResponse implements IGetStorageTankListResponse {
    page?: number;
    pageTotal?: number;
    storageTanks?: StorageTank[];

    constructor(data?: IGetStorageTankListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.storageTanks) {
                this.storageTanks = [];
                for (let i = 0; i < data.storageTanks.length; i++) {
                    let item = data.storageTanks[i];
                    this.storageTanks[i] = item && !(<any>item).toJSON ? new StorageTank(item) : <StorageTank>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageTotal = _data["pageTotal"];
            if (Array.isArray(_data["storageTanks"])) {
                this.storageTanks = [] as any;
                for (let item of _data["storageTanks"])
                    this.storageTanks!.push(StorageTank.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStorageTankListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStorageTankListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageTotal"] = this.pageTotal;
        if (Array.isArray(this.storageTanks)) {
            data["storageTanks"] = [];
            for (let item of this.storageTanks)
                data["storageTanks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStorageTankListResponse {
    page?: number;
    pageTotal?: number;
    storageTanks?: IStorageTank[];
}

export class StorageTank implements IStorageTank {
    id?: string;
    externalId?: string;
    location?: string;
    testDate?: Date;

    constructor(data?: IStorageTank) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.location = _data["location"];
            this.testDate = _data["testDate"] ? new Date(_data["testDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StorageTank {
        data = typeof data === 'object' ? data : {};
        let result = new StorageTank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["location"] = this.location;
        data["testDate"] = this.testDate ? this.testDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IStorageTank {
    id?: string;
    externalId?: string;
    location?: string;
    testDate?: Date;
}

export class GetStorageTankListRequest implements IGetStorageTankListRequest {
    page?: number;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;

    constructor(data?: IGetStorageTankListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): GetStorageTankListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetStorageTankListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface IGetStorageTankListRequest {
    page?: number;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
}

export class GetStorageTankFilesResponse implements IGetStorageTankFilesResponse {
    storageTankFiles?: StorageTankFile[] | undefined;

    constructor(data?: IGetStorageTankFilesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.storageTankFiles) {
                this.storageTankFiles = [];
                for (let i = 0; i < data.storageTankFiles.length; i++) {
                    let item = data.storageTankFiles[i];
                    this.storageTankFiles[i] = item && !(<any>item).toJSON ? new StorageTankFile(item) : <StorageTankFile>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["storageTankFiles"])) {
                this.storageTankFiles = [] as any;
                for (let item of _data["storageTankFiles"])
                    this.storageTankFiles!.push(StorageTankFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStorageTankFilesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStorageTankFilesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.storageTankFiles)) {
            data["storageTankFiles"] = [];
            for (let item of this.storageTankFiles)
                data["storageTankFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStorageTankFilesResponse {
    storageTankFiles?: IStorageTankFile[] | undefined;
}

export class StorageTankFile implements IStorageTankFile {
    fileName?: string;
    fileExtension?: string;
    dateModified?: Date;

    constructor(data?: IStorageTankFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileExtension = _data["fileExtension"];
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StorageTankFile {
        data = typeof data === 'object' ? data : {};
        let result = new StorageTankFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileExtension"] = this.fileExtension;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IStorageTankFile {
    fileName?: string;
    fileExtension?: string;
    dateModified?: Date;
}

export class GetStorageItemMovementAccumulatedQuantityListResponse implements IGetStorageItemMovementAccumulatedQuantityListResponse {
    accumulatedQuantityList?: AccumulatedQuantity[];

    constructor(data?: IGetStorageItemMovementAccumulatedQuantityListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.accumulatedQuantityList) {
                this.accumulatedQuantityList = [];
                for (let i = 0; i < data.accumulatedQuantityList.length; i++) {
                    let item = data.accumulatedQuantityList[i];
                    this.accumulatedQuantityList[i] = item && !(<any>item).toJSON ? new AccumulatedQuantity(item) : <AccumulatedQuantity>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accumulatedQuantityList"])) {
                this.accumulatedQuantityList = [] as any;
                for (let item of _data["accumulatedQuantityList"])
                    this.accumulatedQuantityList!.push(AccumulatedQuantity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStorageItemMovementAccumulatedQuantityListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStorageItemMovementAccumulatedQuantityListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accumulatedQuantityList)) {
            data["accumulatedQuantityList"] = [];
            for (let item of this.accumulatedQuantityList)
                data["accumulatedQuantityList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStorageItemMovementAccumulatedQuantityListResponse {
    accumulatedQuantityList?: IAccumulatedQuantity[];
}

export class AccumulatedQuantity implements IAccumulatedQuantity {
    dateTime?: Date;
    total?: number;
    month?: number;
    year?: number;
    day?: number;
    dayMonth?: string;

    constructor(data?: IAccumulatedQuantity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.total = _data["total"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.day = _data["day"];
            this.dayMonth = _data["dayMonth"];
        }
    }

    static fromJS(data: any): AccumulatedQuantity {
        data = typeof data === 'object' ? data : {};
        let result = new AccumulatedQuantity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["month"] = this.month;
        data["year"] = this.year;
        data["day"] = this.day;
        data["dayMonth"] = this.dayMonth;
        return data;
    }
}

export interface IAccumulatedQuantity {
    dateTime?: Date;
    total?: number;
    month?: number;
    year?: number;
    day?: number;
    dayMonth?: string;
}

export class StevedoreForemanListResponse implements IStevedoreForemanListResponse {
    stevedoreForemen!: StevedoreForeman[];

    constructor(data?: IStevedoreForemanListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.stevedoreForemen) {
                this.stevedoreForemen = [];
                for (let i = 0; i < data.stevedoreForemen.length; i++) {
                    let item = data.stevedoreForemen[i];
                    this.stevedoreForemen[i] = item && !(<any>item).toJSON ? new StevedoreForeman(item) : <StevedoreForeman>item;
                }
            }
        }
        if (!data) {
            this.stevedoreForemen = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stevedoreForemen"])) {
                this.stevedoreForemen = [] as any;
                for (let item of _data["stevedoreForemen"])
                    this.stevedoreForemen!.push(StevedoreForeman.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StevedoreForemanListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StevedoreForemanListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stevedoreForemen)) {
            data["stevedoreForemen"] = [];
            for (let item of this.stevedoreForemen)
                data["stevedoreForemen"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStevedoreForemanListResponse {
    stevedoreForemen: IStevedoreForeman[];
}

export class StevedoreForeman implements IStevedoreForeman {
    id!: string;
    name!: string;

    constructor(data?: IStevedoreForeman) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StevedoreForeman {
        data = typeof data === 'object' ? data : {};
        let result = new StevedoreForeman();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IStevedoreForeman {
    id: string;
    name: string;
}

export class DeleteStevedoreForemanRequest implements IDeleteStevedoreForemanRequest {
    id!: string;

    constructor(data?: IDeleteStevedoreForemanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteStevedoreForemanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStevedoreForemanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteStevedoreForemanRequest {
    id: string;
}

export class GetResourceGroupResponse implements IGetResourceGroupResponse {
    resourceGroups!: string[];

    constructor(data?: IGetResourceGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.resourceGroups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["resourceGroups"])) {
                this.resourceGroups = [] as any;
                for (let item of _data["resourceGroups"])
                    this.resourceGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): GetResourceGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetResourceGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resourceGroups)) {
            data["resourceGroups"] = [];
            for (let item of this.resourceGroups)
                data["resourceGroups"].push(item);
        }
        return data;
    }
}

export interface IGetResourceGroupResponse {
    resourceGroups: string[];
}

export class GetResourceListResponse implements IGetResourceListResponse {
    resources?: ResourceItem[];

    constructor(data?: IGetResourceListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.resources) {
                this.resources = [];
                for (let i = 0; i < data.resources.length; i++) {
                    let item = data.resources[i];
                    this.resources[i] = item && !(<any>item).toJSON ? new ResourceItem(item) : <ResourceItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(ResourceItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetResourceListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetResourceListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetResourceListResponse {
    resources?: IResourceItem[];
}

export class ResourceItem implements IResourceItem {
    id!: string;
    name?: string;
    externalId!: string;
    email?: string | undefined;
    mobilePhone?: string | undefined;
    resourceGroupNo?: string;
    isWorker!: boolean;
    type!: ResourceType;
    licensePlate?: string | undefined;
    capacityText?: string | undefined;
    subType?: string | undefined;
    department?: string | undefined;

    constructor(data?: IResourceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.email = _data["email"];
            this.mobilePhone = _data["mobilePhone"];
            this.resourceGroupNo = _data["resourceGroupNo"];
            this.isWorker = _data["isWorker"];
            this.type = _data["type"];
            this.licensePlate = _data["licensePlate"];
            this.capacityText = _data["capacityText"];
            this.subType = _data["subType"];
            this.department = _data["department"];
        }
    }

    static fromJS(data: any): ResourceItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["email"] = this.email;
        data["mobilePhone"] = this.mobilePhone;
        data["resourceGroupNo"] = this.resourceGroupNo;
        data["isWorker"] = this.isWorker;
        data["type"] = this.type;
        data["licensePlate"] = this.licensePlate;
        data["capacityText"] = this.capacityText;
        data["subType"] = this.subType;
        data["department"] = this.department;
        return data;
    }
}

export interface IResourceItem {
    id: string;
    name?: string;
    externalId: string;
    email?: string | undefined;
    mobilePhone?: string | undefined;
    resourceGroupNo?: string;
    isWorker: boolean;
    type: ResourceType;
    licensePlate?: string | undefined;
    capacityText?: string | undefined;
    subType?: string | undefined;
    department?: string | undefined;
}

export enum ResourceType {
    Person = "Person",
    Machine = "Machine",
}

export class GetResourceRequest implements IGetResourceRequest {
    resourceGroups?: string[] | undefined;
    type?: string | undefined;
    department?: string | undefined;
    subType?: string | undefined;

    constructor(data?: IGetResourceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["resourceGroups"])) {
                this.resourceGroups = [] as any;
                for (let item of _data["resourceGroups"])
                    this.resourceGroups!.push(item);
            }
            this.type = _data["type"];
            this.department = _data["department"];
            this.subType = _data["subType"];
        }
    }

    static fromJS(data: any): GetResourceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetResourceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resourceGroups)) {
            data["resourceGroups"] = [];
            for (let item of this.resourceGroups)
                data["resourceGroups"].push(item);
        }
        data["type"] = this.type;
        data["department"] = this.department;
        data["subType"] = this.subType;
        return data;
    }
}

export interface IGetResourceRequest {
    resourceGroups?: string[] | undefined;
    type?: string | undefined;
    department?: string | undefined;
    subType?: string | undefined;
}

export class UpsertProjectQuestionnaireResponse implements IUpsertProjectQuestionnaireResponse {
    alreadyExisting!: boolean;

    constructor(data?: IUpsertProjectQuestionnaireResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alreadyExisting = _data["alreadyExisting"];
        }
    }

    static fromJS(data: any): UpsertProjectQuestionnaireResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertProjectQuestionnaireResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alreadyExisting"] = this.alreadyExisting;
        return data;
    }
}

export interface IUpsertProjectQuestionnaireResponse {
    alreadyExisting: boolean;
}

export class UpsertProjectQuestionnaireRequest implements IUpsertProjectQuestionnaireRequest {
    id!: string;
    projectId!: string;
    email!: string;
    answerDate!: Date;
    comment?: string | undefined;

    constructor(data?: IUpsertProjectQuestionnaireRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.email = _data["email"];
            this.answerDate = _data["answerDate"] ? new Date(_data["answerDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpsertProjectQuestionnaireRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertProjectQuestionnaireRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["email"] = this.email;
        data["answerDate"] = this.answerDate ? this.answerDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpsertProjectQuestionnaireRequest {
    id: string;
    projectId: string;
    email: string;
    answerDate: Date;
    comment?: string | undefined;
}

export class UpsertQuestionAnswerSetResponse implements IUpsertQuestionAnswerSetResponse {
    alreadyExisting?: boolean;

    constructor(data?: IUpsertQuestionAnswerSetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alreadyExisting = _data["alreadyExisting"];
        }
    }

    static fromJS(data: any): UpsertQuestionAnswerSetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertQuestionAnswerSetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alreadyExisting"] = this.alreadyExisting;
        return data;
    }
}

export interface IUpsertQuestionAnswerSetResponse {
    alreadyExisting?: boolean;
}

export class UpsertQuestionAnswerSetRequest implements IUpsertQuestionAnswerSetRequest {
    id!: string;
    projectId!: string;
    projectQuestionnaireId!: string;
    question!: Question;
    questionnaireAnswer!: QuetionnaireAnswer;

    constructor(data?: IUpsertQuestionAnswerSetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectQuestionnaireId = _data["projectQuestionnaireId"];
            this.question = _data["question"];
            this.questionnaireAnswer = _data["questionnaireAnswer"];
        }
    }

    static fromJS(data: any): UpsertQuestionAnswerSetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertQuestionAnswerSetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectQuestionnaireId"] = this.projectQuestionnaireId;
        data["question"] = this.question;
        data["questionnaireAnswer"] = this.questionnaireAnswer;
        return data;
    }
}

export interface IUpsertQuestionAnswerSetRequest {
    id: string;
    projectId: string;
    projectQuestionnaireId: string;
    question: Question;
    questionnaireAnswer: QuetionnaireAnswer;
}

export enum Question {
    HowWasYourExperience = "HowWasYourExperience",
    HowDidYouExperienceTheQuality = "HowDidYouExperienceTheQuality",
    HowDidYouExperienceTheCommunication = "HowDidYouExperienceTheCommunication",
    HowWouldYouRateYourOverallExperience = "HowWouldYouRateYourOverallExperience",
}

export enum QuetionnaireAnswer {
    Dissatisfied = "Dissatisfied",
    SomeWhatDissatisfied = "SomeWhatDissatisfied",
    ALillteBitDissatisfied = "ALillteBitDissatisfied",
    MinorInconvenience = "MinorInconvenience",
    NeitherSatisfiedorDissatisfied = "NeitherSatisfiedorDissatisfied",
    NotAnInconvenience = "NotAnInconvenience",
    ALillteBitSatisfied = "ALillteBitSatisfied",
    SomeWhatSatisfied = "SomeWhatSatisfied",
    Satisfied = "Satisfied",
    VerySatisfied = "VerySatisfied",
}

export class GetProjectListResponse implements IGetProjectListResponse {
    projects?: ProjectOverview[];
    isFullPage?: boolean;

    constructor(data?: IGetProjectListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.projects) {
                this.projects = [];
                for (let i = 0; i < data.projects.length; i++) {
                    let item = data.projects[i];
                    this.projects[i] = item && !(<any>item).toJSON ? new ProjectOverview(item) : <ProjectOverview>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectOverview.fromJS(item));
            }
            this.isFullPage = _data["isFullPage"];
        }
    }

    static fromJS(data: any): GetProjectListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        data["isFullPage"] = this.isFullPage;
        return data;
    }
}

export interface IGetProjectListResponse {
    projects?: IProjectOverview[];
    isFullPage?: boolean;
}

export class ProjectOverview implements IProjectOverview {
    id!: string;
    name!: string;
    created!: Date;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    lastChanged!: Date;
    customerId?: string | undefined;
    customerName?: string | undefined;
    projectStatus!: ProjectStatus;
    shipName!: string;
    caseNumber!: string;
    voyageNumber!: string;
    from!: string;
    to!: string;
    pilotOnboard!: string;
    expectedArrival!: DateTimeTba;
    expectedDeparture!: DateTimeTba;
    expectedArrivalNextPort?: DateTimeTba | undefined;
    owners!: string;
    port!: string;
    berth!: string;
    cargoDescription!: string;
    quantity?: number;
    weight?: number;
    internalNote?: string;
    esop?: Date | undefined;
    firstLine?: Date | undefined;
    allFast?: Date | undefined;
    norTendered?: Date | undefined;
    norReceived?: Date | undefined;
    opsCommenced?: DateTimeTba | undefined;
    opsCompleted?: DateTimeTba | undefined;
    loadingIn!: string;
    dischargeIn!: string;
    imoNumber!: string;
    flag!: string;
    reference!: string;
    customerRep!: string;
    stevedoreForeman?: string | undefined;
    stevedoreForemanName?: string | undefined;
    stevedoreForemanId?: string | undefined;
    opcAgent?: string | undefined;
    opcAgentName?: string | undefined;
    opcAgentId?: string | undefined;
    surveyor!: string;
    liftingSupervisor!: string;
    shipper!: PostalAddress;
    consignee!: PostalAddress;
    notifyAddress!: PostalAddress;
    customerIds?: string[];
    mailingListId?: string | undefined;
    craneType!: CraneType;
    shoreCraneBooked?: boolean | undefined;
    projectNumber!: number;
    importantInformation!: string;
    actualDeparture?: Date | undefined;
    tugBooked?: DateTimeTba | undefined;
    pilotBooked?: DateTimeTba | undefined;
    tenderedType?: TenderedType;
    receivedType?: ReceivedType;
    /** Called Operation Commenced in UI.  */
    operationsActuallyCommenced?: Date | undefined;
    /** Called Operation Completed in UI. */
    operationsActuallyCompleted?: Date | undefined;
    isProjectTemplate?: boolean | undefined;
    shipWeight?: number | undefined;

    constructor(data?: IProjectOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.expectedArrival = data.expectedArrival && !(<any>data.expectedArrival).toJSON ? new DateTimeTba(data.expectedArrival) : <DateTimeTba>this.expectedArrival;
            this.expectedDeparture = data.expectedDeparture && !(<any>data.expectedDeparture).toJSON ? new DateTimeTba(data.expectedDeparture) : <DateTimeTba>this.expectedDeparture;
            this.expectedArrivalNextPort = data.expectedArrivalNextPort && !(<any>data.expectedArrivalNextPort).toJSON ? new DateTimeTba(data.expectedArrivalNextPort) : <DateTimeTba>this.expectedArrivalNextPort;
            this.opsCommenced = data.opsCommenced && !(<any>data.opsCommenced).toJSON ? new DateTimeTba(data.opsCommenced) : <DateTimeTba>this.opsCommenced;
            this.opsCompleted = data.opsCompleted && !(<any>data.opsCompleted).toJSON ? new DateTimeTba(data.opsCompleted) : <DateTimeTba>this.opsCompleted;
            this.shipper = data.shipper && !(<any>data.shipper).toJSON ? new PostalAddress(data.shipper) : <PostalAddress>this.shipper;
            this.consignee = data.consignee && !(<any>data.consignee).toJSON ? new PostalAddress(data.consignee) : <PostalAddress>this.consignee;
            this.notifyAddress = data.notifyAddress && !(<any>data.notifyAddress).toJSON ? new PostalAddress(data.notifyAddress) : <PostalAddress>this.notifyAddress;
            this.tugBooked = data.tugBooked && !(<any>data.tugBooked).toJSON ? new DateTimeTba(data.tugBooked) : <DateTimeTba>this.tugBooked;
            this.pilotBooked = data.pilotBooked && !(<any>data.pilotBooked).toJSON ? new DateTimeTba(data.pilotBooked) : <DateTimeTba>this.pilotBooked;
        }
        if (!data) {
            this.expectedArrival = new DateTimeTba();
            this.expectedDeparture = new DateTimeTba();
            this.shipper = new PostalAddress();
            this.consignee = new PostalAddress();
            this.notifyAddress = new PostalAddress();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
            this.lastChanged = _data["lastChanged"] ? new Date(_data["lastChanged"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.projectStatus = _data["projectStatus"];
            this.shipName = _data["shipName"];
            this.caseNumber = _data["caseNumber"];
            this.voyageNumber = _data["voyageNumber"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.pilotOnboard = _data["pilotOnboard"];
            this.expectedArrival = _data["expectedArrival"] ? DateTimeTba.fromJS(_data["expectedArrival"]) : new DateTimeTba();
            this.expectedDeparture = _data["expectedDeparture"] ? DateTimeTba.fromJS(_data["expectedDeparture"]) : new DateTimeTba();
            this.expectedArrivalNextPort = _data["expectedArrivalNextPort"] ? DateTimeTba.fromJS(_data["expectedArrivalNextPort"]) : <any>undefined;
            this.owners = _data["owners"];
            this.port = _data["port"];
            this.berth = _data["berth"];
            this.cargoDescription = _data["cargoDescription"];
            this.quantity = _data["quantity"];
            this.weight = _data["weight"];
            this.internalNote = _data["internalNote"];
            this.esop = _data["esop"] ? new Date(_data["esop"].toString()) : <any>undefined;
            this.firstLine = _data["firstLine"] ? new Date(_data["firstLine"].toString()) : <any>undefined;
            this.allFast = _data["allFast"] ? new Date(_data["allFast"].toString()) : <any>undefined;
            this.norTendered = _data["norTendered"] ? new Date(_data["norTendered"].toString()) : <any>undefined;
            this.norReceived = _data["norReceived"] ? new Date(_data["norReceived"].toString()) : <any>undefined;
            this.opsCommenced = _data["opsCommenced"] ? DateTimeTba.fromJS(_data["opsCommenced"]) : <any>undefined;
            this.opsCompleted = _data["opsCompleted"] ? DateTimeTba.fromJS(_data["opsCompleted"]) : <any>undefined;
            this.loadingIn = _data["loadingIn"];
            this.dischargeIn = _data["dischargeIn"];
            this.imoNumber = _data["imoNumber"];
            this.flag = _data["flag"];
            this.reference = _data["reference"];
            this.customerRep = _data["customerRep"];
            this.stevedoreForeman = _data["stevedoreForeman"];
            this.stevedoreForemanName = _data["stevedoreForemanName"];
            this.stevedoreForemanId = _data["stevedoreForemanId"];
            this.opcAgent = _data["opcAgent"];
            this.opcAgentName = _data["opcAgentName"];
            this.opcAgentId = _data["opcAgentId"];
            this.surveyor = _data["surveyor"];
            this.liftingSupervisor = _data["liftingSupervisor"];
            this.shipper = _data["shipper"] ? PostalAddress.fromJS(_data["shipper"]) : new PostalAddress();
            this.consignee = _data["consignee"] ? PostalAddress.fromJS(_data["consignee"]) : new PostalAddress();
            this.notifyAddress = _data["notifyAddress"] ? PostalAddress.fromJS(_data["notifyAddress"]) : new PostalAddress();
            if (Array.isArray(_data["customerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["customerIds"])
                    this.customerIds!.push(item);
            }
            this.mailingListId = _data["mailingListId"];
            this.craneType = _data["craneType"];
            this.shoreCraneBooked = _data["shoreCraneBooked"];
            this.projectNumber = _data["projectNumber"];
            this.importantInformation = _data["importantInformation"];
            this.actualDeparture = _data["actualDeparture"] ? new Date(_data["actualDeparture"].toString()) : <any>undefined;
            this.tugBooked = _data["tugBooked"] ? DateTimeTba.fromJS(_data["tugBooked"]) : <any>undefined;
            this.pilotBooked = _data["pilotBooked"] ? DateTimeTba.fromJS(_data["pilotBooked"]) : <any>undefined;
            this.tenderedType = _data["tenderedType"];
            this.receivedType = _data["receivedType"];
            this.operationsActuallyCommenced = _data["operationsActuallyCommenced"] ? new Date(_data["operationsActuallyCommenced"].toString()) : <any>undefined;
            this.operationsActuallyCompleted = _data["operationsActuallyCompleted"] ? new Date(_data["operationsActuallyCompleted"].toString()) : <any>undefined;
            this.isProjectTemplate = _data["isProjectTemplate"];
            this.shipWeight = _data["shipWeight"];
        }
    }

    static fromJS(data: any): ProjectOverview {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        data["lastChanged"] = this.lastChanged ? this.lastChanged.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["projectStatus"] = this.projectStatus;
        data["shipName"] = this.shipName;
        data["caseNumber"] = this.caseNumber;
        data["voyageNumber"] = this.voyageNumber;
        data["from"] = this.from;
        data["to"] = this.to;
        data["pilotOnboard"] = this.pilotOnboard;
        data["expectedArrival"] = this.expectedArrival ? this.expectedArrival.toJSON() : <any>undefined;
        data["expectedDeparture"] = this.expectedDeparture ? this.expectedDeparture.toJSON() : <any>undefined;
        data["expectedArrivalNextPort"] = this.expectedArrivalNextPort ? this.expectedArrivalNextPort.toJSON() : <any>undefined;
        data["owners"] = this.owners;
        data["port"] = this.port;
        data["berth"] = this.berth;
        data["cargoDescription"] = this.cargoDescription;
        data["quantity"] = this.quantity;
        data["weight"] = this.weight;
        data["internalNote"] = this.internalNote;
        data["esop"] = this.esop ? this.esop.toISOString() : <any>undefined;
        data["firstLine"] = this.firstLine ? this.firstLine.toISOString() : <any>undefined;
        data["allFast"] = this.allFast ? this.allFast.toISOString() : <any>undefined;
        data["norTendered"] = this.norTendered ? this.norTendered.toISOString() : <any>undefined;
        data["norReceived"] = this.norReceived ? this.norReceived.toISOString() : <any>undefined;
        data["opsCommenced"] = this.opsCommenced ? this.opsCommenced.toJSON() : <any>undefined;
        data["opsCompleted"] = this.opsCompleted ? this.opsCompleted.toJSON() : <any>undefined;
        data["loadingIn"] = this.loadingIn;
        data["dischargeIn"] = this.dischargeIn;
        data["imoNumber"] = this.imoNumber;
        data["flag"] = this.flag;
        data["reference"] = this.reference;
        data["customerRep"] = this.customerRep;
        data["stevedoreForeman"] = this.stevedoreForeman;
        data["stevedoreForemanName"] = this.stevedoreForemanName;
        data["stevedoreForemanId"] = this.stevedoreForemanId;
        data["opcAgent"] = this.opcAgent;
        data["opcAgentName"] = this.opcAgentName;
        data["opcAgentId"] = this.opcAgentId;
        data["surveyor"] = this.surveyor;
        data["liftingSupervisor"] = this.liftingSupervisor;
        data["shipper"] = this.shipper ? this.shipper.toJSON() : <any>undefined;
        data["consignee"] = this.consignee ? this.consignee.toJSON() : <any>undefined;
        data["notifyAddress"] = this.notifyAddress ? this.notifyAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.customerIds)) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        data["mailingListId"] = this.mailingListId;
        data["craneType"] = this.craneType;
        data["shoreCraneBooked"] = this.shoreCraneBooked;
        data["projectNumber"] = this.projectNumber;
        data["importantInformation"] = this.importantInformation;
        data["actualDeparture"] = this.actualDeparture ? this.actualDeparture.toISOString() : <any>undefined;
        data["tugBooked"] = this.tugBooked ? this.tugBooked.toJSON() : <any>undefined;
        data["pilotBooked"] = this.pilotBooked ? this.pilotBooked.toJSON() : <any>undefined;
        data["tenderedType"] = this.tenderedType;
        data["receivedType"] = this.receivedType;
        data["operationsActuallyCommenced"] = this.operationsActuallyCommenced ? this.operationsActuallyCommenced.toISOString() : <any>undefined;
        data["operationsActuallyCompleted"] = this.operationsActuallyCompleted ? this.operationsActuallyCompleted.toISOString() : <any>undefined;
        data["isProjectTemplate"] = this.isProjectTemplate;
        data["shipWeight"] = this.shipWeight;
        return data;
    }
}

export interface IProjectOverview {
    id: string;
    name: string;
    created: Date;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    lastChanged: Date;
    customerId?: string | undefined;
    customerName?: string | undefined;
    projectStatus: ProjectStatus;
    shipName: string;
    caseNumber: string;
    voyageNumber: string;
    from: string;
    to: string;
    pilotOnboard: string;
    expectedArrival: IDateTimeTba;
    expectedDeparture: IDateTimeTba;
    expectedArrivalNextPort?: IDateTimeTba | undefined;
    owners: string;
    port: string;
    berth: string;
    cargoDescription: string;
    quantity?: number;
    weight?: number;
    internalNote?: string;
    esop?: Date | undefined;
    firstLine?: Date | undefined;
    allFast?: Date | undefined;
    norTendered?: Date | undefined;
    norReceived?: Date | undefined;
    opsCommenced?: IDateTimeTba | undefined;
    opsCompleted?: IDateTimeTba | undefined;
    loadingIn: string;
    dischargeIn: string;
    imoNumber: string;
    flag: string;
    reference: string;
    customerRep: string;
    stevedoreForeman?: string | undefined;
    stevedoreForemanName?: string | undefined;
    stevedoreForemanId?: string | undefined;
    opcAgent?: string | undefined;
    opcAgentName?: string | undefined;
    opcAgentId?: string | undefined;
    surveyor: string;
    liftingSupervisor: string;
    shipper: IPostalAddress;
    consignee: IPostalAddress;
    notifyAddress: IPostalAddress;
    customerIds?: string[];
    mailingListId?: string | undefined;
    craneType: CraneType;
    shoreCraneBooked?: boolean | undefined;
    projectNumber: number;
    importantInformation: string;
    actualDeparture?: Date | undefined;
    tugBooked?: IDateTimeTba | undefined;
    pilotBooked?: IDateTimeTba | undefined;
    tenderedType?: TenderedType;
    receivedType?: ReceivedType;
    /** Called Operation Commenced in UI.  */
    operationsActuallyCommenced?: Date | undefined;
    /** Called Operation Completed in UI. */
    operationsActuallyCompleted?: Date | undefined;
    isProjectTemplate?: boolean | undefined;
    shipWeight?: number | undefined;
}

export enum ProjectStatus {
    Initial = "Initial",
    Started = "Started",
    Completed = "Completed",
}

export class PostalAddress implements IPostalAddress {
    name!: string;
    address!: string;
    postalCode!: string;
    city!: string;
    country!: string;

    constructor(data?: IPostalAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): PostalAddress {
        data = typeof data === 'object' ? data : {};
        let result = new PostalAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        return data;
    }
}

export interface IPostalAddress {
    name: string;
    address: string;
    postalCode: string;
    city: string;
    country: string;
}

export enum CraneType {
    Unused = "Unused",
    Unknown = "Unknown",
    VesselGear = "VesselGear",
    PortCrane = "PortCrane",
    MobileCrane = "MobileCrane",
    RoRo = "RoRo",
    None = "None",
}

export enum TenderedType {
    Unsued = "Unsued",
    Unknown = "Unknown",
    None = "None",
    Date = "Date",
}

export enum ReceivedType {
    Unsued = "Unsued",
    Unknown = "Unknown",
    None = "None",
    Date = "Date",
}

export enum ProjectOrdering {
    DepartureDate = "DepartureDate",
    ArrivalDate = "ArrivalDate",
    Name = "Name",
    ShipName = "ShipName",
}

export class UpsertProjectResponse implements IUpsertProjectResponse {
    alreadyExisting!: boolean;
    projectNumber!: number;

    constructor(data?: IUpsertProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alreadyExisting = _data["alreadyExisting"];
            this.projectNumber = _data["projectNumber"];
        }
    }

    static fromJS(data: any): UpsertProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alreadyExisting"] = this.alreadyExisting;
        data["projectNumber"] = this.projectNumber;
        return data;
    }
}

export interface IUpsertProjectResponse {
    alreadyExisting: boolean;
    projectNumber: number;
}

export class UpsertProjectRequest implements IUpsertProjectRequest {
    projectId!: string;
    name!: string;
    shipName!: string;
    caseNumber!: string;
    voyageNumber!: string;
    from!: string;
    to?: string;
    expectedArrival!: DateTimeTba;
    expectedDeparture!: DateTimeTba;
    expectedArrivalNextPort?: DateTimeTba | undefined;
    internalNote?: string;
    owners?: string;
    port?: string;
    berth?: string;
    cargoDescription?: string;
    quantity?: number;
    weight?: number;
    esop?: Date | undefined;
    firstLine?: Date | undefined;
    allFast?: Date | undefined;
    norTendered?: Date | undefined;
    norReceived?: Date | undefined;
    opsCommenced?: DateTimeTba | undefined;
    opsCompleted?: DateTimeTba | undefined;
    loadingIn?: string;
    dischargeIn?: string;
    imoNumber?: string;
    flag?: string;
    reference?: string;
    customerRep?: string;
    stevedoreForemanId?: string | undefined;
    opcAgentId?: string | undefined;
    surveyor?: string;
    liftingSupervisor?: string;
    shipper?: PostalAddress;
    consignee?: PostalAddress;
    notifyAddress?: PostalAddress;
    customerIds?: string[];
    mailingListId?: string | undefined;
    craneType?: CraneType;
    shoreCraneBooked?: boolean | undefined;
    importantInformation?: string;
    actualDeparture?: Date | undefined;
    tugBooked?: DateTimeTba | undefined;
    isTugBooked?: boolean | undefined;
    pilotBooked?: DateTimeTba | undefined;
    isPilotBooked?: boolean;
    tenderedType?: TenderedType;
    receivedType?: ReceivedType;
    /** Called Operation Commenced in UI.  */
    operationsActuallyCommenced?: Date | undefined;
    /** Called Operation Completed in UI. */
    operationsActuallyCompleted?: Date | undefined;
    projectStatus?: ProjectStatus;
    isProjectTemplate?: boolean | undefined;
    informantOrderDate?: DateTimeTba | undefined;
    informantOrderShip?: string;
    informantOrderPort?: string;
    informantOrderCase?: string;
    informantOrderJob?: string;
    informantOrderMachine?: string;
    informantOrderMachineJobNumber?: string;
    informantOrderReady?: string;
    informantOrderNote?: string;
    terminalStatementMultipleMachines?: string;
    terminalStatementNote?: string;
    terminalStatementJobNumber?: string;
    shipWeight?: number;
    informantOrderReadyDate?: DateTimeTba | undefined;
    projectTerminalStatements?: ProjectTerminalStatement[];
    /** Using Shore Power (True) or Vessel Power (False) */
    usingShorePower?: boolean;
    sendHasQuayManOrTerminalCalculationChanged?: boolean | undefined;

    constructor(data?: IUpsertProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.expectedArrival = data.expectedArrival && !(<any>data.expectedArrival).toJSON ? new DateTimeTba(data.expectedArrival) : <DateTimeTba>this.expectedArrival;
            this.expectedDeparture = data.expectedDeparture && !(<any>data.expectedDeparture).toJSON ? new DateTimeTba(data.expectedDeparture) : <DateTimeTba>this.expectedDeparture;
            this.expectedArrivalNextPort = data.expectedArrivalNextPort && !(<any>data.expectedArrivalNextPort).toJSON ? new DateTimeTba(data.expectedArrivalNextPort) : <DateTimeTba>this.expectedArrivalNextPort;
            this.opsCommenced = data.opsCommenced && !(<any>data.opsCommenced).toJSON ? new DateTimeTba(data.opsCommenced) : <DateTimeTba>this.opsCommenced;
            this.opsCompleted = data.opsCompleted && !(<any>data.opsCompleted).toJSON ? new DateTimeTba(data.opsCompleted) : <DateTimeTba>this.opsCompleted;
            this.shipper = data.shipper && !(<any>data.shipper).toJSON ? new PostalAddress(data.shipper) : <PostalAddress>this.shipper;
            this.consignee = data.consignee && !(<any>data.consignee).toJSON ? new PostalAddress(data.consignee) : <PostalAddress>this.consignee;
            this.notifyAddress = data.notifyAddress && !(<any>data.notifyAddress).toJSON ? new PostalAddress(data.notifyAddress) : <PostalAddress>this.notifyAddress;
            this.tugBooked = data.tugBooked && !(<any>data.tugBooked).toJSON ? new DateTimeTba(data.tugBooked) : <DateTimeTba>this.tugBooked;
            this.pilotBooked = data.pilotBooked && !(<any>data.pilotBooked).toJSON ? new DateTimeTba(data.pilotBooked) : <DateTimeTba>this.pilotBooked;
            this.informantOrderDate = data.informantOrderDate && !(<any>data.informantOrderDate).toJSON ? new DateTimeTba(data.informantOrderDate) : <DateTimeTba>this.informantOrderDate;
            this.informantOrderReadyDate = data.informantOrderReadyDate && !(<any>data.informantOrderReadyDate).toJSON ? new DateTimeTba(data.informantOrderReadyDate) : <DateTimeTba>this.informantOrderReadyDate;
            if (data.projectTerminalStatements) {
                this.projectTerminalStatements = [];
                for (let i = 0; i < data.projectTerminalStatements.length; i++) {
                    let item = data.projectTerminalStatements[i];
                    this.projectTerminalStatements[i] = item && !(<any>item).toJSON ? new ProjectTerminalStatement(item) : <ProjectTerminalStatement>item;
                }
            }
        }
        if (!data) {
            this.expectedArrival = new DateTimeTba();
            this.expectedDeparture = new DateTimeTba();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.shipName = _data["shipName"];
            this.caseNumber = _data["caseNumber"];
            this.voyageNumber = _data["voyageNumber"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.expectedArrival = _data["expectedArrival"] ? DateTimeTba.fromJS(_data["expectedArrival"]) : new DateTimeTba();
            this.expectedDeparture = _data["expectedDeparture"] ? DateTimeTba.fromJS(_data["expectedDeparture"]) : new DateTimeTba();
            this.expectedArrivalNextPort = _data["expectedArrivalNextPort"] ? DateTimeTba.fromJS(_data["expectedArrivalNextPort"]) : <any>undefined;
            this.internalNote = _data["internalNote"];
            this.owners = _data["owners"];
            this.port = _data["port"];
            this.berth = _data["berth"];
            this.cargoDescription = _data["cargoDescription"];
            this.quantity = _data["quantity"];
            this.weight = _data["weight"];
            this.esop = _data["esop"] ? new Date(_data["esop"].toString()) : <any>undefined;
            this.firstLine = _data["firstLine"] ? new Date(_data["firstLine"].toString()) : <any>undefined;
            this.allFast = _data["allFast"] ? new Date(_data["allFast"].toString()) : <any>undefined;
            this.norTendered = _data["norTendered"] ? new Date(_data["norTendered"].toString()) : <any>undefined;
            this.norReceived = _data["norReceived"] ? new Date(_data["norReceived"].toString()) : <any>undefined;
            this.opsCommenced = _data["opsCommenced"] ? DateTimeTba.fromJS(_data["opsCommenced"]) : <any>undefined;
            this.opsCompleted = _data["opsCompleted"] ? DateTimeTba.fromJS(_data["opsCompleted"]) : <any>undefined;
            this.loadingIn = _data["loadingIn"];
            this.dischargeIn = _data["dischargeIn"];
            this.imoNumber = _data["imoNumber"];
            this.flag = _data["flag"];
            this.reference = _data["reference"];
            this.customerRep = _data["customerRep"];
            this.stevedoreForemanId = _data["stevedoreForemanId"];
            this.opcAgentId = _data["opcAgentId"];
            this.surveyor = _data["surveyor"];
            this.liftingSupervisor = _data["liftingSupervisor"];
            this.shipper = _data["shipper"] ? PostalAddress.fromJS(_data["shipper"]) : <any>undefined;
            this.consignee = _data["consignee"] ? PostalAddress.fromJS(_data["consignee"]) : <any>undefined;
            this.notifyAddress = _data["notifyAddress"] ? PostalAddress.fromJS(_data["notifyAddress"]) : <any>undefined;
            if (Array.isArray(_data["customerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["customerIds"])
                    this.customerIds!.push(item);
            }
            this.mailingListId = _data["mailingListId"];
            this.craneType = _data["craneType"];
            this.shoreCraneBooked = _data["shoreCraneBooked"];
            this.importantInformation = _data["importantInformation"];
            this.actualDeparture = _data["actualDeparture"] ? new Date(_data["actualDeparture"].toString()) : <any>undefined;
            this.tugBooked = _data["tugBooked"] ? DateTimeTba.fromJS(_data["tugBooked"]) : <any>undefined;
            this.isTugBooked = _data["isTugBooked"];
            this.pilotBooked = _data["pilotBooked"] ? DateTimeTba.fromJS(_data["pilotBooked"]) : <any>undefined;
            this.isPilotBooked = _data["isPilotBooked"];
            this.tenderedType = _data["tenderedType"];
            this.receivedType = _data["receivedType"];
            this.operationsActuallyCommenced = _data["operationsActuallyCommenced"] ? new Date(_data["operationsActuallyCommenced"].toString()) : <any>undefined;
            this.operationsActuallyCompleted = _data["operationsActuallyCompleted"] ? new Date(_data["operationsActuallyCompleted"].toString()) : <any>undefined;
            this.projectStatus = _data["projectStatus"];
            this.isProjectTemplate = _data["isProjectTemplate"];
            this.informantOrderDate = _data["informantOrderDate"] ? DateTimeTba.fromJS(_data["informantOrderDate"]) : <any>undefined;
            this.informantOrderShip = _data["informantOrderShip"];
            this.informantOrderPort = _data["informantOrderPort"];
            this.informantOrderCase = _data["informantOrderCase"];
            this.informantOrderJob = _data["informantOrderJob"];
            this.informantOrderMachine = _data["informantOrderMachine"];
            this.informantOrderMachineJobNumber = _data["informantOrderMachineJobNumber"];
            this.informantOrderReady = _data["informantOrderReady"];
            this.informantOrderNote = _data["informantOrderNote"];
            this.terminalStatementMultipleMachines = _data["terminalStatementMultipleMachines"];
            this.terminalStatementNote = _data["terminalStatementNote"];
            this.terminalStatementJobNumber = _data["terminalStatementJobNumber"];
            this.shipWeight = _data["shipWeight"];
            this.informantOrderReadyDate = _data["informantOrderReadyDate"] ? DateTimeTba.fromJS(_data["informantOrderReadyDate"]) : <any>undefined;
            if (Array.isArray(_data["projectTerminalStatements"])) {
                this.projectTerminalStatements = [] as any;
                for (let item of _data["projectTerminalStatements"])
                    this.projectTerminalStatements!.push(ProjectTerminalStatement.fromJS(item));
            }
            this.usingShorePower = _data["usingShorePower"];
            this.sendHasQuayManOrTerminalCalculationChanged = _data["sendHasQuayManOrTerminalCalculationChanged"];
        }
    }

    static fromJS(data: any): UpsertProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["shipName"] = this.shipName;
        data["caseNumber"] = this.caseNumber;
        data["voyageNumber"] = this.voyageNumber;
        data["from"] = this.from;
        data["to"] = this.to;
        data["expectedArrival"] = this.expectedArrival ? this.expectedArrival.toJSON() : <any>undefined;
        data["expectedDeparture"] = this.expectedDeparture ? this.expectedDeparture.toJSON() : <any>undefined;
        data["expectedArrivalNextPort"] = this.expectedArrivalNextPort ? this.expectedArrivalNextPort.toJSON() : <any>undefined;
        data["internalNote"] = this.internalNote;
        data["owners"] = this.owners;
        data["port"] = this.port;
        data["berth"] = this.berth;
        data["cargoDescription"] = this.cargoDescription;
        data["quantity"] = this.quantity;
        data["weight"] = this.weight;
        data["esop"] = this.esop ? this.esop.toISOString() : <any>undefined;
        data["firstLine"] = this.firstLine ? this.firstLine.toISOString() : <any>undefined;
        data["allFast"] = this.allFast ? this.allFast.toISOString() : <any>undefined;
        data["norTendered"] = this.norTendered ? this.norTendered.toISOString() : <any>undefined;
        data["norReceived"] = this.norReceived ? this.norReceived.toISOString() : <any>undefined;
        data["opsCommenced"] = this.opsCommenced ? this.opsCommenced.toJSON() : <any>undefined;
        data["opsCompleted"] = this.opsCompleted ? this.opsCompleted.toJSON() : <any>undefined;
        data["loadingIn"] = this.loadingIn;
        data["dischargeIn"] = this.dischargeIn;
        data["imoNumber"] = this.imoNumber;
        data["flag"] = this.flag;
        data["reference"] = this.reference;
        data["customerRep"] = this.customerRep;
        data["stevedoreForemanId"] = this.stevedoreForemanId;
        data["opcAgentId"] = this.opcAgentId;
        data["surveyor"] = this.surveyor;
        data["liftingSupervisor"] = this.liftingSupervisor;
        data["shipper"] = this.shipper ? this.shipper.toJSON() : <any>undefined;
        data["consignee"] = this.consignee ? this.consignee.toJSON() : <any>undefined;
        data["notifyAddress"] = this.notifyAddress ? this.notifyAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.customerIds)) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        data["mailingListId"] = this.mailingListId;
        data["craneType"] = this.craneType;
        data["shoreCraneBooked"] = this.shoreCraneBooked;
        data["importantInformation"] = this.importantInformation;
        data["actualDeparture"] = this.actualDeparture ? this.actualDeparture.toISOString() : <any>undefined;
        data["tugBooked"] = this.tugBooked ? this.tugBooked.toJSON() : <any>undefined;
        data["isTugBooked"] = this.isTugBooked;
        data["pilotBooked"] = this.pilotBooked ? this.pilotBooked.toJSON() : <any>undefined;
        data["isPilotBooked"] = this.isPilotBooked;
        data["tenderedType"] = this.tenderedType;
        data["receivedType"] = this.receivedType;
        data["operationsActuallyCommenced"] = this.operationsActuallyCommenced ? this.operationsActuallyCommenced.toISOString() : <any>undefined;
        data["operationsActuallyCompleted"] = this.operationsActuallyCompleted ? this.operationsActuallyCompleted.toISOString() : <any>undefined;
        data["projectStatus"] = this.projectStatus;
        data["isProjectTemplate"] = this.isProjectTemplate;
        data["informantOrderDate"] = this.informantOrderDate ? this.informantOrderDate.toJSON() : <any>undefined;
        data["informantOrderShip"] = this.informantOrderShip;
        data["informantOrderPort"] = this.informantOrderPort;
        data["informantOrderCase"] = this.informantOrderCase;
        data["informantOrderJob"] = this.informantOrderJob;
        data["informantOrderMachine"] = this.informantOrderMachine;
        data["informantOrderMachineJobNumber"] = this.informantOrderMachineJobNumber;
        data["informantOrderReady"] = this.informantOrderReady;
        data["informantOrderNote"] = this.informantOrderNote;
        data["terminalStatementMultipleMachines"] = this.terminalStatementMultipleMachines;
        data["terminalStatementNote"] = this.terminalStatementNote;
        data["terminalStatementJobNumber"] = this.terminalStatementJobNumber;
        data["shipWeight"] = this.shipWeight;
        data["informantOrderReadyDate"] = this.informantOrderReadyDate ? this.informantOrderReadyDate.toJSON() : <any>undefined;
        if (Array.isArray(this.projectTerminalStatements)) {
            data["projectTerminalStatements"] = [];
            for (let item of this.projectTerminalStatements)
                data["projectTerminalStatements"].push(item.toJSON());
        }
        data["usingShorePower"] = this.usingShorePower;
        data["sendHasQuayManOrTerminalCalculationChanged"] = this.sendHasQuayManOrTerminalCalculationChanged;
        return data;
    }
}

export interface IUpsertProjectRequest {
    projectId: string;
    name: string;
    shipName: string;
    caseNumber: string;
    voyageNumber: string;
    from: string;
    to?: string;
    expectedArrival: IDateTimeTba;
    expectedDeparture: IDateTimeTba;
    expectedArrivalNextPort?: IDateTimeTba | undefined;
    internalNote?: string;
    owners?: string;
    port?: string;
    berth?: string;
    cargoDescription?: string;
    quantity?: number;
    weight?: number;
    esop?: Date | undefined;
    firstLine?: Date | undefined;
    allFast?: Date | undefined;
    norTendered?: Date | undefined;
    norReceived?: Date | undefined;
    opsCommenced?: IDateTimeTba | undefined;
    opsCompleted?: IDateTimeTba | undefined;
    loadingIn?: string;
    dischargeIn?: string;
    imoNumber?: string;
    flag?: string;
    reference?: string;
    customerRep?: string;
    stevedoreForemanId?: string | undefined;
    opcAgentId?: string | undefined;
    surveyor?: string;
    liftingSupervisor?: string;
    shipper?: IPostalAddress;
    consignee?: IPostalAddress;
    notifyAddress?: IPostalAddress;
    customerIds?: string[];
    mailingListId?: string | undefined;
    craneType?: CraneType;
    shoreCraneBooked?: boolean | undefined;
    importantInformation?: string;
    actualDeparture?: Date | undefined;
    tugBooked?: IDateTimeTba | undefined;
    isTugBooked?: boolean | undefined;
    pilotBooked?: IDateTimeTba | undefined;
    isPilotBooked?: boolean;
    tenderedType?: TenderedType;
    receivedType?: ReceivedType;
    /** Called Operation Commenced in UI.  */
    operationsActuallyCommenced?: Date | undefined;
    /** Called Operation Completed in UI. */
    operationsActuallyCompleted?: Date | undefined;
    projectStatus?: ProjectStatus;
    isProjectTemplate?: boolean | undefined;
    informantOrderDate?: IDateTimeTba | undefined;
    informantOrderShip?: string;
    informantOrderPort?: string;
    informantOrderCase?: string;
    informantOrderJob?: string;
    informantOrderMachine?: string;
    informantOrderMachineJobNumber?: string;
    informantOrderReady?: string;
    informantOrderNote?: string;
    terminalStatementMultipleMachines?: string;
    terminalStatementNote?: string;
    terminalStatementJobNumber?: string;
    shipWeight?: number;
    informantOrderReadyDate?: IDateTimeTba | undefined;
    projectTerminalStatements?: IProjectTerminalStatement[];
    /** Using Shore Power (True) or Vessel Power (False) */
    usingShorePower?: boolean;
    sendHasQuayManOrTerminalCalculationChanged?: boolean | undefined;
}

export class ProjectTerminalStatement implements IProjectTerminalStatement {
    id?: string;
    terminalStatementId?: string;
    date?: Date;
    value?: number;

    constructor(data?: IProjectTerminalStatement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.terminalStatementId = _data["terminalStatementId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProjectTerminalStatement {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTerminalStatement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["terminalStatementId"] = this.terminalStatementId;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface IProjectTerminalStatement {
    id?: string;
    terminalStatementId?: string;
    date?: Date;
    value?: number;
}

export class EditInternalNoteRequest implements IEditInternalNoteRequest {
    projectId?: string;
    internalNote?: string;

    constructor(data?: IEditInternalNoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.internalNote = _data["internalNote"];
        }
    }

    static fromJS(data: any): EditInternalNoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditInternalNoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["internalNote"] = this.internalNote;
        return data;
    }
}

export interface IEditInternalNoteRequest {
    projectId?: string;
    internalNote?: string;
}

export class GetProjectDetailsResponse implements IGetProjectDetailsResponse {
    id!: string;
    name!: string;
    created!: Date;
    createdByName?: string | undefined;
    createdById?: string | undefined;
    lastChanged!: Date;
    lastChangedByName?: string | undefined;
    lastChangedById?: string | undefined;
    projectStatus!: ProjectStatus;
    shipName!: string;
    caseNumber!: string;
    voyageNumber!: string;
    from!: string;
    to!: string;
    pilotOnboard!: string;
    expectedArrival!: DateTimeTba;
    expectedDeparture!: DateTimeTba;
    expectedArrivalNextPort?: DateTimeTba | undefined;
    owners?: string;
    port?: string;
    berth?: string;
    cargoDescription?: string;
    quantity?: number;
    weight?: number;
    esop?: Date | undefined;
    firstLine?: Date | undefined;
    allFast?: Date | undefined;
    norTendered?: Date | undefined;
    norReceived?: Date | undefined;
    opsCommenced?: DateTimeTba | undefined;
    opsCompleted?: DateTimeTba | undefined;
    loadingIn?: string;
    dischargeIn?: string;
    imoNumber?: string;
    flag?: string;
    reference?: string;
    stevedoreForeman?: string | undefined;
    stevedoreForemanName?: string | undefined;
    stevedoreForemanId?: string | undefined;
    opcAgent?: string | undefined;
    opcAgentName?: string | undefined;
    opcAgentId?: string | undefined;
    customerRep?: string;
    surveyor?: string;
    liftingSupervisor?: string;
    shipper?: PostalAddress;
    consignee?: PostalAddress;
    notifyAddress?: PostalAddress;
    components!: Component[];
    gangs!: Gang[];
    events!: Event[];
    projectCustomers!: ProjectCustomer[];
    mailingListId?: string | undefined;
    craneType!: CraneType;
    shoreCraneBooked?: boolean | undefined;
    projectNumber!: number;
    internalNote?: string;
    informantOrderDate?: DateTimeTba | undefined;
    informantOrderShip?: string;
    informantOrderPort?: string;
    informantOrderCase?: string;
    informantOrderJob?: string;
    informantOrderMachine?: string;
    informantOrderMachineJobNumber?: string;
    informantOrderReady?: string;
    informantOrderNote?: string;
    informantOrderReadyDate?: DateTimeTba | undefined;
    terminalStatementDate?: DateTimeTba | undefined;
    terminalStatementSalery?: string;
    terminalStatementMultipleMachines?: string;
    terminalStatementNote?: string;
    terminalStatementJobNumber?: string;
    importantInformation!: string;
    actualDeparture?: Date | undefined;
    tugBooked?: DateTimeTba | undefined;
    isTugBooked?: boolean;
    pilotBooked?: DateTimeTba | undefined;
    isPilotBooked?: boolean;
    isProjectTemplate?: boolean | undefined;
    tenderedType?: TenderedType;
    receivedType?: ReceivedType;
    /** Called Operation Commenced in UI.  */
    operationsActuallyCommenced?: Date | undefined;
    /** Called Operation Completed in UI. */
    operationsActuallyCompleted?: Date | undefined;
    shipWeight?: number | undefined;
    projectTerminalStatements?: ProjectTerminalStatement2[];
    /** Using Shore Power (True) or Vessel Power (False) */
    usingShorePower?: boolean;

    constructor(data?: IGetProjectDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.expectedArrival = data.expectedArrival && !(<any>data.expectedArrival).toJSON ? new DateTimeTba(data.expectedArrival) : <DateTimeTba>this.expectedArrival;
            this.expectedDeparture = data.expectedDeparture && !(<any>data.expectedDeparture).toJSON ? new DateTimeTba(data.expectedDeparture) : <DateTimeTba>this.expectedDeparture;
            this.expectedArrivalNextPort = data.expectedArrivalNextPort && !(<any>data.expectedArrivalNextPort).toJSON ? new DateTimeTba(data.expectedArrivalNextPort) : <DateTimeTba>this.expectedArrivalNextPort;
            this.opsCommenced = data.opsCommenced && !(<any>data.opsCommenced).toJSON ? new DateTimeTba(data.opsCommenced) : <DateTimeTba>this.opsCommenced;
            this.opsCompleted = data.opsCompleted && !(<any>data.opsCompleted).toJSON ? new DateTimeTba(data.opsCompleted) : <DateTimeTba>this.opsCompleted;
            this.shipper = data.shipper && !(<any>data.shipper).toJSON ? new PostalAddress(data.shipper) : <PostalAddress>this.shipper;
            this.consignee = data.consignee && !(<any>data.consignee).toJSON ? new PostalAddress(data.consignee) : <PostalAddress>this.consignee;
            this.notifyAddress = data.notifyAddress && !(<any>data.notifyAddress).toJSON ? new PostalAddress(data.notifyAddress) : <PostalAddress>this.notifyAddress;
            if (data.components) {
                this.components = [];
                for (let i = 0; i < data.components.length; i++) {
                    let item = data.components[i];
                    this.components[i] = item && !(<any>item).toJSON ? new Component(item) : <Component>item;
                }
            }
            if (data.gangs) {
                this.gangs = [];
                for (let i = 0; i < data.gangs.length; i++) {
                    let item = data.gangs[i];
                    this.gangs[i] = item && !(<any>item).toJSON ? new Gang(item) : <Gang>item;
                }
            }
            if (data.events) {
                this.events = [];
                for (let i = 0; i < data.events.length; i++) {
                    let item = data.events[i];
                    this.events[i] = item && !(<any>item).toJSON ? new Event(item) : <Event>item;
                }
            }
            if (data.projectCustomers) {
                this.projectCustomers = [];
                for (let i = 0; i < data.projectCustomers.length; i++) {
                    let item = data.projectCustomers[i];
                    this.projectCustomers[i] = item && !(<any>item).toJSON ? new ProjectCustomer(item) : <ProjectCustomer>item;
                }
            }
            this.informantOrderDate = data.informantOrderDate && !(<any>data.informantOrderDate).toJSON ? new DateTimeTba(data.informantOrderDate) : <DateTimeTba>this.informantOrderDate;
            this.informantOrderReadyDate = data.informantOrderReadyDate && !(<any>data.informantOrderReadyDate).toJSON ? new DateTimeTba(data.informantOrderReadyDate) : <DateTimeTba>this.informantOrderReadyDate;
            this.terminalStatementDate = data.terminalStatementDate && !(<any>data.terminalStatementDate).toJSON ? new DateTimeTba(data.terminalStatementDate) : <DateTimeTba>this.terminalStatementDate;
            this.tugBooked = data.tugBooked && !(<any>data.tugBooked).toJSON ? new DateTimeTba(data.tugBooked) : <DateTimeTba>this.tugBooked;
            this.pilotBooked = data.pilotBooked && !(<any>data.pilotBooked).toJSON ? new DateTimeTba(data.pilotBooked) : <DateTimeTba>this.pilotBooked;
            if (data.projectTerminalStatements) {
                this.projectTerminalStatements = [];
                for (let i = 0; i < data.projectTerminalStatements.length; i++) {
                    let item = data.projectTerminalStatements[i];
                    this.projectTerminalStatements[i] = item && !(<any>item).toJSON ? new ProjectTerminalStatement2(item) : <ProjectTerminalStatement2>item;
                }
            }
        }
        if (!data) {
            this.expectedArrival = new DateTimeTba();
            this.expectedDeparture = new DateTimeTba();
            this.components = [];
            this.gangs = [];
            this.events = [];
            this.projectCustomers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdByName = _data["createdByName"];
            this.createdById = _data["createdById"];
            this.lastChanged = _data["lastChanged"] ? new Date(_data["lastChanged"].toString()) : <any>undefined;
            this.lastChangedByName = _data["lastChangedByName"];
            this.lastChangedById = _data["lastChangedById"];
            this.projectStatus = _data["projectStatus"];
            this.shipName = _data["shipName"];
            this.caseNumber = _data["caseNumber"];
            this.voyageNumber = _data["voyageNumber"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.pilotOnboard = _data["pilotOnboard"];
            this.expectedArrival = _data["expectedArrival"] ? DateTimeTba.fromJS(_data["expectedArrival"]) : new DateTimeTba();
            this.expectedDeparture = _data["expectedDeparture"] ? DateTimeTba.fromJS(_data["expectedDeparture"]) : new DateTimeTba();
            this.expectedArrivalNextPort = _data["expectedArrivalNextPort"] ? DateTimeTba.fromJS(_data["expectedArrivalNextPort"]) : <any>undefined;
            this.owners = _data["owners"];
            this.port = _data["port"];
            this.berth = _data["berth"];
            this.cargoDescription = _data["cargoDescription"];
            this.quantity = _data["quantity"];
            this.weight = _data["weight"];
            this.esop = _data["esop"] ? new Date(_data["esop"].toString()) : <any>undefined;
            this.firstLine = _data["firstLine"] ? new Date(_data["firstLine"].toString()) : <any>undefined;
            this.allFast = _data["allFast"] ? new Date(_data["allFast"].toString()) : <any>undefined;
            this.norTendered = _data["norTendered"] ? new Date(_data["norTendered"].toString()) : <any>undefined;
            this.norReceived = _data["norReceived"] ? new Date(_data["norReceived"].toString()) : <any>undefined;
            this.opsCommenced = _data["opsCommenced"] ? DateTimeTba.fromJS(_data["opsCommenced"]) : <any>undefined;
            this.opsCompleted = _data["opsCompleted"] ? DateTimeTba.fromJS(_data["opsCompleted"]) : <any>undefined;
            this.loadingIn = _data["loadingIn"];
            this.dischargeIn = _data["dischargeIn"];
            this.imoNumber = _data["imoNumber"];
            this.flag = _data["flag"];
            this.reference = _data["reference"];
            this.stevedoreForeman = _data["stevedoreForeman"];
            this.stevedoreForemanName = _data["stevedoreForemanName"];
            this.stevedoreForemanId = _data["stevedoreForemanId"];
            this.opcAgent = _data["opcAgent"];
            this.opcAgentName = _data["opcAgentName"];
            this.opcAgentId = _data["opcAgentId"];
            this.customerRep = _data["customerRep"];
            this.surveyor = _data["surveyor"];
            this.liftingSupervisor = _data["liftingSupervisor"];
            this.shipper = _data["shipper"] ? PostalAddress.fromJS(_data["shipper"]) : <any>undefined;
            this.consignee = _data["consignee"] ? PostalAddress.fromJS(_data["consignee"]) : <any>undefined;
            this.notifyAddress = _data["notifyAddress"] ? PostalAddress.fromJS(_data["notifyAddress"]) : <any>undefined;
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(Component.fromJS(item));
            }
            if (Array.isArray(_data["gangs"])) {
                this.gangs = [] as any;
                for (let item of _data["gangs"])
                    this.gangs!.push(Gang.fromJS(item));
            }
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(Event.fromJS(item));
            }
            if (Array.isArray(_data["projectCustomers"])) {
                this.projectCustomers = [] as any;
                for (let item of _data["projectCustomers"])
                    this.projectCustomers!.push(ProjectCustomer.fromJS(item));
            }
            this.mailingListId = _data["mailingListId"];
            this.craneType = _data["craneType"];
            this.shoreCraneBooked = _data["shoreCraneBooked"];
            this.projectNumber = _data["projectNumber"];
            this.internalNote = _data["internalNote"];
            this.informantOrderDate = _data["informantOrderDate"] ? DateTimeTba.fromJS(_data["informantOrderDate"]) : <any>undefined;
            this.informantOrderShip = _data["informantOrderShip"];
            this.informantOrderPort = _data["informantOrderPort"];
            this.informantOrderCase = _data["informantOrderCase"];
            this.informantOrderJob = _data["informantOrderJob"];
            this.informantOrderMachine = _data["informantOrderMachine"];
            this.informantOrderMachineJobNumber = _data["informantOrderMachineJobNumber"];
            this.informantOrderReady = _data["informantOrderReady"];
            this.informantOrderNote = _data["informantOrderNote"];
            this.informantOrderReadyDate = _data["informantOrderReadyDate"] ? DateTimeTba.fromJS(_data["informantOrderReadyDate"]) : <any>undefined;
            this.terminalStatementDate = _data["terminalStatementDate"] ? DateTimeTba.fromJS(_data["terminalStatementDate"]) : <any>undefined;
            this.terminalStatementSalery = _data["terminalStatementSalery"];
            this.terminalStatementMultipleMachines = _data["terminalStatementMultipleMachines"];
            this.terminalStatementNote = _data["terminalStatementNote"];
            this.terminalStatementJobNumber = _data["terminalStatementJobNumber"];
            this.importantInformation = _data["importantInformation"];
            this.actualDeparture = _data["actualDeparture"] ? new Date(_data["actualDeparture"].toString()) : <any>undefined;
            this.tugBooked = _data["tugBooked"] ? DateTimeTba.fromJS(_data["tugBooked"]) : <any>undefined;
            this.isTugBooked = _data["isTugBooked"];
            this.pilotBooked = _data["pilotBooked"] ? DateTimeTba.fromJS(_data["pilotBooked"]) : <any>undefined;
            this.isPilotBooked = _data["isPilotBooked"];
            this.isProjectTemplate = _data["isProjectTemplate"];
            this.tenderedType = _data["tenderedType"];
            this.receivedType = _data["receivedType"];
            this.operationsActuallyCommenced = _data["operationsActuallyCommenced"] ? new Date(_data["operationsActuallyCommenced"].toString()) : <any>undefined;
            this.operationsActuallyCompleted = _data["operationsActuallyCompleted"] ? new Date(_data["operationsActuallyCompleted"].toString()) : <any>undefined;
            this.shipWeight = _data["shipWeight"];
            if (Array.isArray(_data["projectTerminalStatements"])) {
                this.projectTerminalStatements = [] as any;
                for (let item of _data["projectTerminalStatements"])
                    this.projectTerminalStatements!.push(ProjectTerminalStatement2.fromJS(item));
            }
            this.usingShorePower = _data["usingShorePower"];
        }
    }

    static fromJS(data: any): GetProjectDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdByName"] = this.createdByName;
        data["createdById"] = this.createdById;
        data["lastChanged"] = this.lastChanged ? this.lastChanged.toISOString() : <any>undefined;
        data["lastChangedByName"] = this.lastChangedByName;
        data["lastChangedById"] = this.lastChangedById;
        data["projectStatus"] = this.projectStatus;
        data["shipName"] = this.shipName;
        data["caseNumber"] = this.caseNumber;
        data["voyageNumber"] = this.voyageNumber;
        data["from"] = this.from;
        data["to"] = this.to;
        data["pilotOnboard"] = this.pilotOnboard;
        data["expectedArrival"] = this.expectedArrival ? this.expectedArrival.toJSON() : <any>undefined;
        data["expectedDeparture"] = this.expectedDeparture ? this.expectedDeparture.toJSON() : <any>undefined;
        data["expectedArrivalNextPort"] = this.expectedArrivalNextPort ? this.expectedArrivalNextPort.toJSON() : <any>undefined;
        data["owners"] = this.owners;
        data["port"] = this.port;
        data["berth"] = this.berth;
        data["cargoDescription"] = this.cargoDescription;
        data["quantity"] = this.quantity;
        data["weight"] = this.weight;
        data["esop"] = this.esop ? this.esop.toISOString() : <any>undefined;
        data["firstLine"] = this.firstLine ? this.firstLine.toISOString() : <any>undefined;
        data["allFast"] = this.allFast ? this.allFast.toISOString() : <any>undefined;
        data["norTendered"] = this.norTendered ? this.norTendered.toISOString() : <any>undefined;
        data["norReceived"] = this.norReceived ? this.norReceived.toISOString() : <any>undefined;
        data["opsCommenced"] = this.opsCommenced ? this.opsCommenced.toJSON() : <any>undefined;
        data["opsCompleted"] = this.opsCompleted ? this.opsCompleted.toJSON() : <any>undefined;
        data["loadingIn"] = this.loadingIn;
        data["dischargeIn"] = this.dischargeIn;
        data["imoNumber"] = this.imoNumber;
        data["flag"] = this.flag;
        data["reference"] = this.reference;
        data["stevedoreForeman"] = this.stevedoreForeman;
        data["stevedoreForemanName"] = this.stevedoreForemanName;
        data["stevedoreForemanId"] = this.stevedoreForemanId;
        data["opcAgent"] = this.opcAgent;
        data["opcAgentName"] = this.opcAgentName;
        data["opcAgentId"] = this.opcAgentId;
        data["customerRep"] = this.customerRep;
        data["surveyor"] = this.surveyor;
        data["liftingSupervisor"] = this.liftingSupervisor;
        data["shipper"] = this.shipper ? this.shipper.toJSON() : <any>undefined;
        data["consignee"] = this.consignee ? this.consignee.toJSON() : <any>undefined;
        data["notifyAddress"] = this.notifyAddress ? this.notifyAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        if (Array.isArray(this.gangs)) {
            data["gangs"] = [];
            for (let item of this.gangs)
                data["gangs"].push(item.toJSON());
        }
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        if (Array.isArray(this.projectCustomers)) {
            data["projectCustomers"] = [];
            for (let item of this.projectCustomers)
                data["projectCustomers"].push(item.toJSON());
        }
        data["mailingListId"] = this.mailingListId;
        data["craneType"] = this.craneType;
        data["shoreCraneBooked"] = this.shoreCraneBooked;
        data["projectNumber"] = this.projectNumber;
        data["internalNote"] = this.internalNote;
        data["informantOrderDate"] = this.informantOrderDate ? this.informantOrderDate.toJSON() : <any>undefined;
        data["informantOrderShip"] = this.informantOrderShip;
        data["informantOrderPort"] = this.informantOrderPort;
        data["informantOrderCase"] = this.informantOrderCase;
        data["informantOrderJob"] = this.informantOrderJob;
        data["informantOrderMachine"] = this.informantOrderMachine;
        data["informantOrderMachineJobNumber"] = this.informantOrderMachineJobNumber;
        data["informantOrderReady"] = this.informantOrderReady;
        data["informantOrderNote"] = this.informantOrderNote;
        data["informantOrderReadyDate"] = this.informantOrderReadyDate ? this.informantOrderReadyDate.toJSON() : <any>undefined;
        data["terminalStatementDate"] = this.terminalStatementDate ? this.terminalStatementDate.toJSON() : <any>undefined;
        data["terminalStatementSalery"] = this.terminalStatementSalery;
        data["terminalStatementMultipleMachines"] = this.terminalStatementMultipleMachines;
        data["terminalStatementNote"] = this.terminalStatementNote;
        data["terminalStatementJobNumber"] = this.terminalStatementJobNumber;
        data["importantInformation"] = this.importantInformation;
        data["actualDeparture"] = this.actualDeparture ? this.actualDeparture.toISOString() : <any>undefined;
        data["tugBooked"] = this.tugBooked ? this.tugBooked.toJSON() : <any>undefined;
        data["isTugBooked"] = this.isTugBooked;
        data["pilotBooked"] = this.pilotBooked ? this.pilotBooked.toJSON() : <any>undefined;
        data["isPilotBooked"] = this.isPilotBooked;
        data["isProjectTemplate"] = this.isProjectTemplate;
        data["tenderedType"] = this.tenderedType;
        data["receivedType"] = this.receivedType;
        data["operationsActuallyCommenced"] = this.operationsActuallyCommenced ? this.operationsActuallyCommenced.toISOString() : <any>undefined;
        data["operationsActuallyCompleted"] = this.operationsActuallyCompleted ? this.operationsActuallyCompleted.toISOString() : <any>undefined;
        data["shipWeight"] = this.shipWeight;
        if (Array.isArray(this.projectTerminalStatements)) {
            data["projectTerminalStatements"] = [];
            for (let item of this.projectTerminalStatements)
                data["projectTerminalStatements"].push(item.toJSON());
        }
        data["usingShorePower"] = this.usingShorePower;
        return data;
    }
}

export interface IGetProjectDetailsResponse {
    id: string;
    name: string;
    created: Date;
    createdByName?: string | undefined;
    createdById?: string | undefined;
    lastChanged: Date;
    lastChangedByName?: string | undefined;
    lastChangedById?: string | undefined;
    projectStatus: ProjectStatus;
    shipName: string;
    caseNumber: string;
    voyageNumber: string;
    from: string;
    to: string;
    pilotOnboard: string;
    expectedArrival: IDateTimeTba;
    expectedDeparture: IDateTimeTba;
    expectedArrivalNextPort?: IDateTimeTba | undefined;
    owners?: string;
    port?: string;
    berth?: string;
    cargoDescription?: string;
    quantity?: number;
    weight?: number;
    esop?: Date | undefined;
    firstLine?: Date | undefined;
    allFast?: Date | undefined;
    norTendered?: Date | undefined;
    norReceived?: Date | undefined;
    opsCommenced?: IDateTimeTba | undefined;
    opsCompleted?: IDateTimeTba | undefined;
    loadingIn?: string;
    dischargeIn?: string;
    imoNumber?: string;
    flag?: string;
    reference?: string;
    stevedoreForeman?: string | undefined;
    stevedoreForemanName?: string | undefined;
    stevedoreForemanId?: string | undefined;
    opcAgent?: string | undefined;
    opcAgentName?: string | undefined;
    opcAgentId?: string | undefined;
    customerRep?: string;
    surveyor?: string;
    liftingSupervisor?: string;
    shipper?: IPostalAddress;
    consignee?: IPostalAddress;
    notifyAddress?: IPostalAddress;
    components: IComponent[];
    gangs: IGang[];
    events: IEvent[];
    projectCustomers: IProjectCustomer[];
    mailingListId?: string | undefined;
    craneType: CraneType;
    shoreCraneBooked?: boolean | undefined;
    projectNumber: number;
    internalNote?: string;
    informantOrderDate?: IDateTimeTba | undefined;
    informantOrderShip?: string;
    informantOrderPort?: string;
    informantOrderCase?: string;
    informantOrderJob?: string;
    informantOrderMachine?: string;
    informantOrderMachineJobNumber?: string;
    informantOrderReady?: string;
    informantOrderNote?: string;
    informantOrderReadyDate?: IDateTimeTba | undefined;
    terminalStatementDate?: IDateTimeTba | undefined;
    terminalStatementSalery?: string;
    terminalStatementMultipleMachines?: string;
    terminalStatementNote?: string;
    terminalStatementJobNumber?: string;
    importantInformation: string;
    actualDeparture?: Date | undefined;
    tugBooked?: IDateTimeTba | undefined;
    isTugBooked?: boolean;
    pilotBooked?: IDateTimeTba | undefined;
    isPilotBooked?: boolean;
    isProjectTemplate?: boolean | undefined;
    tenderedType?: TenderedType;
    receivedType?: ReceivedType;
    /** Called Operation Commenced in UI.  */
    operationsActuallyCommenced?: Date | undefined;
    /** Called Operation Completed in UI. */
    operationsActuallyCompleted?: Date | undefined;
    shipWeight?: number | undefined;
    projectTerminalStatements?: IProjectTerminalStatement2[];
    /** Using Shore Power (True) or Vessel Power (False) */
    usingShorePower?: boolean;
}

export class Component implements IComponent {
    id!: string;
    description!: string;
    serialNumber!: string;
    setNumber!: string;
    weightKg!: number;
    volumeM3!: number;
    batchSize!: number;
    batchLoaded!: number;
    comment!: string;

    constructor(data?: IComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.serialNumber = _data["serialNumber"];
            this.setNumber = _data["setNumber"];
            this.weightKg = _data["weightKg"];
            this.volumeM3 = _data["volumeM3"];
            this.batchSize = _data["batchSize"];
            this.batchLoaded = _data["batchLoaded"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): Component {
        data = typeof data === 'object' ? data : {};
        let result = new Component();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["serialNumber"] = this.serialNumber;
        data["setNumber"] = this.setNumber;
        data["weightKg"] = this.weightKg;
        data["volumeM3"] = this.volumeM3;
        data["batchSize"] = this.batchSize;
        data["batchLoaded"] = this.batchLoaded;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IComponent {
    id: string;
    description: string;
    serialNumber: string;
    setNumber: string;
    weightKg: number;
    volumeM3: number;
    batchSize: number;
    batchLoaded: number;
    comment: string;
}

export class Gang implements IGang {
    id!: string;
    name!: string;
    workStart?: Date | undefined;
    workEnd?: Date | undefined;
    comment!: string;
    gangMembers!: GangMember[];

    constructor(data?: IGang) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.gangMembers) {
                this.gangMembers = [];
                for (let i = 0; i < data.gangMembers.length; i++) {
                    let item = data.gangMembers[i];
                    this.gangMembers[i] = item && !(<any>item).toJSON ? new GangMember(item) : <GangMember>item;
                }
            }
        }
        if (!data) {
            this.gangMembers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.workStart = _data["workStart"] ? new Date(_data["workStart"].toString()) : <any>undefined;
            this.workEnd = _data["workEnd"] ? new Date(_data["workEnd"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            if (Array.isArray(_data["gangMembers"])) {
                this.gangMembers = [] as any;
                for (let item of _data["gangMembers"])
                    this.gangMembers!.push(GangMember.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Gang {
        data = typeof data === 'object' ? data : {};
        let result = new Gang();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["workStart"] = this.workStart ? this.workStart.toISOString() : <any>undefined;
        data["workEnd"] = this.workEnd ? this.workEnd.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        if (Array.isArray(this.gangMembers)) {
            data["gangMembers"] = [];
            for (let item of this.gangMembers)
                data["gangMembers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGang {
    id: string;
    name: string;
    workStart?: Date | undefined;
    workEnd?: Date | undefined;
    comment: string;
    gangMembers: IGangMember[];
}

export class GangMember implements IGangMember {
    gangMemberId?: string;
    workerId!: string;
    workerName!: string;
    workerExternalId?: string;

    constructor(data?: IGangMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gangMemberId = _data["gangMemberId"];
            this.workerId = _data["workerId"];
            this.workerName = _data["workerName"];
            this.workerExternalId = _data["workerExternalId"];
        }
    }

    static fromJS(data: any): GangMember {
        data = typeof data === 'object' ? data : {};
        let result = new GangMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gangMemberId"] = this.gangMemberId;
        data["workerId"] = this.workerId;
        data["workerName"] = this.workerName;
        data["workerExternalId"] = this.workerExternalId;
        return data;
    }
}

export interface IGangMember {
    gangMemberId?: string;
    workerId: string;
    workerName: string;
    workerExternalId?: string;
}

export class Event implements IEvent {
    id!: string;
    name!: string;
    eventTypeId?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    componentId?: string | undefined;
    componentName?: string | undefined;
    numComments!: number;
    batchLoaded?: number | undefined;

    constructor(data?: IEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.eventTypeId = _data["eventTypeId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.componentId = _data["componentId"];
            this.componentName = _data["componentName"];
            this.numComments = _data["numComments"];
            this.batchLoaded = _data["batchLoaded"];
        }
    }

    static fromJS(data: any): Event {
        data = typeof data === 'object' ? data : {};
        let result = new Event();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["eventTypeId"] = this.eventTypeId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["componentId"] = this.componentId;
        data["componentName"] = this.componentName;
        data["numComments"] = this.numComments;
        data["batchLoaded"] = this.batchLoaded;
        return data;
    }
}

export interface IEvent {
    id: string;
    name: string;
    eventTypeId?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    componentId?: string | undefined;
    componentName?: string | undefined;
    numComments: number;
    batchLoaded?: number | undefined;
}

export class ProjectCustomer implements IProjectCustomer {
    customerId?: string;
    name?: string;

    constructor(data?: IProjectCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProjectCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        return data;
    }
}

export interface IProjectCustomer {
    customerId?: string;
    name?: string;
}

export class ProjectTerminalStatement2 implements IProjectTerminalStatement2 {
    id!: string;
    terminalStatementId!: string;
    date!: Date;
    value!: number;
    terminalStatementName?: string | undefined;

    constructor(data?: IProjectTerminalStatement2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.terminalStatementId = _data["terminalStatementId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.terminalStatementName = _data["terminalStatementName"];
        }
    }

    static fromJS(data: any): ProjectTerminalStatement2 {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTerminalStatement2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["terminalStatementId"] = this.terminalStatementId;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["value"] = this.value;
        data["terminalStatementName"] = this.terminalStatementName;
        return data;
    }
}

export interface IProjectTerminalStatement2 {
    id: string;
    terminalStatementId: string;
    date: Date;
    value: number;
    terminalStatementName?: string | undefined;
}

export class GetProjectTemplatesResponse implements IGetProjectTemplatesResponse {
    projectTemplates?: ProjectTemplate[];

    constructor(data?: IGetProjectTemplatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.projectTemplates) {
                this.projectTemplates = [];
                for (let i = 0; i < data.projectTemplates.length; i++) {
                    let item = data.projectTemplates[i];
                    this.projectTemplates[i] = item && !(<any>item).toJSON ? new ProjectTemplate(item) : <ProjectTemplate>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectTemplates"])) {
                this.projectTemplates = [] as any;
                for (let item of _data["projectTemplates"])
                    this.projectTemplates!.push(ProjectTemplate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectTemplatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectTemplatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectTemplates)) {
            data["projectTemplates"] = [];
            for (let item of this.projectTemplates)
                data["projectTemplates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectTemplatesResponse {
    projectTemplates?: IProjectTemplate[];
}

export class ProjectTemplate implements IProjectTemplate {
    id?: string;
    name?: string;

    constructor(data?: IProjectTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProjectTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProjectTemplate {
    id?: string;
    name?: string;
}

export class UpsertProjectOccurenceRequest implements IUpsertProjectOccurenceRequest {
    id!: string;
    projectId!: string;
    typeId!: string;
    severity!: number;
    comment!: string;
    date!: Date;
    members?: ProjectOccurenceMember[] | undefined;

    constructor(data?: IUpsertProjectOccurenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.members) {
                this.members = [];
                for (let i = 0; i < data.members.length; i++) {
                    let item = data.members[i];
                    this.members[i] = item && !(<any>item).toJSON ? new ProjectOccurenceMember(item) : <ProjectOccurenceMember>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.typeId = _data["typeId"];
            this.severity = _data["severity"];
            this.comment = _data["comment"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(ProjectOccurenceMember.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertProjectOccurenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertProjectOccurenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["typeId"] = this.typeId;
        data["severity"] = this.severity;
        data["comment"] = this.comment;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpsertProjectOccurenceRequest {
    id: string;
    projectId: string;
    typeId: string;
    severity: number;
    comment: string;
    date: Date;
    members?: IProjectOccurenceMember[] | undefined;
}

export class ProjectOccurenceMember implements IProjectOccurenceMember {
    id!: string;
    projectOccurenceId!: string;
    workerId!: string;

    constructor(data?: IProjectOccurenceMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectOccurenceId = _data["projectOccurenceId"];
            this.workerId = _data["workerId"];
        }
    }

    static fromJS(data: any): ProjectOccurenceMember {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectOccurenceMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectOccurenceId"] = this.projectOccurenceId;
        data["workerId"] = this.workerId;
        return data;
    }
}

export interface IProjectOccurenceMember {
    id: string;
    projectOccurenceId: string;
    workerId: string;
}

export class ProjectMemberListResponse implements IProjectMemberListResponse {
    projectMembers!: ProjectMember[];

    constructor(data?: IProjectMemberListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.projectMembers) {
                this.projectMembers = [];
                for (let i = 0; i < data.projectMembers.length; i++) {
                    let item = data.projectMembers[i];
                    this.projectMembers[i] = item && !(<any>item).toJSON ? new ProjectMember(item) : <ProjectMember>item;
                }
            }
        }
        if (!data) {
            this.projectMembers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectMembers"])) {
                this.projectMembers = [] as any;
                for (let item of _data["projectMembers"])
                    this.projectMembers!.push(ProjectMember.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectMemberListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMemberListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectMembers)) {
            data["projectMembers"] = [];
            for (let item of this.projectMembers)
                data["projectMembers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectMemberListResponse {
    projectMembers: IProjectMember[];
}

export class ProjectMember implements IProjectMember {
    id!: string;
    name!: string;
    role!: ProjectMemberRole;

    constructor(data?: IProjectMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ProjectMember {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["role"] = this.role;
        return data;
    }
}

export interface IProjectMember {
    id: string;
    name: string;
    role: ProjectMemberRole;
}

export enum ProjectMemberRole {
    NotUsed = "NotUsed",
    StevedoreForeman = "StevedoreForeman",
    OpcAgent = "OpcAgent",
}

export class GetProjectFilesResponse implements IGetProjectFilesResponse {
    projectFiles?: File[];

    constructor(data?: IGetProjectFilesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.projectFiles) {
                this.projectFiles = [];
                for (let i = 0; i < data.projectFiles.length; i++) {
                    let item = data.projectFiles[i];
                    this.projectFiles[i] = item && !(<any>item).toJSON ? new File(item) : <File>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectFiles"])) {
                this.projectFiles = [] as any;
                for (let item of _data["projectFiles"])
                    this.projectFiles!.push(File.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectFilesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectFilesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectFiles)) {
            data["projectFiles"] = [];
            for (let item of this.projectFiles)
                data["projectFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectFilesResponse {
    projectFiles?: IFile[];
}

export class File implements IFile {
    fileId!: string;
    originalFilename!: string;
    mimeType!: string;
    created!: Date;
    name!: string;

    constructor(data?: IFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.originalFilename = _data["originalFilename"];
            this.mimeType = _data["mimeType"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["originalFilename"] = this.originalFilename;
        data["mimeType"] = this.mimeType;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IFile {
    fileId: string;
    originalFilename: string;
    mimeType: string;
    created: Date;
    name: string;
}

export class GetProjectDocumentsResponse implements IGetProjectDocumentsResponse {
    projectDocuments?: DocumentFile[];

    constructor(data?: IGetProjectDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.projectDocuments) {
                this.projectDocuments = [];
                for (let i = 0; i < data.projectDocuments.length; i++) {
                    let item = data.projectDocuments[i];
                    this.projectDocuments[i] = item && !(<any>item).toJSON ? new DocumentFile(item) : <DocumentFile>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectDocuments"])) {
                this.projectDocuments = [] as any;
                for (let item of _data["projectDocuments"])
                    this.projectDocuments!.push(DocumentFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectDocuments)) {
            data["projectDocuments"] = [];
            for (let item of this.projectDocuments)
                data["projectDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectDocumentsResponse {
    projectDocuments?: IDocumentFile[];
}

export class DocumentFile implements IDocumentFile {
    fileId!: string;
    originalFileName!: string;
    mimeType!: string;
    created!: Date;
    name!: string;
    sent?: Date | undefined;
    updated?: Date | undefined;
    isChecked?: boolean;
    isProjectDocumentShared?: boolean;

    constructor(data?: IDocumentFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.originalFileName = _data["originalFileName"];
            this.mimeType = _data["mimeType"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.sent = _data["sent"] ? new Date(_data["sent"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.isChecked = _data["isChecked"];
            this.isProjectDocumentShared = _data["isProjectDocumentShared"];
        }
    }

    static fromJS(data: any): DocumentFile {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["originalFileName"] = this.originalFileName;
        data["mimeType"] = this.mimeType;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["sent"] = this.sent ? this.sent.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["isChecked"] = this.isChecked;
        data["isProjectDocumentShared"] = this.isProjectDocumentShared;
        return data;
    }
}

export interface IDocumentFile {
    fileId: string;
    originalFileName: string;
    mimeType: string;
    created: Date;
    name: string;
    sent?: Date | undefined;
    updated?: Date | undefined;
    isChecked?: boolean;
    isProjectDocumentShared?: boolean;
}

export class GetProjectEventTypesResponse implements IGetProjectEventTypesResponse {
    projectEventTypes!: ProjectEventType[];

    constructor(data?: IGetProjectEventTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.projectEventTypes) {
                this.projectEventTypes = [];
                for (let i = 0; i < data.projectEventTypes.length; i++) {
                    let item = data.projectEventTypes[i];
                    this.projectEventTypes[i] = item && !(<any>item).toJSON ? new ProjectEventType(item) : <ProjectEventType>item;
                }
            }
        }
        if (!data) {
            this.projectEventTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectEventTypes"])) {
                this.projectEventTypes = [] as any;
                for (let item of _data["projectEventTypes"])
                    this.projectEventTypes!.push(ProjectEventType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectEventTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectEventTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectEventTypes)) {
            data["projectEventTypes"] = [];
            for (let item of this.projectEventTypes)
                data["projectEventTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectEventTypesResponse {
    projectEventTypes: IProjectEventType[];
}

export class ProjectEventType implements IProjectEventType {
    id!: string;
    name!: string;

    constructor(data?: IProjectEventType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProjectEventType {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectEventType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProjectEventType {
    id: string;
    name: string;
}

export class SetProjectEventTypesRequest implements ISetProjectEventTypesRequest {
    projectId!: string;
    eventTypeIds!: string[];

    constructor(data?: ISetProjectEventTypesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.eventTypeIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["eventTypeIds"])) {
                this.eventTypeIds = [] as any;
                for (let item of _data["eventTypeIds"])
                    this.eventTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SetProjectEventTypesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetProjectEventTypesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.eventTypeIds)) {
            data["eventTypeIds"] = [];
            for (let item of this.eventTypeIds)
                data["eventTypeIds"].push(item);
        }
        return data;
    }
}

export interface ISetProjectEventTypesRequest {
    projectId: string;
    eventTypeIds: string[];
}

export class UpsertProjectCommentRequest implements IUpsertProjectCommentRequest {
    id!: string;
    projectId!: string;
    eventId?: string | undefined;
    comment!: string;
    timestamp!: Date;
    shouldSendDamageReport?: boolean;

    constructor(data?: IUpsertProjectCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.eventId = _data["eventId"];
            this.comment = _data["comment"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.shouldSendDamageReport = _data["shouldSendDamageReport"];
        }
    }

    static fromJS(data: any): UpsertProjectCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertProjectCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["eventId"] = this.eventId;
        data["comment"] = this.comment;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["shouldSendDamageReport"] = this.shouldSendDamageReport;
        return data;
    }
}

export interface IUpsertProjectCommentRequest {
    id: string;
    projectId: string;
    eventId?: string | undefined;
    comment: string;
    timestamp: Date;
    shouldSendDamageReport?: boolean;
}

export class ProjectCommentFileDto implements IProjectCommentFileDto {
    id?: string;
    originalFilename?: string;
    mimeType?: string;
    created?: Date;

    constructor(data?: IProjectCommentFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalFilename = _data["originalFilename"];
            this.mimeType = _data["mimeType"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectCommentFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCommentFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalFilename"] = this.originalFilename;
        data["mimeType"] = this.mimeType;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProjectCommentFileDto {
    id?: string;
    originalFilename?: string;
    mimeType?: string;
    created?: Date;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class GetProjectCommentsResponse implements IGetProjectCommentsResponse {
    projectComments!: ProjectComment[];

    constructor(data?: IGetProjectCommentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.projectComments) {
                this.projectComments = [];
                for (let i = 0; i < data.projectComments.length; i++) {
                    let item = data.projectComments[i];
                    this.projectComments[i] = item && !(<any>item).toJSON ? new ProjectComment(item) : <ProjectComment>item;
                }
            }
        }
        if (!data) {
            this.projectComments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectComments"])) {
                this.projectComments = [] as any;
                for (let item of _data["projectComments"])
                    this.projectComments!.push(ProjectComment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectCommentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectCommentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectComments)) {
            data["projectComments"] = [];
            for (let item of this.projectComments)
                data["projectComments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectCommentsResponse {
    projectComments: IProjectComment[];
}

export class ProjectComment implements IProjectComment {
    id!: string;
    projectId?: string;
    eventId?: string | undefined;
    comment!: string;
    timestamp!: Date;
    created?: Date;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    lastChanged?: Date;
    lastChangedById?: string | undefined;
    lastChangedByName?: string | undefined;
    attachments!: CommentAttachment[];
    shouldSendDamageReport!: boolean;

    constructor(data?: IProjectComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.attachments) {
                this.attachments = [];
                for (let i = 0; i < data.attachments.length; i++) {
                    let item = data.attachments[i];
                    this.attachments[i] = item && !(<any>item).toJSON ? new CommentAttachment(item) : <CommentAttachment>item;
                }
            }
        }
        if (!data) {
            this.attachments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.eventId = _data["eventId"];
            this.comment = _data["comment"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
            this.lastChanged = _data["lastChanged"] ? new Date(_data["lastChanged"].toString()) : <any>undefined;
            this.lastChangedById = _data["lastChangedById"];
            this.lastChangedByName = _data["lastChangedByName"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommentAttachment.fromJS(item));
            }
            this.shouldSendDamageReport = _data["shouldSendDamageReport"];
        }
    }

    static fromJS(data: any): ProjectComment {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["eventId"] = this.eventId;
        data["comment"] = this.comment;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        data["lastChanged"] = this.lastChanged ? this.lastChanged.toISOString() : <any>undefined;
        data["lastChangedById"] = this.lastChangedById;
        data["lastChangedByName"] = this.lastChangedByName;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["shouldSendDamageReport"] = this.shouldSendDamageReport;
        return data;
    }
}

export interface IProjectComment {
    id: string;
    projectId?: string;
    eventId?: string | undefined;
    comment: string;
    timestamp: Date;
    created?: Date;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    lastChanged?: Date;
    lastChangedById?: string | undefined;
    lastChangedByName?: string | undefined;
    attachments: ICommentAttachment[];
    shouldSendDamageReport: boolean;
}

export class CommentAttachment implements ICommentAttachment {
    fileId!: string;
    originalFilename!: string;
    mimeType!: string;
    created!: Date;
    name!: string;

    constructor(data?: ICommentAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.originalFilename = _data["originalFilename"];
            this.mimeType = _data["mimeType"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CommentAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new CommentAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["originalFilename"] = this.originalFilename;
        data["mimeType"] = this.mimeType;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface ICommentAttachment {
    fileId: string;
    originalFilename: string;
    mimeType: string;
    created: Date;
    name: string;
}

export class UpsertProjectCo2Request implements IUpsertProjectCo2Request {
    portCrane!: number;
    mobileCrane!: number;
    vesselCrane!: number;
    vesselPower!: number;
    shorePower!: number;
    disclaimer?: string;

    constructor(data?: IUpsertProjectCo2Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portCrane = _data["portCrane"];
            this.mobileCrane = _data["mobileCrane"];
            this.vesselCrane = _data["vesselCrane"];
            this.vesselPower = _data["vesselPower"];
            this.shorePower = _data["shorePower"];
            this.disclaimer = _data["disclaimer"];
        }
    }

    static fromJS(data: any): UpsertProjectCo2Request {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertProjectCo2Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portCrane"] = this.portCrane;
        data["mobileCrane"] = this.mobileCrane;
        data["vesselCrane"] = this.vesselCrane;
        data["vesselPower"] = this.vesselPower;
        data["shorePower"] = this.shorePower;
        data["disclaimer"] = this.disclaimer;
        return data;
    }
}

export interface IUpsertProjectCo2Request {
    portCrane: number;
    mobileCrane: number;
    vesselCrane: number;
    vesselPower: number;
    shorePower: number;
    disclaimer?: string;
}

export class ProjectCo2Response implements IProjectCo2Response {
    id!: number;
    portCrane!: number;
    mobileCrane!: number;
    vesselCrane!: number;
    vesselPower!: number;
    shorePower!: number;
    disclaimer?: string;

    constructor(data?: IProjectCo2Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.portCrane = _data["portCrane"];
            this.mobileCrane = _data["mobileCrane"];
            this.vesselCrane = _data["vesselCrane"];
            this.vesselPower = _data["vesselPower"];
            this.shorePower = _data["shorePower"];
            this.disclaimer = _data["disclaimer"];
        }
    }

    static fromJS(data: any): ProjectCo2Response {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCo2Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["portCrane"] = this.portCrane;
        data["mobileCrane"] = this.mobileCrane;
        data["vesselCrane"] = this.vesselCrane;
        data["vesselPower"] = this.vesselPower;
        data["shorePower"] = this.shorePower;
        data["disclaimer"] = this.disclaimer;
        return data;
    }
}

export interface IProjectCo2Response {
    id: number;
    portCrane: number;
    mobileCrane: number;
    vesselCrane: number;
    vesselPower: number;
    shorePower: number;
    disclaimer?: string;
}

export class UpsertOccurenceTypeResponse implements IUpsertOccurenceTypeResponse {

    constructor(data?: IUpsertOccurenceTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpsertOccurenceTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertOccurenceTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpsertOccurenceTypeResponse {
}

export class UpsertOccurenceTypeRequest implements IUpsertOccurenceTypeRequest {
    id?: string;
    name?: string;

    constructor(data?: IUpsertOccurenceTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpsertOccurenceTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertOccurenceTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpsertOccurenceTypeRequest {
    id?: string;
    name?: string;
}

export class GetOccurenceTypeResponse implements IGetOccurenceTypeResponse {
    occurenceTypes!: OccurenceType[];

    constructor(data?: IGetOccurenceTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.occurenceTypes) {
                this.occurenceTypes = [];
                for (let i = 0; i < data.occurenceTypes.length; i++) {
                    let item = data.occurenceTypes[i];
                    this.occurenceTypes[i] = item && !(<any>item).toJSON ? new OccurenceType(item) : <OccurenceType>item;
                }
            }
        }
        if (!data) {
            this.occurenceTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["occurenceTypes"])) {
                this.occurenceTypes = [] as any;
                for (let item of _data["occurenceTypes"])
                    this.occurenceTypes!.push(OccurenceType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOccurenceTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOccurenceTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.occurenceTypes)) {
            data["occurenceTypes"] = [];
            for (let item of this.occurenceTypes)
                data["occurenceTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOccurenceTypeResponse {
    occurenceTypes: IOccurenceType[];
}

export class OccurenceType implements IOccurenceType {
    name!: string;
    id!: string;

    constructor(data?: IOccurenceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OccurenceType {
        data = typeof data === 'object' ? data : {};
        let result = new OccurenceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IOccurenceType {
    name: string;
    id: string;
}

export class GetMailLogResponse implements IGetMailLogResponse {
    mailLogs?: MailLogResponse[];

    constructor(data?: IGetMailLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.mailLogs) {
                this.mailLogs = [];
                for (let i = 0; i < data.mailLogs.length; i++) {
                    let item = data.mailLogs[i];
                    this.mailLogs[i] = item && !(<any>item).toJSON ? new MailLogResponse(item) : <MailLogResponse>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mailLogs"])) {
                this.mailLogs = [] as any;
                for (let item of _data["mailLogs"])
                    this.mailLogs!.push(MailLogResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMailLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMailLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mailLogs)) {
            data["mailLogs"] = [];
            for (let item of this.mailLogs)
                data["mailLogs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMailLogResponse {
    mailLogs?: IMailLogResponse[];
}

export class MailLogResponse implements IMailLogResponse {
    id?: string;
    email?: string;
    mailStatus?: MailStatus;
    mailType?: string;
    projectId?: string;
    created?: Date;

    constructor(data?: IMailLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.mailStatus = _data["mailStatus"];
            this.mailType = _data["mailType"];
            this.projectId = _data["projectId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MailLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["mailStatus"] = this.mailStatus;
        data["mailType"] = this.mailType;
        data["projectId"] = this.projectId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMailLogResponse {
    id?: string;
    email?: string;
    mailStatus?: MailStatus;
    mailType?: string;
    projectId?: string;
    created?: Date;
}

export enum MailStatus {
    NotUsed = "NotUsed",
    NotSent = "NotSent",
    Sent = "Sent",
    Failed = "Failed",
}

export class UpsertMailingListRequest implements IUpsertMailingListRequest {
    mailingListId!: string;
    mailReceivers!: MailReceiver[];

    constructor(data?: IUpsertMailingListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.mailReceivers) {
                this.mailReceivers = [];
                for (let i = 0; i < data.mailReceivers.length; i++) {
                    let item = data.mailReceivers[i];
                    this.mailReceivers[i] = item && !(<any>item).toJSON ? new MailReceiver(item) : <MailReceiver>item;
                }
            }
        }
        if (!data) {
            this.mailReceivers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailingListId = _data["mailingListId"];
            if (Array.isArray(_data["mailReceivers"])) {
                this.mailReceivers = [] as any;
                for (let item of _data["mailReceivers"])
                    this.mailReceivers!.push(MailReceiver.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertMailingListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertMailingListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailingListId"] = this.mailingListId;
        if (Array.isArray(this.mailReceivers)) {
            data["mailReceivers"] = [];
            for (let item of this.mailReceivers)
                data["mailReceivers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpsertMailingListRequest {
    mailingListId: string;
    mailReceivers: IMailReceiver[];
}

export class MailReceiver implements IMailReceiver {
    emailAddress!: string;
    name?: string | undefined;
    isMainActor?: boolean;
    lastChanged?: Date;

    constructor(data?: IMailReceiver) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.isMainActor = _data["isMainActor"];
            this.lastChanged = _data["lastChanged"] ? new Date(_data["lastChanged"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MailReceiver {
        data = typeof data === 'object' ? data : {};
        let result = new MailReceiver();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["isMainActor"] = this.isMainActor;
        data["lastChanged"] = this.lastChanged ? this.lastChanged.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMailReceiver {
    emailAddress: string;
    name?: string | undefined;
    isMainActor?: boolean;
    lastChanged?: Date;
}

export class MailReceiverResponse implements IMailReceiverResponse {
    emailAddress!: string;
    name?: string | undefined;
    isActive?: boolean;
    isMainActor?: boolean;
    lastChanged?: Date;

    constructor(data?: IMailReceiverResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.isMainActor = _data["isMainActor"];
            this.lastChanged = _data["lastChanged"] ? new Date(_data["lastChanged"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MailReceiverResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MailReceiverResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["isMainActor"] = this.isMainActor;
        data["lastChanged"] = this.lastChanged ? this.lastChanged.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMailReceiverResponse {
    emailAddress: string;
    name?: string | undefined;
    isActive?: boolean;
    isMainActor?: boolean;
    lastChanged?: Date;
}

export class GetMailingListResponse implements IGetMailingListResponse {
    mailReceivers!: MailReceiverResponse[];

    constructor(data?: IGetMailingListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.mailReceivers) {
                this.mailReceivers = [];
                for (let i = 0; i < data.mailReceivers.length; i++) {
                    let item = data.mailReceivers[i];
                    this.mailReceivers[i] = item && !(<any>item).toJSON ? new MailReceiverResponse(item) : <MailReceiverResponse>item;
                }
            }
        }
        if (!data) {
            this.mailReceivers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mailReceivers"])) {
                this.mailReceivers = [] as any;
                for (let item of _data["mailReceivers"])
                    this.mailReceivers!.push(MailReceiverResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMailingListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMailingListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mailReceivers)) {
            data["mailReceivers"] = [];
            for (let item of this.mailReceivers)
                data["mailReceivers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMailingListResponse {
    mailReceivers: IMailReceiverResponse[];
}

export class LoginResponse implements ILoginResponse {
    userId!: string;
    username!: string;
    token!: string;
    tokenExpires!: Date;
    userRights!: UserRight[];
    passwordReset!: boolean;
    customerId?: string | undefined;
    resourceId?: string | undefined;

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userRights = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.token = _data["token"];
            this.tokenExpires = _data["tokenExpires"] ? new Date(_data["tokenExpires"].toString()) : <any>undefined;
            if (Array.isArray(_data["userRights"])) {
                this.userRights = [] as any;
                for (let item of _data["userRights"])
                    this.userRights!.push(item);
            }
            this.passwordReset = _data["passwordReset"];
            this.customerId = _data["customerId"];
            this.resourceId = _data["resourceId"];
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["token"] = this.token;
        data["tokenExpires"] = this.tokenExpires ? this.tokenExpires.toISOString() : <any>undefined;
        if (Array.isArray(this.userRights)) {
            data["userRights"] = [];
            for (let item of this.userRights)
                data["userRights"].push(item);
        }
        data["passwordReset"] = this.passwordReset;
        data["customerId"] = this.customerId;
        data["resourceId"] = this.resourceId;
        return data;
    }
}

export interface ILoginResponse {
    userId: string;
    username: string;
    token: string;
    tokenExpires: Date;
    userRights: UserRight[];
    passwordReset: boolean;
    customerId?: string | undefined;
    resourceId?: string | undefined;
}

export enum UserRight {
    EditProject = "EditProject",
    CreateEmployeeGroup = "CreateEmployeeGroup",
    ReadInternalNotes = "ReadInternalNotes",
    ListAllProjects = "ListAllProjects",
    ListCustomerProjects = "ListCustomerProjects",
    ListOwnProjects = "ListOwnProjects",
    ListUsers = "ListUsers",
    EditUser = "EditUser",
    DeleteUser = "DeleteUser",
    ListCustomers = "ListCustomers",
    ListCustomersTerminal = "ListCustomersTerminal",
    EditCustomer = "EditCustomer",
    ListDepartments = "ListDepartments",
    ListAllProjectComments = "ListAllProjectComments",
    ListCustomerProjectComments = "ListCustomerProjectComments",
    ListOwnProjectComments = "ListOwnProjectComments",
    ListAllWorkers = "ListAllWorkers",
    EditWorkers = "EditWorkers",
    EditProjectGangs = "EditProjectGangs",
    EditProjectEvents = "EditProjectEvents",
    EditProjectComments = "EditProjectComments",
    ListProjectTemplates = "ListProjectTemplates",
    GetProjectReportsForCustomerProjects = "GetProjectReportsForCustomerProjects",
    GetProjectReportsForAllProjects = "GetProjectReportsForAllProjects",
    GetProjectReportsForOwnProjects = "GetProjectReportsForOwnProjects",
    CreateEventType = "CreateEventType",
    UploadProjectFilesOnAnyProject = "UploadProjectFilesOnAnyProject",
    DownloadProjectFilesOnAnyProject = "DownloadProjectFilesOnAnyProject",
    DownloadProjectFilesOnCustomerProject = "DownloadProjectFilesOnCustomerProject",
    DownloadProjectFilesOnOwnProject = "DownloadProjectFilesOnOwnProject",
    CreateComponentNames = "CreateComponentNames",
    GetComponentNameSuggestions = "GetComponentNameSuggestions",
    DeleteAnyProject = "DeleteAnyProject",
    DeleteEventType = "DeleteEventType",
    EditProjectManager = "EditProjectManager",
    DeleteComponentName = "DeleteComponentName",
    CreateLinkForAnyProject = "CreateLinkForAnyProject",
    CreateLinkForCustomerProject = "CreateLinkForCustomerProject",
    GetMailingList = "GetMailingList",
    EditMailingList = "EditMailingList",
    WatchWebManagerVideos = "WatchWebManagerVideos",
    WatchTabletVideos = "WatchTabletVideos",
    WatchCustomerVideos = "WatchCustomerVideos",
    WatchVideoType4 = "WatchVideoType4",
    DeleteProjectFilesOnAnyProject = "DeleteProjectFilesOnAnyProject",
    ListStevedoreForemen = "ListStevedoreForemen",
    EditStevedoreForemen = "EditStevedoreForemen",
    ListProjectMembers = "ListProjectMembers",
    EditProjectMembers = "EditProjectMembers",
    EditUserAdmin = "EditUserAdmin",
    ViewFrontPage = "ViewFrontPage",
    ViewTerminalPage = "ViewTerminalPage",
    ViewSustainability = "ViewSustainability",
    ViewStorage = "ViewStorage",
    ViewUserAdmin = "ViewUserAdmin",
    ViewShippingOperations = "ViewShippingOperations",
    ViewTerminalDashboardPage = "ViewTerminalDashboardPage",
    ViewTerminalVehiclesPage = "ViewTerminalVehiclesPage",
    ViewTerminalStoragePage = "ViewTerminalStoragePage",
    RestoreUser = "RestoreUser",
    EditSustainability = "EditSustainability",
    ViewStorageGlobal = "ViewStorageGlobal",
    CreateOccurenceType = "CreateOccurenceType",
    DeleteOccurenceType = "DeleteOccurenceType",
    ListOccurenceTypes = "ListOccurenceTypes",
    EditOccurenceType = "EditOccurenceType",
    CreateProjectOccurence = "CreateProjectOccurence",
    TerminalJobCreate = "TerminalJobCreate",
    TerminalJobView = "TerminalJobView",
    TerminalJobEdit = "TerminalJobEdit",
    TerminalTaskCreate = "TerminalTaskCreate",
    TerminalTaskEdit = "TerminalTaskEdit",
    TerminalTaskView = "TerminalTaskView",
    TerminalTaskSetActive = "TerminalTaskSetActive",
    TerminalTaskSetCompleted = "TerminalTaskSetCompleted",
    TerminalTaskSetDeclined = "TerminalTaskSetDeclined",
    TerminalTaskDelete = "TerminalTaskDelete",
    TerminalTaskDownloadFile = "TerminalTaskDownloadFile",
    TerminalTaskUploadFile = "TerminalTaskUploadFile",
    TerminalTaskDeleteFile = "TerminalTaskDeleteFile",
    TerminalOperationCreate = "TerminalOperationCreate",
    TerminalOperationEdit = "TerminalOperationEdit",
    TerminalOperationEditActive = "TerminalOperationEditActive",
    TerminalOperationEditCompleted = "TerminalOperationEditCompleted",
    TerminalOperationEditPending = "TerminalOperationEditPending",
    TerminalOperationView = "TerminalOperationView",
    TerminalOperationDelete = "TerminalOperationDelete",
    TerminalOperationUndelete = "TerminalOperationUndelete",
    TerminalOperationDeleteActive = "TerminalOperationDeleteActive",
    TerminalOperationDeletePending = "TerminalOperationDeletePending",
    TerminalOperationDeleteDeclined = "TerminalOperationDeleteDeclined",
    TerminalOperationRequest = "TerminalOperationRequest",
    TerminalOperationAccept = "TerminalOperationAccept",
    TerminalOnlyOperationAccept = "TerminalOnlyOperationAccept",
    TerminalOperationDecline = "TerminalOperationDecline",
    TerminalOperationPostpone = "TerminalOperationPostpone",
    TerminalOperationComplete = "TerminalOperationComplete",
    TerminalOperationReactivate = "TerminalOperationReactivate",
    TerminalOperationMarkAsInformed = "TerminalOperationMarkAsInformed",
    TerminalOperationCopyActive = "TerminalOperationCopyActive",
    TerminalOperationCopyCompleted = "TerminalOperationCopyCompleted",
    TerminalOperationCopyPending = "TerminalOperationCopyPending",
    TerminalOperationCopyDeleted = "TerminalOperationCopyDeleted",
    TerminalOperationCopyDeclined = "TerminalOperationCopyDeclined",
    TerminalOperationUploadFile = "TerminalOperationUploadFile",
    TerminalOperationDeleteFile = "TerminalOperationDeleteFile",
    TerminalOperationDownloadFile = "TerminalOperationDownloadFile",
    TerminalOperationAssignTheVehiclesActive = "TerminalOperationAssignTheVehiclesActive",
    TerminalOperationAssignTheVehiclesCompleted = "TerminalOperationAssignTheVehiclesCompleted",
    TerminalOperationAssignTheVehiclesPending = "TerminalOperationAssignTheVehiclesPending",
    TerminalOperationRemoveTheVehiclesActive = "TerminalOperationRemoveTheVehiclesActive",
    TerminalOperationRemoveTheVehiclesCompleted = "TerminalOperationRemoveTheVehiclesCompleted",
    TerminalOperationRemoveTheVehiclesPending = "TerminalOperationRemoveTheVehiclesPending",
    TerminalOperationAttachExtraFilesActive = "TerminalOperationAttachExtraFilesActive",
    TerminalOperationAttachExtraFilesCompleted = "TerminalOperationAttachExtraFilesCompleted",
    TerminalOperationAttachExtraFilesPending = "TerminalOperationAttachExtraFilesPending",
    TerminalOperationDetachExtraFilesActive = "TerminalOperationDetachExtraFilesActive",
    TerminalOperationDetachExtraFilesCompleted = "TerminalOperationDetachExtraFilesCompleted",
    TerminalOperationDetachExtraFilesPending = "TerminalOperationDetachExtraFilesPending",
    TerminalOperationCommentEdit = "TerminalOperationCommentEdit",
    ListOperationsActive = "ListOperationsActive",
    ListOperationsPending = "ListOperationsPending",
    ListOperationsCompleted = "ListOperationsCompleted",
    ListOperationsDeleted = "ListOperationsDeleted",
    ListOperationsDeclined = "ListOperationsDeclined",
    ListOperationsForAllInvolvedPersons = "ListOperationsForAllInvolvedPersons",
    TerminalAddDashboardEveryDayNotes = "TerminalAddDashboardEveryDayNotes",
    TerminalViewManpowerUtilization = "TerminalViewManpowerUtilization",
    TerminalViewVehicleUtilization = "TerminalViewVehicleUtilization",
    TerminalLocationView = "TerminalLocationView",
    TerminalSupervisor = "TerminalSupervisor",
    TerminalOperationReject = "TerminalOperationReject",
}

export class LoginRequest implements ILoginRequest {
    username!: string;
    password!: string;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginRequest {
    username: string;
    password: string;
}

export class LinkLoginResponse implements ILinkLoginResponse {
    token!: string;
    tokenExpires!: Date;
    userRights!: UserRight[];
    projectId!: string;

    constructor(data?: ILinkLoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userRights = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenExpires = _data["tokenExpires"] ? new Date(_data["tokenExpires"].toString()) : <any>undefined;
            if (Array.isArray(_data["userRights"])) {
                this.userRights = [] as any;
                for (let item of _data["userRights"])
                    this.userRights!.push(item);
            }
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): LinkLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenExpires"] = this.tokenExpires ? this.tokenExpires.toISOString() : <any>undefined;
        if (Array.isArray(this.userRights)) {
            data["userRights"] = [];
            for (let item of this.userRights)
                data["userRights"].push(item);
        }
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ILinkLoginResponse {
    token: string;
    tokenExpires: Date;
    userRights: UserRight[];
    projectId: string;
}

export class PasswordResetResponse implements IPasswordResetResponse {
    success?: boolean;

    constructor(data?: IPasswordResetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): PasswordResetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IPasswordResetResponse {
    success?: boolean;
}

export class PasswordResetRequest implements IPasswordResetRequest {
    username!: string;

    constructor(data?: IPasswordResetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): PasswordResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IPasswordResetRequest {
    username: string;
}

export class UpsertGangRequest implements IUpsertGangRequest {
    id!: string;
    projectId!: string;
    name!: string;
    workerIds!: string[];
    workStart?: Date | undefined;
    workEnd?: Date | undefined;
    comment!: string;

    constructor(data?: IUpsertGangRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.workerIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            if (Array.isArray(_data["workerIds"])) {
                this.workerIds = [] as any;
                for (let item of _data["workerIds"])
                    this.workerIds!.push(item);
            }
            this.workStart = _data["workStart"] ? new Date(_data["workStart"].toString()) : <any>undefined;
            this.workEnd = _data["workEnd"] ? new Date(_data["workEnd"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpsertGangRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertGangRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        if (Array.isArray(this.workerIds)) {
            data["workerIds"] = [];
            for (let item of this.workerIds)
                data["workerIds"].push(item);
        }
        data["workStart"] = this.workStart ? this.workStart.toISOString() : <any>undefined;
        data["workEnd"] = this.workEnd ? this.workEnd.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpsertGangRequest {
    id: string;
    projectId: string;
    name: string;
    workerIds: string[];
    workStart?: Date | undefined;
    workEnd?: Date | undefined;
    comment: string;
}

export class UpsertEventResponse implements IUpsertEventResponse {
    alreadyExisting?: boolean;

    constructor(data?: IUpsertEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alreadyExisting = _data["alreadyExisting"];
        }
    }

    static fromJS(data: any): UpsertEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alreadyExisting"] = this.alreadyExisting;
        return data;
    }
}

export interface IUpsertEventResponse {
    alreadyExisting?: boolean;
}

export class UpsertEventRequest implements IUpsertEventRequest {
    eventId?: string | undefined;
    projectId!: string;
    eventTypeId!: string;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    componentId?: string | undefined;
    batchLoaded?: number | undefined;

    constructor(data?: IUpsertEventRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.projectId = _data["projectId"];
            this.eventTypeId = _data["eventTypeId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.componentId = _data["componentId"];
            this.batchLoaded = _data["batchLoaded"];
        }
    }

    static fromJS(data: any): UpsertEventRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertEventRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["projectId"] = this.projectId;
        data["eventTypeId"] = this.eventTypeId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["componentId"] = this.componentId;
        data["batchLoaded"] = this.batchLoaded;
        return data;
    }
}

export interface IUpsertEventRequest {
    eventId?: string | undefined;
    projectId: string;
    eventTypeId: string;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    componentId?: string | undefined;
    batchLoaded?: number | undefined;
}

export class UpsertEventTypeResponse implements IUpsertEventTypeResponse {

    constructor(data?: IUpsertEventTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpsertEventTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertEventTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpsertEventTypeResponse {
}

export class UpsertEventTypeRequest implements IUpsertEventTypeRequest {
    id!: string;
    name!: string;

    constructor(data?: IUpsertEventTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpsertEventTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertEventTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpsertEventTypeRequest {
    id: string;
    name: string;
}

export class GetEventTypesResponse implements IGetEventTypesResponse {
    eventTypes!: EventType[];

    constructor(data?: IGetEventTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.eventTypes) {
                this.eventTypes = [];
                for (let i = 0; i < data.eventTypes.length; i++) {
                    let item = data.eventTypes[i];
                    this.eventTypes[i] = item && !(<any>item).toJSON ? new EventType(item) : <EventType>item;
                }
            }
        }
        if (!data) {
            this.eventTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["eventTypes"])) {
                this.eventTypes = [] as any;
                for (let item of _data["eventTypes"])
                    this.eventTypes!.push(EventType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEventTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.eventTypes)) {
            data["eventTypes"] = [];
            for (let item of this.eventTypes)
                data["eventTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEventTypesResponse {
    eventTypes: IEventType[];
}

export class EventType implements IEventType {
    id!: string;
    name!: string;

    constructor(data?: IEventType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EventType {
        data = typeof data === 'object' ? data : {};
        let result = new EventType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEventType {
    id: string;
    name: string;
}

export class UpsertESGResponse implements IUpsertESGResponse {
    alreadyExisting?: boolean;

    constructor(data?: IUpsertESGResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alreadyExisting = _data["alreadyExisting"];
        }
    }

    static fromJS(data: any): UpsertESGResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertESGResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alreadyExisting"] = this.alreadyExisting;
        return data;
    }
}

export interface IUpsertESGResponse {
    alreadyExisting?: boolean;
}

export class UpsertESGRequest implements IUpsertESGRequest {
    id?: string | undefined;
    year!: number;
    scopeList?: ESGScope[];

    constructor(data?: IUpsertESGRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.scopeList) {
                this.scopeList = [];
                for (let i = 0; i < data.scopeList.length; i++) {
                    let item = data.scopeList[i];
                    this.scopeList[i] = item && !(<any>item).toJSON ? new ESGScope(item) : <ESGScope>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            if (Array.isArray(_data["scopeList"])) {
                this.scopeList = [] as any;
                for (let item of _data["scopeList"])
                    this.scopeList!.push(ESGScope.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertESGRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertESGRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        if (Array.isArray(this.scopeList)) {
            data["scopeList"] = [];
            for (let item of this.scopeList)
                data["scopeList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpsertESGRequest {
    id?: string | undefined;
    year: number;
    scopeList?: IESGScope[];
}

export class ESGScope implements IESGScope {
    number?: number;
    scopeDataList?: ESGScopeData[];
    id?: string;

    constructor(data?: IESGScope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.scopeDataList) {
                this.scopeDataList = [];
                for (let i = 0; i < data.scopeDataList.length; i++) {
                    let item = data.scopeDataList[i];
                    this.scopeDataList[i] = item && !(<any>item).toJSON ? new ESGScopeData(item) : <ESGScopeData>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            if (Array.isArray(_data["scopeDataList"])) {
                this.scopeDataList = [] as any;
                for (let item of _data["scopeDataList"])
                    this.scopeDataList!.push(ESGScopeData.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ESGScope {
        data = typeof data === 'object' ? data : {};
        let result = new ESGScope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        if (Array.isArray(this.scopeDataList)) {
            data["scopeDataList"] = [];
            for (let item of this.scopeDataList)
                data["scopeDataList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IESGScope {
    number?: number;
    scopeDataList?: IESGScopeData[];
    id?: string;
}

export class ESGScopeData implements IESGScopeData {
    esgScopeDataType!: ESGScopeDataType;
    value!: number;
    id!: string;

    constructor(data?: IESGScopeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.esgScopeDataType = _data["esgScopeDataType"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ESGScopeData {
        data = typeof data === 'object' ? data : {};
        let result = new ESGScopeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["esgScopeDataType"] = this.esgScopeDataType;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IESGScopeData {
    esgScopeDataType: ESGScopeDataType;
    value: number;
    id: string;
}

export enum ESGScopeDataType {
    EnergyProcesses = "EnergyProcesses",
    Procurement = "Procurement",
    Transport = "Transport",
    WasteRecycling = "WasteRecycling",
    SoldProducts = "SoldProducts",
}

export class GetESGListResponse implements IGetESGListResponse {
    esgList?: ESG[];
    page?: number;
    pageTotal?: number;

    constructor(data?: IGetESGListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.esgList) {
                this.esgList = [];
                for (let i = 0; i < data.esgList.length; i++) {
                    let item = data.esgList[i];
                    this.esgList[i] = item && !(<any>item).toJSON ? new ESG(item) : <ESG>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["esgList"])) {
                this.esgList = [] as any;
                for (let item of _data["esgList"])
                    this.esgList!.push(ESG.fromJS(item));
            }
            this.page = _data["page"];
            this.pageTotal = _data["pageTotal"];
        }
    }

    static fromJS(data: any): GetESGListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetESGListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.esgList)) {
            data["esgList"] = [];
            for (let item of this.esgList)
                data["esgList"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageTotal"] = this.pageTotal;
        return data;
    }
}

export interface IGetESGListResponse {
    esgList?: IESG[];
    page?: number;
    pageTotal?: number;
}

export class ESG implements IESG {
    id!: string;
    year!: number;
    scopeList?: ESGScope[];

    constructor(data?: IESG) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.scopeList) {
                this.scopeList = [];
                for (let i = 0; i < data.scopeList.length; i++) {
                    let item = data.scopeList[i];
                    this.scopeList[i] = item && !(<any>item).toJSON ? new ESGScope(item) : <ESGScope>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            if (Array.isArray(_data["scopeList"])) {
                this.scopeList = [] as any;
                for (let item of _data["scopeList"])
                    this.scopeList!.push(ESGScope.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ESG {
        data = typeof data === 'object' ? data : {};
        let result = new ESG();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        if (Array.isArray(this.scopeList)) {
            data["scopeList"] = [];
            for (let item of this.scopeList)
                data["scopeList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IESG {
    id: string;
    year: number;
    scopeList?: IESGScope[];
}

export class GetESGListRequest implements IGetESGListRequest {
    page?: number;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;

    constructor(data?: IGetESGListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): GetESGListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetESGListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface IGetESGListRequest {
    page?: number;
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
}

export class GetESGResponse implements IGetESGResponse {
    id!: string;
    year!: number;
    scopeList?: ESGScope[];

    constructor(data?: IGetESGResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.scopeList) {
                this.scopeList = [];
                for (let i = 0; i < data.scopeList.length; i++) {
                    let item = data.scopeList[i];
                    this.scopeList[i] = item && !(<any>item).toJSON ? new ESGScope(item) : <ESGScope>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            if (Array.isArray(_data["scopeList"])) {
                this.scopeList = [] as any;
                for (let item of _data["scopeList"])
                    this.scopeList!.push(ESGScope.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetESGResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetESGResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        if (Array.isArray(this.scopeList)) {
            data["scopeList"] = [];
            for (let item of this.scopeList)
                data["scopeList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetESGResponse {
    id: string;
    year: number;
    scopeList?: IESGScope[];
}

export class GetESGMatrixResponse implements IGetESGMatrixResponse {
    scopes?: ESGMatrixScope[];

    constructor(data?: IGetESGMatrixResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.scopes) {
                this.scopes = [];
                for (let i = 0; i < data.scopes.length; i++) {
                    let item = data.scopes[i];
                    this.scopes[i] = item && !(<any>item).toJSON ? new ESGMatrixScope(item) : <ESGMatrixScope>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(ESGMatrixScope.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetESGMatrixResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetESGMatrixResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetESGMatrixResponse {
    scopes?: IESGMatrixScope[];
}

export class ESGMatrixScope implements IESGMatrixScope {
    number?: number;
    scopeData?: ESGMatrixScopeData[];

    constructor(data?: IESGMatrixScope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.scopeData) {
                this.scopeData = [];
                for (let i = 0; i < data.scopeData.length; i++) {
                    let item = data.scopeData[i];
                    this.scopeData[i] = item && !(<any>item).toJSON ? new ESGMatrixScopeData(item) : <ESGMatrixScopeData>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            if (Array.isArray(_data["scopeData"])) {
                this.scopeData = [] as any;
                for (let item of _data["scopeData"])
                    this.scopeData!.push(ESGMatrixScopeData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ESGMatrixScope {
        data = typeof data === 'object' ? data : {};
        let result = new ESGMatrixScope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        if (Array.isArray(this.scopeData)) {
            data["scopeData"] = [];
            for (let item of this.scopeData)
                data["scopeData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IESGMatrixScope {
    number?: number;
    scopeData?: IESGMatrixScopeData[];
}

export class ESGMatrixScopeData implements IESGMatrixScopeData {
    year?: number;
    scopeDataValues?: ESGMatrixScopeDataValue[];
    total?: number;

    constructor(data?: IESGMatrixScopeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.scopeDataValues) {
                this.scopeDataValues = [];
                for (let i = 0; i < data.scopeDataValues.length; i++) {
                    let item = data.scopeDataValues[i];
                    this.scopeDataValues[i] = item && !(<any>item).toJSON ? new ESGMatrixScopeDataValue(item) : <ESGMatrixScopeDataValue>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            if (Array.isArray(_data["scopeDataValues"])) {
                this.scopeDataValues = [] as any;
                for (let item of _data["scopeDataValues"])
                    this.scopeDataValues!.push(ESGMatrixScopeDataValue.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ESGMatrixScopeData {
        data = typeof data === 'object' ? data : {};
        let result = new ESGMatrixScopeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        if (Array.isArray(this.scopeDataValues)) {
            data["scopeDataValues"] = [];
            for (let item of this.scopeDataValues)
                data["scopeDataValues"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IESGMatrixScopeData {
    year?: number;
    scopeDataValues?: IESGMatrixScopeDataValue[];
    total?: number;
}

export class ESGMatrixScopeDataValue implements IESGMatrixScopeDataValue {
    esgScopeDataType?: ESGScopeDataType;
    value?: number;

    constructor(data?: IESGMatrixScopeDataValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.esgScopeDataType = _data["esgScopeDataType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ESGMatrixScopeDataValue {
        data = typeof data === 'object' ? data : {};
        let result = new ESGMatrixScopeDataValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["esgScopeDataType"] = this.esgScopeDataType;
        data["value"] = this.value;
        return data;
    }
}

export interface IESGMatrixScopeDataValue {
    esgScopeDataType?: ESGScopeDataType;
    value?: number;
}

export class GetESGChartResponse implements IGetESGChartResponse {
    datasets?: ESGChartDataset[];

    constructor(data?: IGetESGChartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.datasets) {
                this.datasets = [];
                for (let i = 0; i < data.datasets.length; i++) {
                    let item = data.datasets[i];
                    this.datasets[i] = item && !(<any>item).toJSON ? new ESGChartDataset(item) : <ESGChartDataset>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datasets"])) {
                this.datasets = [] as any;
                for (let item of _data["datasets"])
                    this.datasets!.push(ESGChartDataset.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetESGChartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetESGChartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datasets)) {
            data["datasets"] = [];
            for (let item of this.datasets)
                data["datasets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetESGChartResponse {
    datasets?: IESGChartDataset[];
}

export class ESGChartDataset implements IESGChartDataset {
    label?: string;
    data?: number[];
    backgroundColor?: string;

    constructor(data?: IESGChartDataset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            this.backgroundColor = _data["backgroundColor"];
        }
    }

    static fromJS(data: any): ESGChartDataset {
        data = typeof data === 'object' ? data : {};
        let result = new ESGChartDataset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["backgroundColor"] = this.backgroundColor;
        return data;
    }
}

export interface IESGChartDataset {
    label?: string;
    data?: number[];
    backgroundColor?: string;
}

export class GetDepartmentListResponse implements IGetDepartmentListResponse {
    departments!: Department[];

    constructor(data?: IGetDepartmentListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.departments) {
                this.departments = [];
                for (let i = 0; i < data.departments.length; i++) {
                    let item = data.departments[i];
                    this.departments[i] = item && !(<any>item).toJSON ? new Department(item) : <Department>item;
                }
            }
        }
        if (!data) {
            this.departments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDepartmentListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepartmentListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDepartmentListResponse {
    departments: IDepartment[];
}

export class CreateDepartmentResponse implements ICreateDepartmentResponse {
    department!: Department;

    constructor(data?: ICreateDepartmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.department = data.department && !(<any>data.department).toJSON ? new Department(data.department) : <Department>this.department;
        }
        if (!data) {
            this.department = new Department();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : new Department();
        }
    }

    static fromJS(data: any): CreateDepartmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDepartmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateDepartmentResponse {
    department: IDepartment;
}

export class CreateDepartmentRequest implements ICreateDepartmentRequest {
    name!: string;

    constructor(data?: ICreateDepartmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateDepartmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDepartmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateDepartmentRequest {
    name: string;
}

export class GetCustomerListResponse implements IGetCustomerListResponse {
    customers!: Customer[];

    constructor(data?: IGetCustomerListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.customers) {
                this.customers = [];
                for (let i = 0; i < data.customers.length; i++) {
                    let item = data.customers[i];
                    this.customers[i] = item && !(<any>item).toJSON ? new Customer(item) : <Customer>item;
                }
            }
        }
        if (!data) {
            this.customers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(Customer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomerListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCustomerListResponse {
    customers: ICustomer[];
}

export class Customer implements ICustomer {
    id!: string;
    name!: string;
    externalId!: string;
    address!: string;
    postalCode!: string;
    city!: string;
    country!: string;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        return data;
    }
}

export interface ICustomer {
    id: string;
    name: string;
    externalId: string;
    address: string;
    postalCode: string;
    city: string;
    country: string;
}

export class GetCustomerResponse implements IGetCustomerResponse {
    customer?: Customer | undefined;

    constructor(data?: IGetCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.customer = data.customer && !(<any>data.customer).toJSON ? new Customer(data.customer) : <Customer>this.customer;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCustomerResponse {
    customer?: ICustomer | undefined;
}

export class UpsertCustomerResponse implements IUpsertCustomerResponse {
    alreadyExisting?: boolean;

    constructor(data?: IUpsertCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alreadyExisting = _data["alreadyExisting"];
        }
    }

    static fromJS(data: any): UpsertCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alreadyExisting"] = this.alreadyExisting;
        return data;
    }
}

export interface IUpsertCustomerResponse {
    alreadyExisting?: boolean;
}

export class UpsertCustomerRequest implements IUpsertCustomerRequest {
    id!: string;
    name!: string;

    constructor(data?: IUpsertCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpsertCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpsertCustomerRequest {
    id: string;
    name: string;
}

export class DeleteCustomerResponse implements IDeleteCustomerResponse {
    existed?: boolean;

    constructor(data?: IDeleteCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.existed = _data["existed"];
        }
    }

    static fromJS(data: any): DeleteCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["existed"] = this.existed;
        return data;
    }
}

export interface IDeleteCustomerResponse {
    existed?: boolean;
}

export class DeleteCustomerRequest implements IDeleteCustomerRequest {
    customerId?: string;

    constructor(data?: IDeleteCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): DeleteCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IDeleteCustomerRequest {
    customerId?: string;
}

export class UpsertComponentResponse implements IUpsertComponentResponse {
    alreadyExisting?: boolean;

    constructor(data?: IUpsertComponentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alreadyExisting = _data["alreadyExisting"];
        }
    }

    static fromJS(data: any): UpsertComponentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertComponentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alreadyExisting"] = this.alreadyExisting;
        return data;
    }
}

export interface IUpsertComponentResponse {
    alreadyExisting?: boolean;
}

export class UpsertComponentRequest implements IUpsertComponentRequest {
    componentId!: string;
    projectId!: string;
    description!: string;
    serialNumber!: string;
    setNumber!: string;
    weightKg!: number;
    volumeM3!: number;
    batchSize!: number;
    comment!: string;

    constructor(data?: IUpsertComponentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.projectId = _data["projectId"];
            this.description = _data["description"];
            this.serialNumber = _data["serialNumber"];
            this.setNumber = _data["setNumber"];
            this.weightKg = _data["weightKg"];
            this.volumeM3 = _data["volumeM3"];
            this.batchSize = _data["batchSize"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpsertComponentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertComponentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["projectId"] = this.projectId;
        data["description"] = this.description;
        data["serialNumber"] = this.serialNumber;
        data["setNumber"] = this.setNumber;
        data["weightKg"] = this.weightKg;
        data["volumeM3"] = this.volumeM3;
        data["batchSize"] = this.batchSize;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpsertComponentRequest {
    componentId: string;
    projectId: string;
    description: string;
    serialNumber: string;
    setNumber: string;
    weightKg: number;
    volumeM3: number;
    batchSize: number;
    comment: string;
}

export class UpsertComponentLoadRequest implements IUpsertComponentLoadRequest {
    componentId!: string;
    batchLoaded!: number;

    constructor(data?: IUpsertComponentLoadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.batchLoaded = _data["batchLoaded"];
        }
    }

    static fromJS(data: any): UpsertComponentLoadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertComponentLoadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["batchLoaded"] = this.batchLoaded;
        return data;
    }
}

export interface IUpsertComponentLoadRequest {
    componentId: string;
    batchLoaded: number;
}

export class NameSuggestionResponse implements INameSuggestionResponse {
    suggestions!: Suggestion[];

    constructor(data?: INameSuggestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.suggestions) {
                this.suggestions = [];
                for (let i = 0; i < data.suggestions.length; i++) {
                    let item = data.suggestions[i];
                    this.suggestions[i] = item && !(<any>item).toJSON ? new Suggestion(item) : <Suggestion>item;
                }
            }
        }
        if (!data) {
            this.suggestions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions!.push(Suggestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NameSuggestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NameSuggestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface INameSuggestionResponse {
    suggestions: ISuggestion[];
}

export class Suggestion implements ISuggestion {
    name!: string;

    constructor(data?: ISuggestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Suggestion {
        data = typeof data === 'object' ? data : {};
        let result = new Suggestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISuggestion {
    name: string;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}